/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { supabase } from './supabaseClient';
import { Building2, Calendar, DollarSign, CheckCircle, Clock, Plus, User, BarChart3, TrendingUp, AlertCircle, Mail, Lock, LogOut } from 'lucide-react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Legend, ReferenceLine } from 'recharts';

// Logo CONSTRUACT - imagem original
const LOGO_B64 = "data:image/png;base64,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";
const LogoNOA = ({ className = "w-56 h-20" }) => (
  <img src={LOGO_B64} alt="CONSTRUACT" className={className} style={{objectFit: 'contain'}} />
);


// ═══════════════════════════════════════════════════════════════════════
//  i18n — ConstruAct (PT-BR  ⟷  EN-US)
//  Language detection: ?lang=en  |  hostname *.construact.com
// ═══════════════════════════════════════════════════════════════════════
const detectLang = () => {
  if (typeof window === 'undefined') return 'pt';
  const params = new URLSearchParams(window.location.search);
  if (params.get('lang') === 'en') return 'en';
  if (params.get('lang') === 'pt') return 'pt';
  const host = window.location.hostname;
  if (host.endsWith('.com') && !host.endsWith('.com.br')) return 'en';
  return 'pt';
};

const LANG = detectLang();

const TR = {
  pt: {
    // ── App name ──
    appName: 'Gestão de Obras',
    appTagline: 'Sistema completo para gestão e acompanhamento de obras',
    // ── Roles ──
    contractor: 'Prestador',
    contractorDesc: 'Gerencie todas as suas obras em um só lugar',
    client: 'Cliente',
    clientDesc: 'Acompanhe o andamento da sua obra',
    // ── Auth ──
    loginContractor: 'Login Prestador',
    loginContractorSub: 'Acesse o painel administrativo',
    loginClient: 'Login Cliente',
    loginClientSub: 'Acesse sua obra com o email cadastrado',
    email: 'Email',
    emailPlaceholder: 'seu@email.com',
    emailRegistered: 'Email cadastrado',
    password: 'Senha',
    enter: 'Entrar',
    accessMyProject: 'Acessar minha obra',
    back: '← Voltar',
    loginHint: '💡 Dica: Utilize o email informado pelo seu prestador de serviços.',
    loginError: 'Email ou senha incorretos.',
    emailNotFound: 'Email não encontrado. Verifique com seu prestador de serviços.',
    // ── Dashboard ──
    contractorPanel: 'Painel do Prestador',
    totalProjects: 'Total de Obras',
    activeProjects: 'Obras Ativas',
    totalRevenue: 'Receita Total',
    billed: 'Já Faturado',
    avgProgress: 'Progresso Médio',
    myProjects: 'Minhas Obras',
    newProject: '+ Nova Obra',
    // ── Project card ──
    progress: 'Progresso',
    budget: 'Orçamento',
    services: 'Serviços',
    photos: 'Fotos',
    start: 'Início',
    viewDetails: 'Ver detalhes',
    inProgress: 'Em Andamento',
    concluded: 'Concluído',
    pending: 'Pendente',
    // ── Project detail ──
    generalProgress: 'Progresso',
    totalBudget: 'Orçamento',
    currentSpend: 'Gasto Atual',
    forecast: 'Previsão',
    schedule: 'Cronograma',
    timeline: 'Linha do Tempo',
    financial: 'Financeiro',
    changeOrders: 'Change Orders',
    performance: 'Performance',
    subcontractors: 'Prestadores',
    photos_tab: 'Fotos',
    // ── Services ──
    serviceSchedule: 'Cronograma de Serviços',
    addService: 'Adicionar Serviço',
    serviceName: 'Nome do serviço',
    duration: 'Duração (dias)',
    cost: 'Custo (R$)',
    saveService: 'Salvar Serviço',
    start_service: 'Iniciar',
    conclude: 'Concluir',
    days: 'dias',
    steps: 'etapas',
    // ── Status ──
    status_concluded: '✅ Concluído',
    status_inProgress: '🔄 Em andamento',
    status_pending: '⏳ Pendente',
    // ── Timeline ──
    newUpdate: 'Nova Atualização',
    updateTitle: 'Título da atualização',
    whatWasDone: 'O que foi feito',
    nextSteps: 'Próximos passos',
    mostRecent: 'Mais recentes',
    photoRecords: 'Registros fotográficos',
    noUpdatesContractor: 'Clique em "Nova Atualização" para publicar o primeiro relatório.',
    noUpdatesClient: 'Aguarde o prestador publicar atualizações da obra.',
    deleteUpdate: 'Excluir atualização',
    confirmDelete: 'Confirmar exclusão',
    deleteWarning: 'Tem certeza que deseja excluir esta atualização? Esta ação não pode ser desfeita.',
    cancel: 'Cancelar',
    delete: 'Excluir',
    saving: 'Salvando...',
    publish: 'Publicar Atualização',
    addPhotos: 'Adicionar fotos (opcional)',
    // ── Financial ──
    contractValue: 'Valor do Contrato',
    received: 'Recebido',
    remaining: 'Saldo Restante',
    margin: 'Margem',
    targetMargin: 'Meta de Margem (%)',
    editFinancial: 'Editar dados financeiros',
    save: 'Salvar',
    editReceived: 'Editar recebido',
    // ── Change Orders ──
    co_title: 'Change Orders',
    co_subtitle: 'Gestão de alterações contratuais',
    co_new: '+ Novo Change Order',
    co_number: 'CO #',
    co_description: 'Descrição da alteração',
    co_amount: 'Valor (R$)',
    co_date: 'Data',
    co_status: 'Status',
    co_statusApproved: 'Aprovado',
    co_statusPending: 'Pendente',
    co_statusRejected: 'Rejeitado',
    co_totalApproved: 'Total Aprovado',
    co_empty: 'Nenhum Change Order registrado',
    co_emptyDesc: 'Change Orders documentam alterações no escopo ou valor do contrato.',
    co_save: 'Salvar',
    co_cancel: 'Cancelar',
    // ── Photos ──
    galleryTitle: 'Galeria de Fotos',
    addPhoto: 'Adicionar Foto',
    setCover: 'Definir como capa',
    cover: 'CAPA',
    noPhotosContractor: 'Clique em "Adicionar Foto" para fazer upload de imagens da obra',
    noPhotosClient: 'Aguarde o prestador adicionar fotos do progresso da obra',
    // ── Report ──
    reportBtn: '📄 Relatório',
    reportTitle: 'Relatório de Progresso',
    executiveSummary: 'Resumo Executivo',
    serviceStatus: 'Status dos Serviços',
    recentUpdates: 'Atualizações Recentes',
    photoRecord: 'Registro Fotográfico',
    generatedOn: 'Gestão de Obras NOA — Relatório gerado em',
    // ── Misc ──
    logout: 'Sair',
    loading: 'Carregando...',
    edit: 'Editar',
    visualSchedule: 'Cronograma Visual',
    sCurve: 'Curva S — Progresso Planejado vs Real',
    realProgress: 'Progresso Real',
    expectedProgress: 'Progresso Esperado',
    serviceDistribution: 'Distribuição dos Serviços',
    detailsTitle: 'Detalhes da Obra',
    projectName: 'Nome da Obra',
    clientName: 'Cliente',
    startDate: 'Data de Início',
    completionForecast: 'Previsão de Conclusão',
    address: 'Endereço',
    editEmail: 'Editar',
    emailClient: 'Email do cliente',
    newEmail: 'Novo email',
    currencySymbol: 'R$',
    dateLocale: 'pt-BR',
    currency: 'BRL',
  },
  en: {
    // ── App name ──
    appName: 'Project Management',
    appTagline: 'Complete system for managing and tracking construction projects',
    // ── Roles ──
    contractor: 'Contractor',
    contractorDesc: 'Manage all your projects in one place',
    client: 'Client',
    clientDesc: 'Track the progress of your project',
    // ── Auth ──
    loginContractor: 'Contractor Login',
    loginContractorSub: 'Access the admin panel',
    loginClient: 'Client Login',
    loginClientSub: 'Access your project with your registered email',
    email: 'Email',
    emailPlaceholder: 'your@email.com',
    emailRegistered: 'Registered email',
    password: 'Password',
    enter: 'Sign In',
    accessMyProject: 'Access my project',
    back: '← Back',
    loginHint: '💡 Tip: Use the email provided by your contractor.',
    loginError: 'Incorrect email or password.',
    emailNotFound: 'Email not found. Please check with your contractor.',
    // ── Dashboard ──
    contractorPanel: 'Contractor Panel',
    totalProjects: 'Total Projects',
    activeProjects: 'Active Projects',
    totalRevenue: 'Total Revenue',
    billed: 'Already Billed',
    avgProgress: 'Avg. Progress',
    myProjects: 'My Projects',
    newProject: '+ New Project',
    // ── Project card ──
    progress: 'Progress',
    budget: 'Budget',
    services: 'Services',
    photos: 'Photos',
    start: 'Start',
    viewDetails: 'View details',
    inProgress: 'In Progress',
    concluded: 'Completed',
    pending: 'Pending',
    // ── Project detail ──
    generalProgress: 'Progress',
    totalBudget: 'Budget',
    currentSpend: 'Current Spend',
    forecast: 'Forecast',
    schedule: 'Schedule',
    timeline: 'Timeline',
    financial: 'Financial',
    changeOrders: 'Change Orders',
    performance: 'Performance',
    subcontractors: 'Subcontractors',
    photos_tab: 'Photos',
    // ── Services ──
    serviceSchedule: 'Service Schedule',
    addService: 'Add Service',
    serviceName: 'Service name',
    duration: 'Duration (days)',
    cost: 'Cost ($)',
    saveService: 'Save Service',
    start_service: 'Start',
    conclude: 'Complete',
    days: 'days',
    steps: 'steps',
    // ── Status ──
    status_concluded: '✅ Completed',
    status_inProgress: '🔄 In Progress',
    status_pending: '⏳ Pending',
    // ── Timeline ──
    newUpdate: 'New Update',
    updateTitle: 'Update title',
    whatWasDone: 'What was completed',
    nextSteps: 'Next steps',
    mostRecent: 'Most recent',
    photoRecords: 'Photo records',
    noUpdatesContractor: 'Click "New Update" to publish the first report.',
    noUpdatesClient: 'Wait for the contractor to publish project updates.',
    deleteUpdate: 'Delete update',
    confirmDelete: 'Confirm deletion',
    deleteWarning: 'Are you sure you want to delete this update? This action cannot be undone.',
    cancel: 'Cancel',
    delete: 'Delete',
    saving: 'Saving...',
    publish: 'Publish Update',
    addPhotos: 'Add photos (optional)',
    // ── Financial ──
    contractValue: 'Contract Value',
    received: 'Received',
    remaining: 'Balance Remaining',
    margin: 'Margin',
    targetMargin: 'Target Margin (%)',
    editFinancial: 'Edit financial data',
    save: 'Save',
    editReceived: 'Edit received',
    // ── Change Orders ──
    co_title: 'Change Orders',
    co_subtitle: 'Contract change management',
    co_new: '+ New Change Order',
    co_number: 'CO #',
    co_description: 'Change description',
    co_amount: 'Amount ($)',
    co_date: 'Date',
    co_status: 'Status',
    co_statusApproved: 'Approved',
    co_statusPending: 'Pending',
    co_statusRejected: 'Rejected',
    co_totalApproved: 'Total Approved',
    co_empty: 'No Change Orders recorded',
    co_emptyDesc: 'Change Orders document changes in scope or contract value.',
    co_save: 'Save',
    co_cancel: 'Cancel',
    // ── Photos ──
    galleryTitle: 'Photo Gallery',
    addPhoto: 'Add Photo',
    setCover: 'Set as cover',
    cover: 'COVER',
    noPhotosContractor: 'Click "Add Photo" to upload project images',
    noPhotosClient: 'Wait for the contractor to add progress photos',
    // ── Report ──
    reportBtn: '📄 Report',
    reportTitle: 'Progress Report',
    executiveSummary: 'Executive Summary',
    serviceStatus: 'Service Status',
    recentUpdates: 'Recent Updates',
    photoRecord: 'Photo Record',
    generatedOn: 'Project Management — Report generated on',
    // ── Misc ──
    logout: 'Sign Out',
    loading: 'Loading...',
    edit: 'Edit',
    visualSchedule: 'Visual Schedule',
    sCurve: 'S-Curve — Planned vs Actual Progress',
    realProgress: 'Actual Progress',
    expectedProgress: 'Planned Progress',
    serviceDistribution: 'Service Distribution',
    detailsTitle: 'Project Details',
    projectName: 'Project Name',
    clientName: 'Client',
    startDate: 'Start Date',
    completionForecast: 'Completion Forecast',
    address: 'Address',
    editEmail: 'Edit',
    emailClient: 'Client email',
    newEmail: 'New email',
    currencySymbol: '$',
    dateLocale: 'en-US',
    currency: 'USD',
  }
};

const t = (key) => TR[LANG][key] ?? key;

// Formata moeda de acordo com o idioma
const fmtCurrency = (value) => {
  const n = value || 0;
  if (LANG === 'en') {
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }
  return 'R\u00a0$\u00a0' + n.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};

// Formata data de acordo com o idioma
const fmtDateLocale = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (LANG === 'en') {
    return d.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
  }
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const fmtDateLong = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (LANG === 'en') {
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
};

// ── Parseia data como horário LOCAL (evita offset UTC no Brasil) ──
const parseLocalDate = (str) => {
  if (!str) return new Date();
  if (str instanceof Date) return new Date(str);
  const s = String(str).split('T')[0]; // "2026-03-22"
  const parts = s.split('-');
  if (parts.length === 3) {
    return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
  }
  return new Date(str);
};


// ─── ChangeOrders Tab ────────────────────────────────────────────────────
function ChangeOrdersTab({ obra, isPrestador }) {
  const [changeOrders, setChangeOrders] = useState([]);
  const [modalNovaCO, setModalNovaCO] = useState(false);
  const [novaCO, setNovaCO] = useState({
    descricao: '', valor: '', data: new Date().toISOString().split('T')[0], status: 'pending'
  });
  const [salvando, setSalvando] = useState(false);
  const [editandoCO, setEditandoCO] = useState(null);
  const [editCOData, setEditCOData] = useState(null);

  // Load change orders from Supabase on mount
  useEffect(() => {
    if (!obra?.id) return;
    const loadCOs = async () => {
      try {
        const { data, error } = await supabase
          .from('change_orders')
          .select('*')
          .eq('obra_id', obra.id)
          .order('created_at', { ascending: false });
        if (!error && data) setChangeOrders(data);
      } catch(e) {}
    };
    loadCOs();
  }, [obra?.id]);

  const loadCOs = async () => {
    try {
      const { data, error } = await supabase
        .from('change_orders')
        .select('*')
        .eq('obra_id', obra.id)
        .order('created_at', { ascending: false });
      if (!error && data) setChangeOrders(data);
    } catch(e) {}
  };

  const salvarCO = async () => {
    if (!novaCO.descricao || !novaCO.valor) return;
    setSalvando(true);
    try {
      const { data, error } = await supabase
        .from('change_orders')
        .insert({
          obra_id: obra.id,
          descricao: novaCO.descricao,
          valor: parseFloat(novaCO.valor) || 0,
          data: novaCO.data,
          status: novaCO.status,
        })
        .select()
        .single();
      if (!error && data) {
        setChangeOrders(prev => [data, ...prev]);
        setNovaCO({ descricao: '', valor: '', data: new Date().toISOString().split('T')[0], status: 'pending' });
        setModalNovaCO(false);
      }
    } catch(e) {} finally { setSalvando(false); }
  };

  const atualizarStatusCO = async (id, status) => {
    try {
      const { data, error } = await supabase
        .from('change_orders')
        .update({ status })
        .eq('id', id)
        .select()
        .single();
      if (!error && data) {
        setChangeOrders(prev => prev.map(co => co.id === id ? data : co));
      }
    } catch(e) {}
  };

  const excluirCO = async (id) => {
    try {
      await supabase.from('change_orders').delete().eq('id', id);
      setChangeOrders(prev => prev.filter(co => co.id !== id));
    } catch(e) {}
  };

  const totalAprovado = changeOrders
    .filter(co => co.status === 'approved')
    .reduce((sum, co) => sum + (co.valor || 0), 0);

  const statusColor = {
    approved: 'bg-green-500/15 text-green-400 border border-green-500/30',
    pending: 'bg-amber-500/15 text-amber-400 border border-amber-500/30',
    rejected: 'bg-red-500/15 text-red-400 border border-red-500/30',
  };

  const statusLabel = {
    approved: t('co_statusApproved'),
    pending: t('co_statusPending'),
    rejected: t('co_statusRejected'),
  };

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="bg-gray-900/80 rounded-2xl border border-gray-800 p-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-base font-medium text-white flex items-center gap-2">
              <span className="w-1 h-5 bg-orange-500 rounded-full inline-block"></span>
              {t('co_title')}
            </h2>
            <p className="text-sm text-gray-400 font-light mt-0.5">{t('co_subtitle')}</p>
          </div>
          {isPrestador && (
            <button
              onClick={() => setModalNovaCO(true)}
              className="px-3 py-1.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all flex items-center gap-1.5"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
              {t('co_new')}
            </button>
          )}
        </div>

        {/* Total Approved Banner */}
        {changeOrders.length > 0 && (
          <div className="bg-gradient-to-r from-orange-500/10 to-amber-500/10 rounded-xl border border-orange-500/20 p-4 mb-4">
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-300">{t('co_totalApproved')}</span>
              <span className="text-xl font-semibold text-orange-400">{fmtCurrency(totalAprovado)}</span>
            </div>
            <div className="flex gap-4 mt-2 text-xs text-gray-500">
              <span className="text-green-400">{changeOrders.filter(c => c.status === 'approved').length} {t('co_statusApproved').toLowerCase()}</span>
              <span className="text-amber-400">{changeOrders.filter(c => c.status === 'pending').length} {t('co_statusPending').toLowerCase()}</span>
              <span className="text-red-400">{changeOrders.filter(c => c.status === 'rejected').length} {t('co_statusRejected').toLowerCase()}</span>
            </div>
          </div>
        )}

        {/* Change Orders List */}
        {changeOrders.length === 0 ? (
          <div className="text-center py-10 border border-dashed border-gray-800 rounded-xl">
            <svg className="w-10 h-10 text-gray-600 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8" strokeWidth={1.5}/>
            </svg>
            <p className="text-gray-400 text-sm font-light">{t('co_empty')}</p>
            <p className="text-gray-600 text-xs mt-1">{t('co_emptyDesc')}</p>
          </div>
        ) : (
          <div className="space-y-3">
            {changeOrders.map((co, idx) => (
              <div key={co.id} className="bg-gray-800/60 rounded-xl border border-gray-800 p-4 hover:border-orange-500/30 transition-all">
                <div className="flex items-start justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-xs text-gray-500 font-medium">{t('co_number')}{changeOrders.length - idx}</span>
                      <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${statusColor[co.status] || statusColor.pending}`}>
                        {statusLabel[co.status] || co.status}
                      </span>
                    </div>
                    <p className="text-sm text-white leading-relaxed">{co.descricao}</p>
                    <div className="flex items-center gap-4 mt-2">
                      <span className="text-base font-semibold text-orange-400">{fmtCurrency(co.valor || 0)}</span>
                      <span className="text-xs text-gray-500">{fmtDateLocale(co.data)}</span>
                    </div>
                  </div>
                  {isPrestador && (
                    <div className="flex flex-col gap-1.5 flex-shrink-0">
                      {co.status !== 'approved' && (
                        <button
                          onClick={() => atualizarStatusCO(co.id, 'approved')}
                          className="px-2.5 py-1 text-xs bg-green-500/15 text-green-400 border border-green-500/30 rounded-lg hover:bg-green-500/25 transition-all"
                        >
                          ✓ {t('co_statusApproved')}
                        </button>
                      )}
                      {co.status !== 'pending' && (
                        <button
                          onClick={() => atualizarStatusCO(co.id, 'pending')}
                          className="px-2.5 py-1 text-xs bg-amber-500/15 text-amber-400 border border-amber-500/30 rounded-lg hover:bg-amber-500/25 transition-all"
                        >
                          ⏳ {t('co_statusPending')}
                        </button>
                      )}
                      {co.status !== 'rejected' && (
                        <button
                          onClick={() => atualizarStatusCO(co.id, 'rejected')}
                          className="px-2.5 py-1 text-xs bg-red-500/15 text-red-400 border border-red-500/30 rounded-lg hover:bg-red-500/25 transition-all"
                        >
                          ✕ {t('co_statusRejected')}
                        </button>
                      )}
                      <button
                        onClick={() => excluirCO(co.id)}
                        className="px-2.5 py-1 text-xs bg-gray-700/50 text-gray-500 border border-gray-700 rounded-lg hover:bg-red-500/15 hover:text-red-400 hover:border-red-500/30 transition-all"
                      >
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Modal — Nova CO */}
      {modalNovaCO && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4 ">
          <div className="bg-gray-900 border border-gray-800 rounded-2xl shadow-2xl w-full max-w-md">
            <div className="px-6 py-5 border-b border-gray-800">
              <h3 className="text-base font-medium text-white">{t('co_new')}</h3>
            </div>
            <div className="px-6 py-5 space-y-4">
              <div>
                <label className="block text-sm text-gray-400 mb-1.5">{t('co_description')}</label>
                <textarea
                  value={novaCO.descricao}
                  onChange={e => setNovaCO(p => ({...p, descricao: e.target.value}))}
                  placeholder={t('co_description')}
                  rows={3}
                  className="w-full bg-gray-800/60 border border-gray-700 rounded-xl px-4 py-3 text-white text-sm placeholder-gray-600 focus:border-orange-500/50 focus:ring-1 focus:ring-orange-500/30 outline-none resize-none transition-all"
                />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-sm text-gray-400 mb-1.5">{t('co_amount')}</label>
                  <input
                    type="number"
                    value={novaCO.valor}
                    onChange={e => setNovaCO(p => ({...p, valor: e.target.value}))}
                    placeholder="0"
                    className="w-full bg-gray-800/60 border border-gray-700 rounded-xl px-4 py-3 text-white text-sm placeholder-gray-600 focus:border-orange-500/50 focus:ring-1 focus:ring-orange-500/30 outline-none transition-all"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-400 mb-1.5">{t('co_date')}</label>
                  <input
                    type="date"
                    value={novaCO.data}
                    onChange={e => setNovaCO(p => ({...p, data: e.target.value}))}
                    className="w-full bg-gray-800/60 border border-gray-700 rounded-xl px-4 py-3 text-white text-sm focus:border-orange-500/50 focus:ring-1 focus:ring-orange-500/30 outline-none transition-all"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm text-gray-400 mb-1.5">{t('co_status')}</label>
                <select
                  value={novaCO.status}
                  onChange={e => setNovaCO(p => ({...p, status: e.target.value}))}
                  className="w-full bg-gray-800/60 border border-gray-700 rounded-xl px-4 py-3 text-white text-sm focus:border-orange-500/50 outline-none transition-all"
                >
                  <option value="pending">{t('co_statusPending')}</option>
                  <option value="approved">{t('co_statusApproved')}</option>
                  <option value="rejected">{t('co_statusRejected')}</option>
                </select>
              </div>
            </div>
            <div className="px-6 py-4 border-t border-gray-800 flex gap-3">
              <button
                onClick={() => setModalNovaCO(false)}
                className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-xl hover:border-gray-600 hover:text-white transition-all"
              >
                {t('co_cancel')}
              </button>
              <button
                onClick={salvarCO}
                disabled={!novaCO.descricao || !novaCO.valor || salvando}
                className="flex-1 px-4 py-2.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-medium rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all disabled:opacity-40 disabled:cursor-not-allowed"
              >
                {salvando ? t('saving') : t('co_save')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function GestaoObras() {
  // ── TODOS os useState — devem ficar ANTES de qualquer useEffect/useCallback ──
  const [usuarioLogado,              setUsuarioLogado]              = useState(null);
  const [telaAtual,                  setTelaAtual]                  = useState('escolha');
  const loginEmAndamento = useRef(false);
  const [emailCliente,               setEmailCliente]               = useState('');
  const [obras,                      setObras]                      = useState([]);
  const [obraSelecionada,            setObraSelecionada]            = useState(null);
  const [novoServico,                setNovoServico]                = useState({ nome: '', duracao: '', custo: '', valorVenda: '', valorCustoContratado: '', nomePrestador: '', dataInicioAcordada: '', dataEntregaAcordada: '' });
  const [mostrarForm,                setMostrarForm]                = useState(false);
  const [mostrarModalNovaObra,       setMostrarModalNovaObra]       = useState(false);
  const [novaObra,                   setNovaObra]                   = useState({ nome: '', cliente: '', emailCliente: '', endereco: '', inicio: '', orcamentoTotal: '' });
  const [editandoEmail,              setEditandoEmail]              = useState(null);
  const [novoEmail,                  setNovoEmail]                  = useState('');
  const [statusDropdownAberto,       setStatusDropdownAberto]       = useState(null);
  const [fotoSelecionada,            setFotoSelecionada]            = useState(null);
  const [servicoExpandido,           setServicoExpandido]           = useState(null);
  const [abaDetalhes,                setAbaDetalhes]                = useState('cronograma');
  const [editandoMargem,             setEditandoMargem]             = useState(false);
  const [editandoFinanceiroServico,  setEditandoFinanceiroServico]  = useState(null);
  const [dadosFinanceiroServico,     setDadosFinanceiroServico]     = useState({ valorVenda: '', valorCustoContratado: '', valorPago: '' });
  const [comprasMatPorObra,          setComprasMatPorObra]          = useState({});  // { obraId: totalCompras }
  const [atualizacoes,               setAtualizacoes]               = useState([]);
  const [carregandoAtualizacoes,     setCarregandoAtualizacoes]     = useState(false);
  const [modalNovaAtualizacao,       setModalNovaAtualizacao]       = useState(false);
  const [novaAtualizacao,            setNovaAtualizacao]            = useState({ titulo: '', descricao: '', proximos_passos: '' });
  const [fotosNovaAtualizacao,       setFotosNovaAtualizacao]       = useState([]);
  const [salvandoAtualizacao,        setSalvandoAtualizacao]        = useState(false);
  const [fotoTimelineAmpliada,       setFotoTimelineAmpliada]       = useState(null);
  const [excluindoAtualizacao,       setExcluindoAtualizacao]       = useState(null);
  const [editandoRecebimento,        setEditandoRecebimento]        = useState(false);
  const [valorRecebidoInput,         setValorRecebidoInput]         = useState('');
  const [dadosMargem,                setDadosMargem]                = useState({ valorContrato: '', valorRecebido: '', metaMargem: '20', bdiCustosIndiretosPct: '22', bdiLucroPct: '20' });
  const [mostrarFormEtapa,           setMostrarFormEtapa]           = useState(null);
  const [carregando,                 setCarregando]                 = useState(false);
  const [erroLogin,                  setErroLogin]                  = useState('');
  const [emailPrestador,             setEmailPrestador]             = useState('');
  const [senhaPrestador,             setSenhaPrestador]             = useState('');
  const [senhaCliente,               setSenhaCliente]               = useState('');
  const [mostrarFormMaterial,        setMostrarFormMaterial]        = useState(null);
  const [novaEtapa,                  setNovaEtapa]                  = useState({ nome: '', concluida: false });
  const [novoMaterial,               setNovoMaterial]               = useState({ nome: '', quantidade: '', unidade: '', fornecedor: '' });
  const [editandoServico,            setEditandoServico]            = useState(null);
  const [servicoEmEdicao,            setServicoEmEdicao]            = useState({ nome: '', duracao: '', custo: '', valorVenda: '', valorCustoContratado: '', valorPago: '', nomePrestador: '', dataInicioAcordada: '', dataEntregaAcordada: '' });
  const [confirmarExclusaoServico,   setConfirmarExclusaoServico]   = useState(null);
  const [editandoOrcamento,          setEditandoOrcamento]          = useState(false);
  const [novoOrcamento,              setNovoOrcamento]              = useState('');
  const [mostrarRelatorio,           setMostrarRelatorio]           = useState(false);
  const [changeOrders,               setChangeOrders]               = useState([]);
  const [modalNovaCO,                setModalNovaCO]                = useState(false);
  const [novaCO,                     setNovaCO]                     = useState({ descricao: '', valor: '', data: new Date().toISOString().split('T')[0], status: 'pending' });
  const [salvandoCO,                 setSalvandoCO]                 = useState(false);
  const [editandoObra,               setEditandoObra]               = useState(null);
  const [formEditObra,               setFormEditObra]               = useState({ nome: '', cliente: '', emailCliente: '', endereco: '', inicio: '', orcamentoTotal: '' });

  // Normaliza dados da obra para a visão do cliente (sem custos internos)
  const normalizeObraCliente = (data) => ({
    id: data.id, nome: data.nome, cliente: data.cliente,
    emailCliente: data.email_cliente, endereco: data.endereco || '',
    inicio: data.inicio, status: data.status,
    orcamentoTotal: data.orcamento_total, gastoAtual: data.gasto_atual,
    orcamentoMateriais:  data.orcamento_materiais  || 0,
    orcamentoMaoDeObra:  data.orcamento_mao_de_obra || 0,
    bdiIndiretos:        data.bdi_indiretos        || 0,
    bdiMargem:           data.bdi_margem           || 0,
    bdiCustosIndiretosPct: data.bdi_custos_indiretos_pct ?? 22,
    bdiLucroPct:           data.bdi_lucro_pct           ?? 20,
    valorRecebido:       data.valor_recebido_total || 0,
    fotoCapa: data.fotos?.find(f => f.is_capa) || null,
    fotos: (data.fotos || []).map(f => ({ id: f.id, url: f.url, nome: f.nome, data: f.created_at })),
    servicos: (data.servicos || []).sort((a, b) => a.ordem - b.ordem).map(s => ({
      id: s.id, nome: s.nome, duracao: s.duracao,
      custo: s.valor_venda_etapa || s.custo || 0,
      status: s.status, ordem: s.ordem, observacoes: s.observacoes || '',
      etapas: (s.etapas || []).map(e => ({ id: e.id, nome: e.nome, concluida: e.concluida })),
      materiais: (s.materiais || []).map(m => ({ id: m.id, nome: m.nome, quantidade: m.quantidade, unidade: m.unidade, fornecedor: m.fornecedor }))
    }))
  });

  // ── Carregar fonte + verificar sessão ──────────────────────────
  useEffect(() => {
    let viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) {
      viewport = document.createElement('meta');
      viewport.name = 'viewport';
      document.head.appendChild(viewport);
    }
    viewport.content = 'width=device-width, initial-scale=1, maximum-scale=1';

    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Garet:wght@300;400&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    // Detecta se veio de um Magic Link de cliente (?modo=cliente na URL)
    const modo = new URLSearchParams(window.location.search).get('modo');

    const handleSession = async (session) => {
      if (!session) return;
      // Se um login (prestador ou cliente) está em andamento, não interferir
      if (loginEmAndamento.current) return;

      if (modo === 'cliente') {
        // ── Magic Link: autenticar cliente pela obra ──────────────
        try {
          const { data, error } = await supabase
            .from('obras')
            .select(`*, servicos(*, etapas(*), materiais(*)), fotos(*)`)
            .eq('email_cliente', session.user.email.toLowerCase())
            .limit(1)
            .maybeSingle();

          if (error || !data) {
            // Email autenticado, mas sem obra vinculada
            await supabase.auth.signOut();
            setErroLogin('Obra não encontrada para este email. Contate seu prestador.');
            setTelaAtual('login-cliente');
          } else {
            const obra = normalizeObraCliente(data);
            setUsuarioLogado({ tipo: 'cliente', nome: data.cliente, email: session.user.email });
            setObraSelecionada(obra);
            setTelaAtual('detalhes-obra');
            // Carrega atualizações da linha do tempo para o cliente
            carregarAtualizacoes(data.id);
            // Limpa o ?modo=cliente da URL sem recarregar a página
            window.history.replaceState({}, '', window.location.pathname);
          }
        } catch (e) {
          await supabase.auth.signOut();
          setTelaAtual('login-cliente');
        }
      } else {
        // ── Verifica se é cliente ou prestador ─────────────────────
        try {
          // Usa .maybeSingle() para não lançar erro quando não encontra
          const { data: obraCliente, error: errCliente } = await supabase
            .from('obras')
            .select(`*, servicos(*, etapas(*), materiais(*)), fotos(*)`)
            .eq('email_cliente', session.user.email.toLowerCase())
            .limit(1)
            .maybeSingle();

          if (!errCliente && obraCliente) {
            // É um cliente — redireciona direto para detalhes da obra
            const obra = normalizeObraCliente(obraCliente);
            setUsuarioLogado({ tipo: 'cliente', nome: obraCliente.cliente, email: session.user.email });
            setObraSelecionada(obra);
            setTelaAtual('detalhes-obra');
            carregarAtualizacoes(obraCliente.id);
          } else {
            // Não encontrou obra vinculada — é um prestador
            setUsuarioLogado({ tipo: 'prestador', nome: session.user.email, id: session.user.id });
            setObraSelecionada(null);
            setTelaAtual('home-prestador');
          }
        } catch {
          // Fallback: tenta uma última vez como cliente antes de assumir prestador
          try {
            const { data: obraFallback } = await supabase
              .from('obras')
              .select(`*, servicos(*, etapas(*), materiais(*)), fotos(*)`)
              .eq('email_cliente', session.user.email.toLowerCase())
              .limit(1)
              .maybeSingle();
            if (obraFallback) {
              const obra = normalizeObraCliente(obraFallback);
              setUsuarioLogado({ tipo: 'cliente', nome: obraFallback.cliente, email: session.user.email });
              setObraSelecionada(obra);
              setTelaAtual('detalhes-obra');
              carregarAtualizacoes(obraFallback.id);
              return;
            }
          } catch {}
          setUsuarioLogado({ tipo: 'prestador', nome: session.user.email, id: session.user.id });
          setObraSelecionada(null);
          setTelaAtual('home-prestador');
        }
      }
    };

    // Verificar sessão ativa (ex: página recarregada)
    supabase.auth.getSession().then(({ data: { session } }) => {
      handleSession(session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) {
        handleSession(session);
      } else {
        setUsuarioLogado(null);
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  const carregarObras = useCallback(async () => {
    if (!usuarioLogado) return [];
    setCarregando(true);
    try {
      const { data, error } = await supabase
        .from('obras')
        .select(`
          *,
          servicos (
            *,
            etapas (*),
            materiais (*)
          ),
          fotos (*)
        `)
        .order('created_at', { ascending: false });

      if (error) throw error;

      // Normalizar dados do Supabase para o formato do app
      const obrasNormalizadas = data.map(o => ({
        id: o.id,
        nome: o.nome,
        cliente: o.cliente,
        emailCliente: o.email_cliente,
        endereco: o.endereco || '',
        inicio: o.inicio,
        status: o.status,
        orcamentoTotal: o.orcamento_total,
        gastoAtual: o.gasto_atual,
        valorContrato: o.valor_contrato || 0,
        metaMargem:   o.meta_margem   || 20,
        // custoReal e custoPrevisto são calculados via useMemo (totaisObra)
        valorRecebido: o.valor_recebido_total || 0,
        orcamentoMateriais:  o.orcamento_materiais  || 0,
        orcamentoMaoDeObra:  o.orcamento_mao_de_obra || 0,
        bdiIndiretos:        o.bdi_indiretos        || 0,
        bdiMargem:           o.bdi_margem           || 0,
        bdiCustosIndiretosPct: o.bdi_custos_indiretos_pct ?? 22,
        bdiLucroPct:           o.bdi_lucro_pct           ?? 20,
        fotoCapa: o.fotos?.find(f => f.is_capa) ? { id: o.fotos.find(f => f.is_capa).id, url: o.fotos.find(f => f.is_capa).url, nome: o.fotos.find(f => f.is_capa).nome } : null,
        fotos: (o.fotos || []).map(f => ({ id: f.id, url: f.url, nome: f.nome, data: f.created_at })),
        servicos: (o.servicos || []).sort((a, b) => a.ordem - b.ordem).map(s => ({
          id: s.id,
          nome: s.nome,
          duracao: s.duracao,
          custo: s.custo,
          status: s.status,
          ordem: s.ordem,
          observacoes: s.observacoes || '',
          // ── Campos financeiros por etapa (somente prestador) ──
          valorVenda:            s.valor_venda_etapa       || 0,
          valorCustoContratado:  s.valor_custo_contratado  || s.custo || 0,
          valorPago:             s.valor_pago_etapa        || 0,
          nomePrestador:         s.nome_prestador          || '',
          dataInicioAcordada:    s.data_inicio_acordada    || null,
          dataEntregaAcordada:   s.data_entrega_acordada   || null,
          etapas: (s.etapas || []).map(e => ({ id: e.id, nome: e.nome, concluida: e.concluida })),
          materiais: (s.materiais || []).map(m => ({ id: m.id, nome: m.nome, quantidade: m.quantidade, unidade: m.unidade, fornecedor: m.fornecedor }))
        }))
      }));

      setObras(obrasNormalizadas);

      // ── Buscar compras de materiais de todas as obras ──
      try {
        const obraIds = obrasNormalizadas.map(o => o.id);
        if (obraIds.length > 0) {
          const { data: compras } = await supabase
            .from('compras_materiais')
            .select('obra_id, total')
            .in('obra_id', obraIds);
          const mapa = {};
          (compras || []).forEach(c => {
            mapa[c.obra_id] = (mapa[c.obra_id] || 0) + (c.total || 0);
          });
          setComprasMatPorObra(mapa);
        }
      } catch(e) {}

      setCarregando(false);
      return obrasNormalizadas; // ← retorna dados frescos para sync imediato
    } catch (e) {
      console.error('Erro ao carregar obras:', e);
      setCarregando(false);
      return [];
    }
  }, [usuarioLogado]);

  useEffect(() => {
    if (usuarioLogado?.tipo === 'prestador') carregarObras();
  }, [usuarioLogado, carregarObras]);

  // ── salvarOrcamento ──────────────────────────────────────────────
  const salvarOrcamento = async () => {
    const valor = parseFloat(novoOrcamento);
    if (!valor || valor <= 0 || !obraSelecionada) return;
    await supabase.from('obras').update({ orcamento_total: valor }).eq('id', obraSelecionada.id);
    atualizarObraLocal(obraSelecionada.id, { orcamentoTotal: valor });
    setEditandoOrcamento(false);
    setNovoOrcamento('');
  };

  const adicionarFoto = async (obraId, event) => {
    const file = event.target.files[0];
    if (!file) return;

    // ── Validação de tipo e tamanho ───────────────────────────────
    const TIPOS_VALIDOS = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
    const TAMANHO_MAX   = 10 * 1024 * 1024; // 10 MB
    if (!TIPOS_VALIDOS.includes(file.type)) {
      alert('Formato inválido. Use JPG, PNG, WebP ou GIF.');
      event.target.value = '';
      return;
    }
    if (file.size > TAMANHO_MAX) {
      alert('Arquivo muito grande. Máximo permitido: 10 MB.');
      event.target.value = '';
      return;
    }
    // ─────────────────────────────────────────────────────────────

    setCarregando(true);
    const ext = file.name.split('.').pop().toLowerCase();
    const path = `${obraId}/${Date.now()}.${ext}`;
    const { error: uploadError } = await supabase.storage
      .from('fotos-obras')
      .upload(path, file, { upsert: true });
    if (!uploadError) {
      const { data: { publicUrl } } = supabase.storage.from('fotos-obras').getPublicUrl(path);
      const { data: novaFoto } = await supabase.from('fotos').insert({ obra_id: obraId, url: publicUrl, nome: file.name, is_capa: false }).select().single();
      if (novaFoto) {
        const fotoLocal = { id: novaFoto.id, url: publicUrl, nome: file.name, data: novaFoto.created_at };
        atualizarObraLocal(obraId, { fotos: [...(obras.find(o => o.id === obraId)?.fotos || []), fotoLocal] });
      }
    }
    setCarregando(false);
  };

  const removerFoto = async (obraId, fotoId) => {
    // Buscar url para deletar do storage
    const foto = obraSelecionada?.fotos?.find(f => f.id === fotoId);
    if (foto?.url) {
      const path = foto.url.split('/fotos-obras/')[1];
      if (path) await supabase.storage.from('fotos-obras').remove([path]);
    }
    await supabase.from('fotos').delete().eq('id', fotoId);
    const obra = obras.find(o => o.id === obraId);
    if (obra) {
      const novasfotos = obra.fotos.filter(f => f.id !== fotoId);
      const novaCapa = obra.fotoCapa?.id === fotoId ? null : obra.fotoCapa;
      atualizarObraLocal(obraId, { fotos: novasfotos, fotoCapa: novaCapa });
    }
  };

  const definirFotoCapa = async (obraId, foto) => {
    // Remover capa atual
    await supabase.from('fotos').update({ is_capa: false }).eq('obra_id', obraId);
    // Definir nova capa
    await supabase.from('fotos').update({ is_capa: true }).eq('id', foto.id);
    // Salvar url da capa na obra
    await supabase.from('obras').update({ foto_capa_url: foto.url }).eq('id', obraId);
    atualizarObraLocal(obraId, { fotoCapa: { id: foto.id, url: foto.url, nome: foto.nome } });
  };

  const adicionarEtapa = async (servicoId) => {
    if (!novaEtapa.nome) return;
    const { data: novaEtapaDB } = await supabase.from('etapas').insert({ servico_id: servicoId, nome: novaEtapa.nome, concluida: false }).select().single();
    if (novaEtapaDB && obraSelecionada) {
      const servico = obraSelecionada.servicos.find(s => s.id === servicoId);
      if (servico) {
        const etapasNova = [...servico.etapas, { id: novaEtapaDB.id, nome: novaEtapaDB.nome, concluida: false }];
        atualizarServicoLocal(obraSelecionada.id, servicoId, { etapas: etapasNova });
      }
    }
    setNovaEtapa({ nome: '', concluida: false });
    setMostrarFormEtapa(null);
  };

  const toggleEtapa = async (servicoId, etapaId) => {
    const servico = obraSelecionada.servicos.find(s => s.id === servicoId);
    const etapa = servico?.etapas.find(e => e.id === etapaId);
    if (!etapa) return;
    const novaConcluida = !etapa.concluida;
    // Optimistic update — atualiza tela imediatamente
    const etapasNova = servico.etapas.map(e => e.id === etapaId ? { ...e, concluida: novaConcluida } : e);
    atualizarServicoLocal(obraSelecionada.id, servicoId, { etapas: etapasNova });
    // Salva no banco em background
    await supabase.from('etapas').update({ concluida: novaConcluida }).eq('id', etapaId);
  };

  const adicionarMaterial = async (servicoId) => {
    if (!novoMaterial.nome || !novoMaterial.quantidade) return;
    const { data: matDB } = await supabase.from('materiais').insert({
      servico_id: servicoId,
      nome: novoMaterial.nome,
      quantidade: novoMaterial.quantidade,
      unidade: novoMaterial.unidade,
      fornecedor: novoMaterial.fornecedor
    }).select().single();
    if (matDB && obraSelecionada) {
      const servico = obraSelecionada.servicos.find(s => s.id === servicoId);
      if (servico) {
        const materiaisNovos = [...servico.materiais, { id: matDB.id, nome: matDB.nome, quantidade: matDB.quantidade, unidade: matDB.unidade, fornecedor: matDB.fornecedor }];
        atualizarServicoLocal(obraSelecionada.id, servicoId, { materiais: materiaisNovos });
      }
    }
    setNovoMaterial({ nome: '', quantidade: '', unidade: '', fornecedor: '' });
    setMostrarFormMaterial(null);
  };

  const removerMaterial = async (servicoId, materialId) => {
    await supabase.from('materiais').delete().eq('id', materialId);
    if (obraSelecionada) {
      const servico = obraSelecionada.servicos.find(s => s.id === servicoId);
      if (servico) {
        const materiaisNovos = servico.materiais.filter(m => m.id !== materialId);
        atualizarServicoLocal(obraSelecionada.id, servicoId, { materiais: materiaisNovos });
      }
    }
  };

  const atualizarObservacoes = async (servicoId, observacoes) => {
    await supabase.from('servicos').update({ observacoes }).eq('id', servicoId);
    // Atualizar estado local sem reload completo para evitar perder foco
    const obrasAtualizadas = obras.map(obra => {
      if (obra.id === obraSelecionada.id) {
        return { ...obra, servicos: obra.servicos.map(s => s.id === servicoId ? { ...s, observacoes } : s) };
      }
      return obra;
    });
    setObras(obrasAtualizadas);
    setObraSelecionada(obrasAtualizadas.find(o => o.id === obraSelecionada.id));
  };

  const adicionarObra = async () => {
    if (!novaObra.nome || !novaObra.cliente || !novaObra.emailCliente || !novaObra.inicio || !novaObra.orcamentoTotal) return;
    setCarregando(true);
    const { error } = await supabase.from('obras').insert({
      prestador_id: usuarioLogado.id,
      nome: novaObra.nome,
      cliente: novaObra.cliente,
      email_cliente: novaObra.emailCliente.toLowerCase(),
      endereco: novaObra.endereco,
      inicio: novaObra.inicio,
      status: 'em_andamento',
      orcamento_total: parseFloat(novaObra.orcamentoTotal),
      gasto_atual: 0
    });
    if (!error) {
      // Recarregar obras para pegar o ID gerado pelo banco
      await carregarObras();
      setNovaObra({ nome: '', cliente: '', emailCliente: '', endereco: '', inicio: '', orcamentoTotal: '' });
      setMostrarModalNovaObra(false);
    }
    setCarregando(false);
  };



  // ─────────────────────────────────────────────
  // Linha do Tempo — funções de dados
  // ─────────────────────────────────────────────
  const carregarAtualizacoes = async (obraId) => {
    if (!obraId) return;
    setCarregandoAtualizacoes(true);
    try {
      const { data, error } = await supabase
        .from('obra_atualizacoes')
        .select('*, obra_atualizacao_fotos(*)')
        .eq('obra_id', obraId)
        .order('data_publicacao', { ascending: false });
      if (!error && data) setAtualizacoes(data);
    } finally {
      setCarregandoAtualizacoes(false);
    }
  };

  const salvarAtualizacao = async () => {
    if (!novaAtualizacao.titulo.trim() || !obraSelecionada) return;
    setSalvandoAtualizacao(true);
    try {
      // Insert update record
      const { data: atualiz, error } = await supabase
        .from('obra_atualizacoes')
        .insert({
          obra_id:         obraSelecionada.id,
          titulo:          novaAtualizacao.titulo.trim(),
          descricao:       novaAtualizacao.descricao.trim(),
          proximos_passos: novaAtualizacao.proximos_passos.trim(),
          data_publicacao: new Date().toISOString(),
        })
        .select()
        .single();
      if (error) throw error;

      // Upload photos
      if (fotosNovaAtualizacao.length > 0) {
        for (let idx = 0; idx < fotosNovaAtualizacao.length; idx++) {
          const file = fotosNovaAtualizacao[idx];
          const ext  = file.name.split('.').pop();
          const path = `atualizacoes/${atualiz.id}/${Date.now()}_${idx}.${ext}`;
          const { error: upErr } = await supabase.storage
            .from('fotos-obras')
            .upload(path, file, { upsert: true });
          if (!upErr) {
            const { data: { publicUrl } } = supabase.storage.from('fotos-obras').getPublicUrl(path);
            await supabase.from('obra_atualizacao_fotos').insert({
              atualizacao_id: atualiz.id,
              url_imagem:     publicUrl,
              ordem:          idx,
            });
          }
        }
      }

      // Reset & reload
      setNovaAtualizacao({ titulo: '', descricao: '', proximos_passos: '' });
      setFotosNovaAtualizacao([]);
      setModalNovaAtualizacao(false);
      await carregarAtualizacoes(obraSelecionada.id);
    } catch (e) {
      console.error('Erro ao salvar atualização:', e);
    } finally {
      setSalvandoAtualizacao(false);
    }
  };

  const excluirAtualizacao = async (atualizacaoId) => {
    // Delete photos from storage + DB, then delete record
    const atualiz = atualizacoes.find(a => a.id === atualizacaoId);
    if (atualiz?.obra_atualizacao_fotos?.length) {
      for (const foto of atualiz.obra_atualizacao_fotos) {
        // Extract storage path from URL
        const parts = foto.url_imagem.split('/fotos-obras/');
        if (parts[1]) {
          await supabase.storage.from('fotos-obras').remove([decodeURIComponent(parts[1])]);
        }
        await supabase.from('obra_atualizacao_fotos').delete().eq('id', foto.id);
      }
    }
    await supabase.from('obra_atualizacoes').delete().eq('id', atualizacaoId);
    setExcluindoAtualizacao(null);
    await carregarAtualizacoes(obraSelecionada.id);
  };

  // ── Helper: sincroniza obraSelecionada a partir dos dados frescos do DB ──
  const sincObra = (obrasAtualizadas) => {
    if (!obraSelecionada) return;
    const atualizada = obrasAtualizadas.find(o => o.id === obraSelecionada.id);
    if (atualizada) setObraSelecionada(atualizada);
  };

  // ── Helper: atualiza obra localmente (sem ir ao banco) ──────────
  const atualizarObraLocal = (obraId, updates) => {
    setObras(prev => {
      const novas = prev.map(o => o.id === obraId ? { ...o, ...updates } : o);
      if (obraSelecionada?.id === obraId) setObraSelecionada(novas.find(o => o.id === obraId));
      return novas;
    });
  };

  // ── Helper: atualiza serviço localmente ─────────────────────────
  const atualizarServicoLocal = (obraId, servicoId, updates) => {
    setObras(prev => {
      const novas = prev.map(o => {
        if (o.id !== obraId) return o;
        const servicos = o.servicos.map(s => s.id === servicoId ? { ...s, ...updates } : s);
        const atualizada = { ...o, servicos };
        if (obraSelecionada?.id === obraId) setObraSelecionada(atualizada);
        return atualizada;
      });
      return novas;
    });
  };

  const salvarRecebimento = async () => {
    if (!obraSelecionada) return;
    const valor = parseFloat(valorRecebidoInput) || 0;
    const { error } = await supabase
      .from('obras')
      .update({ valor_recebido_total: valor })
      .eq('id', obraSelecionada.id);
    if (error) {
      console.error('Erro ao salvar recebimento:', error);
      alert(`Erro ao salvar recebimento:\n${error.message || error.code || JSON.stringify(error)}`);
      return;
    }
    atualizarObraLocal(obraSelecionada.id, { valorRecebido: valor });
    setEditandoRecebimento(false);
  };

  const salvarFinanceiroServico = async () => {
    if (!editandoFinanceiroServico) return;
    const venda    = parseFloat(dadosFinanceiroServico.valorVenda)           || 0;
    const custo    = parseFloat(dadosFinanceiroServico.valorCustoContratado) || 0;
    const pago     = parseFloat(dadosFinanceiroServico.valorPago)            || 0;
    const { error } = await supabase.from('servicos').update({
      valor_venda_etapa:      venda,
      valor_custo_contratado: custo,
      valor_pago_etapa:       pago,
    }).eq('id', editandoFinanceiroServico);
    if (error) {
      console.error('Erro ao salvar financeiro da etapa:', error);
      alert(`Erro ao salvar etapa:\n${error.message || error.code || JSON.stringify(error)}`);
      return;
    }
    if (obraSelecionada) {
      atualizarServicoLocal(obraSelecionada.id, editandoFinanceiroServico, {
        valorVenda: venda, valorCustoContratado: custo, valorPago: pago
      });
    }
    setEditandoFinanceiroServico(null);
    setDadosFinanceiroServico({ valorVenda: '', valorCustoContratado: '', valorPago: '' });
  };

  const salvarMargem = async () => {
    if (!obraSelecionada) return;
    const valorContrato  = parseFloat(dadosMargem.valorContrato)  || 0;
    const valorRecebido  = dadosMargem.valorRecebido !== '' ? (parseFloat(dadosMargem.valorRecebido) || 0) : null;
    const metaMargem     = parseFloat(dadosMargem.metaMargem) || 20;
    const updates = { valor_contrato: valorContrato, meta_margem: metaMargem };
    if (valorRecebido !== null) updates.valor_recebido_total = valorRecebido;
    const { error } = await supabase.from('obras').update(updates).eq('id', obraSelecionada.id);
    if (error) {
      console.error('Erro ao salvar contrato:', error);
      alert(`Erro ao salvar contrato:\n${error.message || error.code || JSON.stringify(error)}`);
      return;
    }
    const localUpdates = { valorContrato, metaMargem };
    if (valorRecebido !== null) localUpdates.valorRecebido = valorRecebido;
    atualizarObraLocal(obraSelecionada.id, localUpdates);
    setEditandoMargem(false);
  };


  const loginPrestador = async () => {
    if (!emailPrestador || !senhaPrestador) {
      setErroLogin('Preencha email e senha.');
      return;
    }
    setCarregando(true);
    setErroLogin('');
    loginEmAndamento.current = true;
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email: emailPrestador.trim(),
        password: senhaPrestador
      });
      if (error) {
        setErroLogin(error.message);
      } else if (data?.user) {
        setUsuarioLogado({ tipo: 'prestador', nome: data.user.email, id: data.user.id });
        setTelaAtual('home-prestador');
      }
    } catch(e) {
      setErroLogin('Erro de conexão. Tente novamente.');
    }
    loginEmAndamento.current = false;
    setCarregando(false);
  };

  const loginCliente = async () => {
    if (!emailCliente || !senhaCliente) {
      setErroLogin('Preencha email e senha.');
      return;
    }
    setCarregando(true);
    setErroLogin('');
    loginEmAndamento.current = true;
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email: emailCliente.trim().toLowerCase(),
        password: senhaCliente,
      });

      if (error) {
        setErroLogin('Email ou senha incorretos. Tente novamente.');
      } else if (data?.user) {
        // Buscar obra vinculada ao email do cliente
        const { data: obraData, error: obraError } = await supabase
          .from('obras')
          .select(`*, servicos(*, etapas(*), materiais(*)), fotos(*)`)
          .eq('email_cliente', data.user.email.toLowerCase())
          .limit(1)
          .maybeSingle();

        if (obraError || !obraData) {
          await supabase.auth.signOut();
          setErroLogin('Nenhuma obra encontrada para este email. Contate seu prestador.');
        } else {
          const obra = normalizeObraCliente(obraData);
          setUsuarioLogado({ tipo: 'cliente', nome: obraData.cliente, email: data.user.email });
          setObraSelecionada(obra);
          setTelaAtual('detalhes-obra');
          carregarAtualizacoes(obraData.id);
        }
      }
    } catch (e) {
      setErroLogin('Erro de conexão. Tente novamente.');
    }
    loginEmAndamento.current = false;
    setCarregando(false);
  };

  const logout = async () => {
    await supabase.auth.signOut();
    setUsuarioLogado(null);
    setObraSelecionada(null);
    setEmailCliente('');
    setSenhaCliente('');
    setTelaAtual('escolha');
  };

  const selecionarObra = (obra) => {
    setObraSelecionada(obra);
    setAbaDetalhes('cronograma');
    setTelaAtual('detalhes-obra');
    carregarAtualizacoes(obra.id);
  };

  const voltarHome = () => {
    setTelaAtual('home-prestador');
    setObraSelecionada(null);
  };

  const calcularDataConclusao = (obra) => {
    if (!obra?.servicos || obra.servicos.length === 0) return '-';
    const dataInicio = parseLocalDate(obra.inicio);
    const diasTotais = obra.servicos.reduce((total, s) => total + (s.duracao || 0), 0);
    const dataConclusao = new Date(dataInicio);
    dataConclusao.setDate(dataConclusao.getDate() + diasTotais);
    return dataConclusao.toLocaleDateString(t('dateLocale'));
  };

  const calcularProgresso = (obra) => {
    if (!obra?.servicos || obra.servicos.length === 0) return 0;
    const totalServicos = obra.servicos.length;
    const servicosConcluidos = obra.servicos.filter(s => s.status === 'concluido').length;
    const servicosEmAndamento = obra.servicos.filter(s => s.status === 'em_andamento').length * 0.5;
    return Math.round(((servicosConcluidos + servicosEmAndamento) / totalServicos) * 100);
  };

  // ── Versões memoizadas para a obra selecionada (tela de detalhes) ──
  const progressoObra = useMemo(
    () => calcularProgresso(obraSelecionada),
    [obraSelecionada] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const dataConclusaoObra = useMemo(
    () => calcularDataConclusao(obraSelecionada),
    [obraSelecionada] // eslint-disable-line react-hooks/exhaustive-deps
  );

  // ── useMemo: totais financeiros da obra selecionada ──────────────
  const totaisObra = useMemo(() => {
    if (!obraSelecionada) return { custoPrevisto: 0, custoReal: 0, totalPago: 0, saldoCusto: 0 };
    const servicos = obraSelecionada.servicos || [];
    const custoPrevisto = servicos.reduce((t, s) => t + (s.valorCustoContratado || 0), 0);
    const custoReal     = servicos.filter(s => s.status === 'concluido').reduce((t, s) => t + (s.valorCustoContratado || 0), 0);
    const totalPago     = servicos.reduce((t, s) => t + (s.valorPago || 0), 0);
    const saldoCusto    = custoPrevisto - totalPago;
    return { custoPrevisto, custoReal, totalPago, saldoCusto };
  }, [obraSelecionada]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── useMemo: estatísticas do painel home ─────────────────────────
  const statsHome = useMemo(() => {
    const obrasAtivas   = obras.filter(o => o.status === 'em_andamento').length;
    const receitaTotal  = obras.reduce((acc, o) => acc + (o.orcamentoTotal || 0), 0);
    const progressoMedio = obras.length
      ? Math.round(obras.reduce((acc, o) => acc + calcularProgresso(o), 0) / obras.length)
      : 0;
    return { obrasAtivas, receitaTotal, progressoMedio };
  }, [obras]); // eslint-disable-line react-hooks/exhaustive-deps

  const adicionarServico = async () => {
    if (!novoServico.nome || !novoServico.duracao || !novoServico.valorVenda) return;
    setCarregando(true);
    const venda = parseFloat(novoServico.valorVenda) || 0;
    const custo = parseFloat(novoServico.valorCustoContratado) || 0;
    const { error } = await supabase.from('servicos').insert({
      obra_id: obraSelecionada.id,
      nome: novoServico.nome,
      duracao: parseInt(novoServico.duracao),
      custo: venda || parseFloat(novoServico.custo) || 0,
      valor_venda_etapa:      venda,
      valor_custo_contratado: custo,
      valor_pago_etapa:       0,
      nome_prestador:         novoServico.nomePrestador || null,
      data_inicio_acordada:   novoServico.dataInicioAcordada || null,
      data_entrega_acordada:  novoServico.dataEntregaAcordada || null,
      status: 'pendente',
      ordem: obraSelecionada.servicos.length + 1,
      observacoes: ''
    });
    if (!error) {
      // Para serviço novo precisamos do ID gerado — recarregar só a obra atual
      await carregarObras();
      setNovoServico({ nome: '', duracao: '', custo: '', valorVenda: '', valorCustoContratado: '', nomePrestador: '', dataInicioAcordada: '', dataEntregaAcordada: '' });
      setMostrarForm(false);
    }
    setCarregando(false);
  };

  const removerServico = async (servicoId) => {
    await supabase.from('servicos').delete().eq('id', servicoId);
    if (obraSelecionada) {
      const servicosNovos = obraSelecionada.servicos.filter(s => s.id !== servicoId);
      atualizarObraLocal(obraSelecionada.id, { servicos: servicosNovos });
    }
  };

  const salvarEdicaoServico = async () => {
    if (!servicoEmEdicao.nome || !servicoEmEdicao.duracao) return;
    const venda = parseFloat(servicoEmEdicao.valorVenda)           || 0;
    const custo = parseFloat(servicoEmEdicao.valorCustoContratado) || 0;
    const pago  = parseFloat(servicoEmEdicao.valorPago)            || 0;
    await supabase.from('servicos').update({
      nome:                   servicoEmEdicao.nome,
      duracao:                parseInt(servicoEmEdicao.duracao),
      custo:                  venda || parseFloat(servicoEmEdicao.custo) || 0,
      valor_venda_etapa:      venda,
      valor_custo_contratado: custo,
      valor_pago_etapa:       pago,
      nome_prestador:         servicoEmEdicao.nomePrestador || null,
      data_inicio_acordada:   servicoEmEdicao.dataInicioAcordada || null,
      data_entrega_acordada:  servicoEmEdicao.dataEntregaAcordada || null,
    }).eq('id', editandoServico);
    if (obraSelecionada) {
      atualizarServicoLocal(obraSelecionada.id, editandoServico, {
        nome: servicoEmEdicao.nome,
        duracao: parseInt(servicoEmEdicao.duracao),
        custo: venda || parseFloat(servicoEmEdicao.custo) || 0,
        valorVenda: venda,
        valorCustoContratado: custo,
        valorPago: pago,
        nomePrestador: servicoEmEdicao.nomePrestador || '',
        dataInicioAcordada: servicoEmEdicao.dataInicioAcordada || null,
        dataEntregaAcordada: servicoEmEdicao.dataEntregaAcordada || null,
      });
    }
    setEditandoServico(null);
    setServicoEmEdicao({ nome: '', duracao: '', custo: '', valorVenda: '', valorCustoContratado: '', valorPago: '', nomePrestador: '', dataInicioAcordada: '', dataEntregaAcordada: '' });
  };

  const atualizarStatusServico = async (servicoId, novoStatus) => {
    // Optimistic update — atualiza tela imediatamente
    const servicosAtualizados = obraSelecionada.servicos.map(s => s.id === servicoId ? { ...s, status: novoStatus } : s);
    atualizarObraLocal(obraSelecionada.id, { servicos: servicosAtualizados });
    // Salva no banco em background
    await supabase.from('servicos').update({ status: novoStatus }).eq('id', servicoId);
  };

  const atualizarEmailCliente = async (obraId) => {
    await supabase.from('obras').update({ email_cliente: novoEmail.toLowerCase() }).eq('id', obraId);
    atualizarObraLocal(obraId, { emailCliente: novoEmail.toLowerCase() });
    setEditandoEmail(null);
    setNovoEmail('');
  };

  // ── Salvar edição completa da obra ──────────────────────────────
  const abrirEdicaoObra = (obra) => {
    setFormEditObra({
      nome: obra.nome || '',
      cliente: obra.cliente || '',
      emailCliente: obra.emailCliente || '',
      endereco: obra.endereco || '',
      inicio: obra.inicio || '',
      orcamentoTotal: obra.orcamentoTotal || '',
    });
    setEditandoObra(obra.id);
  };

  const salvarEdicaoObra = async () => {
    if (!editandoObra) return;
    const updates = {
      nome: formEditObra.nome,
      cliente: formEditObra.cliente,
      emailCliente: formEditObra.emailCliente.toLowerCase(),
      endereco: formEditObra.endereco,
      inicio: formEditObra.inicio,
      orcamentoTotal: parseFloat(formEditObra.orcamentoTotal) || 0,
    };
    // Supabase update
    await supabase.from('obras').update({
      nome: updates.nome,
      cliente: updates.cliente,
      email_cliente: updates.emailCliente,
      endereco: updates.endereco,
      inicio: updates.inicio,
      orcamento_total: updates.orcamentoTotal,
    }).eq('id', editandoObra);
    atualizarObraLocal(editandoObra, updates);
    setEditandoObra(null);
  };





  // ═══════════════════════════════════════════════════
  // ═══════════════════════════════════════════════════
  // Componente Relatório PDF — Client-Facing Report
  // ═══════════════════════════════════════════════════
  const RelatorioView = ({ obra, onClose }) => {
    if (!obra) return null;

    const progresso     = calcularProgresso(obra);
    const dataConclusao = calcularDataConclusao(obra);
    const hoje          = new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
    const servicos      = obra.servicos || [];
    const concluidos    = servicos.filter(s => s.status === 'concluido').length;
    const emAndamento   = servicos.filter(s => s.status === 'em_andamento').length;
    const pendentes     = servicos.filter(s => s.status === 'pendente').length;

    // Saúde da obra
    const saude = calcularSaude(obra);
    const scoreGeral = saude ? saude.scoreGeral : 0;
    const corSaude = scoreGeral >= 80 ? '#22c55e' : scoreGeral >= 60 ? '#eab308' : '#ef4444';
    const labelSaude = scoreGeral >= 80 ? 'Saudável' : scoreGeral >= 60 ? 'Atenção' : 'Crítico';

    // SPI calculation
    const diasTotais     = servicos.reduce((t, s) => t + (s.duracao || 0), 0);
    const diasDecorridos = Math.max(0, Math.floor((new Date() - new Date(obra.inicio)) / 86400000));
    const progressoReal  = progresso / 100;
    const progEsperado   = diasTotais > 0 ? Math.min(diasDecorridos / diasTotais, 1) : 0;
    const spi            = progEsperado === 0 ? 1 : progressoReal / progEsperado;
    const labelSPI       = spi >= 1 ? 'No prazo' : spi >= 0.9 ? 'Atenção' : 'Atrasado';
    const corSPI         = spi >= 1 ? '#22c55e' : spi >= 0.9 ? '#eab308' : '#ef4444';

    // Services progress
    const servicosExecutados = concluidos;
    const totalServicos      = servicos.length;

    const corStatus = (st) => st === 'concluido' ? '#22c55e' : st === 'em_andamento' ? '#f97316' : '#64748b';
    const labelStatus = (st) => st === 'concluido' ? 'Concluído' : st === 'em_andamento' ? 'Em Andamento' : 'Pendente';

    const handlePrint = () => {
      const el = document.getElementById('noa-relatorio-print');
      if (!el) return;

      const janela = window.open('', '_blank', 'width=900,height=750');
      if (!janela) {
        alert('Habilite pop-ups para este site e tente novamente.');
        return;
      }

      const html = [
        '<!DOCTYPE html><html lang="pt-BR"><head>',
        '<meta charset="UTF-8"/>',
        '<meta name="viewport" content="width=device-width,initial-scale=1.0"/>',
        '<title>Relatório da Obra</title>',
        '<style>',
        '@page{margin:12mm;size:A4;}',
        'body{margin:0;padding:0;background:white;font-family:Segoe UI,Arial,sans-serif;}',
        '.no-print{display:none!important;}',
        '</style>',
        '</head><body>',
        el.innerHTML,
        '</body></html>'
      ].join('');

      janela.document.open();
      janela.document.write(html);
      janela.document.close();

      setTimeout(function() {
        janela.focus();
        janela.print();
      }, 600);
    };

    return (
      <>
        {/* CSS de impressão embutido */}
        <style>{`
          @media print {
            body > * { display: none !important; }
            #noa-relatorio-print { display: block !important; }
            @page { margin: 12mm; size: A4; }
            .no-print { display: none !important; }
            .page-break { page-break-before: always; }
          }
          #noa-relatorio-print {
            font-family: 'Segoe UI', Arial, sans-serif;
            color: #1e293b;
            background: white;
          }
        `}</style>

        {/* Overlay tela cheia */}
        <div className="fixed inset-0 z-50 bg-gray-950 overflow-y-auto">

          {/* Barra de ações (não imprime) */}
          <div className="no-print sticky top-0 z-10 bg-gray-900 border-b border-gray-700 px-4 py-3 flex justify-between items-center">
            <div className="flex items-center gap-3">
              <button
                onClick={onClose}
                className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
              >
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
                </svg>
              </button>
              <span className="text-white font-medium">Pré-visualização do Relatório</span>
            </div>
            <button
              onClick={handlePrint}
              className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white rounded-xl font-medium hover:from-orange-600 hover:to-amber-600 transition-all text-sm"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
              </svg>
              Salvar / Imprimir PDF
            </button>
          </div>

          {/* Conteúdo do relatório */}
          <div id="noa-relatorio-print" className="max-w-4xl mx-auto my-6 mx-4 bg-white shadow-2xl rounded-2xl overflow-hidden">

            {/* ── CAPA ───────────────────────────────────────────── */}
            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0f172a 100%)', minHeight: '340px', position: 'relative', overflow: 'hidden' }}>
              {/* Foto de capa como fundo (se houver) */}
              {obra.fotoCapa && (
                <div style={{ position: 'absolute', inset: 0, opacity: 0.18 }}>
                  <img src={obra.fotoCapa.url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
              )}
              <div style={{ position: 'relative', zIndex: 1, padding: '40px 48px' }}>
                {/* Logo + título empresa */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '36px' }}>
                  <img src="https://i.ibb.co/hR5JZzN1/MARCA-DAGUA.png" alt="ConstruAct" style={{ height: '48px', objectFit: 'contain' }} />
                  <div>
                    <p style={{ color: '#f97316', fontWeight: 700, fontSize: '13px', letterSpacing: '2px', textTransform: 'uppercase', margin: 0 }}>ConstruAct</p>
                    <p style={{ color: '#94a3b8', fontSize: '11px', margin: 0 }}>Gestão de Obras</p>
                  </div>
                </div>

                {/* Título do relatório */}
                <p style={{ color: '#f97316', fontWeight: 700, fontSize: '11px', letterSpacing: '3px', textTransform: 'uppercase', margin: '0 0 8px' }}>RELATÓRIO DA OBRA</p>

                {/* Nome da obra */}
                <h1 style={{ color: 'white', fontSize: '28px', fontWeight: 300, lineHeight: 1.2, margin: '0 0 8px', maxWidth: '600px' }}>
                  {obra.nome}
                </h1>
                <div style={{ width: '48px', height: '3px', background: 'linear-gradient(to right, #f97316, #fbbf24)', borderRadius: '2px', margin: '12px 0 20px' }}/>

                {/* Informações principais */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px', marginTop: '8px' }}>
                  <div>
                    <p style={{ color: '#64748b', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 4px' }}>Cliente</p>
                    <p style={{ color: 'white', fontSize: '14px', fontWeight: 600, margin: 0 }}>{obra.cliente}</p>
                  </div>
                  <div>
                    <p style={{ color: '#64748b', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 4px' }}>Data do Relatório</p>
                    <p style={{ color: 'white', fontSize: '14px', fontWeight: 600, margin: 0 }}>{hoje}</p>
                  </div>
                  <div>
                    <p style={{ color: '#64748b', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 4px' }}>Progresso Geral</p>
                    <p style={{ color: '#f97316', fontSize: '22px', fontWeight: 800, margin: 0 }}>{progresso}%</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Barra de progresso visual */}
            <div style={{ background: '#e2e8f0', height: '6px' }}>
              <div style={{ height: '100%', width: `${progresso}%`, background: 'linear-gradient(to right, #f97316, #fbbf24)', transition: 'width 0.6s ease' }}/>
            </div>

            <div style={{ padding: '36px 48px' }}>

              {/* ── SEÇÃO 1: RESUMO DA OBRA ─────────────────────── */}
              <div style={{ marginBottom: '36px' }}>
                <h2 style={{ fontSize: '13px', fontWeight: 700, color: '#f97316', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ display: 'inline-block', width: '3px', height: '16px', background: '#f97316', borderRadius: '2px' }}/>
                  Resumo da Obra
                </h2>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
                  {/* Saúde da Obra */}
                  <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', borderLeft: `3px solid ${corSaude}` }}>
                    <p style={{ color: '#64748b', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 6px' }}>Saúde da Obra</p>
                    <p style={{ color: corSaude, fontSize: '22px', fontWeight: 800, margin: '0 0 4px', lineHeight: 1.2 }}>{Math.round(scoreGeral)}%</p>
                    <p style={{ color: corSaude, fontSize: '11px', fontWeight: 600, margin: 0 }}>{labelSaude}</p>
                  </div>
                  {/* Total Investido */}
                  <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', borderLeft: '3px solid #3b82f6' }}>
                    <p style={{ color: '#64748b', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 6px' }}>Total Investido</p>
                    <p style={{ color: '#3b82f6', fontSize: '16px', fontWeight: 800, margin: 0, lineHeight: 1.2 }}>{fmtCurrency(obra.valorRecebido || 0)}</p>
                  </div>
                  {/* Progresso da Obra */}
                  <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', borderLeft: '3px solid #f97316' }}>
                    <p style={{ color: '#64748b', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 6px' }}>Progresso da Obra</p>
                    <p style={{ color: '#f97316', fontSize: '22px', fontWeight: 800, margin: '0 0 8px', lineHeight: 1.2 }}>{progresso}%</p>
                    <div style={{ height: '6px', background: '#e2e8f0', borderRadius: '3px', overflow: 'hidden' }}>
                      <div style={{ height: '100%', width: `${progresso}%`, background: 'linear-gradient(to right, #f97316, #fbbf24)', borderRadius: '3px' }}/>
                    </div>
                  </div>
                </div>

                {/* Datas e endereço */}
                <div style={{ marginTop: '16px', padding: '16px', background: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
                    <div>
                      <p style={{ color: '#64748b', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 4px' }}>Data de Início</p>
                      <p style={{ color: '#1e293b', fontSize: '13px', fontWeight: 600, margin: 0 }}>{new Date(obra.inicio).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })}</p>
                    </div>
                    <div>
                      <p style={{ color: '#64748b', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 4px' }}>Duração Total</p>
                      <p style={{ color: '#1e293b', fontSize: '13px', fontWeight: 600, margin: 0 }}>{diasTotais} dias corridos</p>
                    </div>
                    <div>
                      <p style={{ color: '#64748b', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 4px' }}>Endereço</p>
                      <p style={{ color: '#1e293b', fontSize: '12px', fontWeight: 500, margin: 0 }}>{obra.endereco || '—'}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* ── SEÇÃO 2: INDICADORES DE DESEMPENHO ─────────── */}
              <div style={{ marginBottom: '36px' }}>
                <h2 style={{ fontSize: '13px', fontWeight: 700, color: '#f97316', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ display: 'inline-block', width: '3px', height: '16px', background: '#f97316', borderRadius: '2px' }}/>
                  Indicadores de Desempenho
                </h2>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
                  {/* SPI */}
                  <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', borderLeft: `3px solid ${corSPI}` }}>
                    <p style={{ color: '#64748b', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 6px' }}>Índice de Desempenho de Prazo (SPI)</p>
                    <p style={{ color: corSPI, fontSize: '22px', fontWeight: 800, margin: '0 0 4px', lineHeight: 1.2 }}>{spi.toFixed(2)}</p>
                    <p style={{ color: corSPI, fontSize: '11px', fontWeight: 600, margin: 0 }}>{labelSPI}</p>
                  </div>
                  {/* Prazo de Entrega */}
                  <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', borderLeft: '3px solid #8b5cf6' }}>
                    <p style={{ color: '#64748b', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 6px' }}>Prazo de Entrega</p>
                    <p style={{ color: '#8b5cf6', fontSize: '16px', fontWeight: 800, margin: 0, lineHeight: 1.2 }}>{dataConclusao}</p>
                  </div>
                  {/* Total Executado */}
                  <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', borderLeft: '3px solid #0ea5e9' }}>
                    <p style={{ color: '#64748b', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 6px' }}>Total Executado</p>
                    <p style={{ color: '#0ea5e9', fontSize: '16px', fontWeight: 800, margin: 0, lineHeight: 1.2 }}>{servicosExecutados} de {totalServicos} serviços</p>
                  </div>
                </div>
              </div>

              {/* ── SEÇÃO 3: ETAPAS CONCLUÍDAS ─────────────────── */}
              <div style={{ marginBottom: '36px' }}>
                <h2 style={{ fontSize: '13px', fontWeight: 700, color: '#f97316', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ display: 'inline-block', width: '3px', height: '16px', background: '#f97316', borderRadius: '2px' }}/>
                  Etapas Concluídas
                </h2>

                {/* Pills de contagem */}
                <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
                  {[
                    { label: 'Concluídos', count: concluidos, cor: '#22c55e', bg: '#f0fdf4' },
                    { label: 'Em Andamento', count: emAndamento, cor: '#f97316', bg: '#fff7ed' },
                    { label: 'Pendentes', count: pendentes, cor: '#64748b', bg: '#f8fafc' },
                  ].map((pill, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 14px', background: pill.bg, border: `1px solid ${pill.cor}30`, borderRadius: '8px' }}>
                      <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: pill.cor }}/>
                      <span style={{ fontSize: '12px', color: '#475569' }}>{pill.label}:</span>
                      <span style={{ fontSize: '14px', fontWeight: 700, color: pill.cor }}>{pill.count}</span>
                    </div>
                  ))}
                </div>

                {/* Tabela de serviços */}
                <div style={{ border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                    <thead>
                      <tr style={{ background: '#f1f5f9' }}>
                        {['#', 'Serviço', 'Status', 'Progresso'].map((h, i) => (
                          <th key={i} style={{ padding: '10px 12px', textAlign: i > 1 ? 'center' : 'left', color: '#64748b', fontWeight: 600, fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #e2e8f0' }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {servicos.map((s, i) => {
                        const prog = s.etapas?.length > 0
                          ? Math.round((s.etapas.filter(e => e.concluida).length / s.etapas.length) * 100)
                          : s.status === 'concluido' ? 100 : s.status === 'em_andamento' ? 50 : 0;
                        const cor = corStatus(s.status);
                        return (
                          <tr key={s.id} style={{ background: i % 2 === 0 ? 'white' : '#f8fafc', borderBottom: '1px solid #f1f5f9' }}>
                            <td style={{ padding: '10px 12px', color: '#94a3b8', fontWeight: 600 }}>{String(i + 1).padStart(2, '0')}</td>
                            <td style={{ padding: '10px 12px', color: '#1e293b', fontWeight: 600 }}>{s.nome}</td>
                            <td style={{ padding: '10px 12px', textAlign: 'center' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'center' }}>
                                <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: cor }}/>
                                <span style={{ color: cor, fontWeight: 600, fontSize: '11px' }}>{labelStatus(s.status)}</span>
                              </div>
                            </td>
                            <td style={{ padding: '10px 12px', textAlign: 'center' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'center' }}>
                                <div style={{ flex: 1, height: '6px', background: '#e2e8f0', borderRadius: '3px', overflow: 'hidden', maxWidth: '60px' }}>
                                  <div style={{ height: '100%', width: `${prog}%`, background: cor, borderRadius: '3px' }}/>
                                </div>
                                <span style={{ color: cor, fontWeight: 700, fontSize: '11px', minWidth: '28px' }}>{prog}%</span>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* ── REGISTRO FOTOGRÁFICO ────────────────────────── */}
              {obra.fotos && obra.fotos.length > 0 && (
                <div style={{ marginBottom: '36px' }} className="page-break">
                  <h2 style={{ fontSize: '13px', fontWeight: 700, color: '#f97316', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ display: 'inline-block', width: '3px', height: '16px', background: '#f97316', borderRadius: '2px' }}/>
                    Registro Fotográfico
                  </h2>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' }}>
                    {obra.fotos.slice(0, 8).map((foto, i) => (
                      <div key={i} style={{ position: 'relative', paddingBottom: '75%', borderRadius: '8px', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
                        <img src={foto.url} alt={foto.nome || `Foto ${i + 1}`} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
                      </div>
                    ))}
                  </div>
                  {obra.fotos.length > 8 && (
                    <p style={{ fontSize: '11px', color: '#94a3b8', textAlign: 'center', marginTop: '8px' }}>
                      + {obra.fotos.length - 8} fotos adicionais disponíveis no sistema
                    </p>
                  )}
                </div>
              )}

              {/* ── RODAPÉ ──────────────────────────────────────── */}
              <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <img src="https://i.ibb.co/hR5JZzN1/MARCA-DAGUA.png" alt="ConstruAct" style={{ height: '24px', objectFit: 'contain' }} />
                  <span style={{ color: '#94a3b8', fontSize: '11px' }}>
                    ConstruAct — Relatório gerado em {hoje}
                  </span>
                </div>
                <span style={{ color: '#cbd5e1', fontSize: '10px' }}>
                  Documento confidencial
                </span>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  // ═══════════════════════════════════════════════════
  // Componente Gantt — Melhorado
  // ═══════════════════════════════════════════════════
  const GanttChart = ({ obra }) => {
    const [zoom, setZoom] = useState('semanas'); // 'dias' | 'semanas' | 'meses'
    const [servicoHover, setServicoHover] = useState(null);
    const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
    const [exportando, setExportando] = useState(false);
    const ganttRef = useRef(null);

    if (!obra?.servicos || obra.servicos.length === 0) return null;

    const dataInicio = parseLocalDate(obra.inicio);
    let diaAtual = 0;
    const servicosComDatas = obra.servicos.map(servico => {
      const inicio = new Date(dataInicio);
      inicio.setDate(inicio.getDate() + diaAtual);
      const fim = new Date(inicio);
      fim.setDate(fim.getDate() + (servico.duracao || 0));
      const obj = { ...servico, dataInicio: inicio, dataFim: fim, diaInicio: diaAtual };
      diaAtual += (servico.duracao || 0);
      return obj;
    });
    const totalDias = diaAtual;
    const hoje = new Date();
    // Normaliza "hoje" para meia-noite local para cálculo correto
    hoje.setHours(0, 0, 0, 0);
    const diasPassados = Math.floor((hoje - dataInicio) / (1000 * 60 * 60 * 24));
    const fmt = (d) => d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
    const fmtFull = (d) => d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });

    const getCorBarra = (status) => {
      if (status === 'concluido') return '#22c55e';
      if (status === 'em_andamento') return '#f97316';
      return '#475569';
    };

    // ── Marcadores de tempo conforme zoom ──────────────────────
    const getMarcadores = () => {
      const marks = [];
      if (zoom === 'dias') {
        for (let i = 0; i <= totalDias; i += 3) marks.push(i);
      } else if (zoom === 'semanas') {
        for (let i = 0; i <= totalDias; i += 7) marks.push(i);
      } else {
        for (let i = 0; i <= totalDias; i += 30) marks.push(i);
      }
      return marks;
    };

    // ── Largura mínima de cada unidade conforme zoom ────────────
    const getPxPorDia = () => {
      if (zoom === 'dias') return 18;
      if (zoom === 'semanas') return 3;
      return 1.5;
    };

    const pxPorDia = getPxPorDia();
    const larguraTotal = Math.max(totalDias * pxPorDia + 160, 600);
    const marcadores = getMarcadores();

    // ── Exportar como imagem ─────────────────────────────────────
    const exportarImagem = () => {
      setExportando(true);
      const style = document.createElement('style');
      style.id = 'gantt-print-style';
      style.innerHTML = '@media print { body > * { display: none !important; } #gantt-print-area { display: block !important; background: #1e293b; color: white; padding: 20px; } }';
      document.head.appendChild(style);
      if (ganttRef.current) ganttRef.current.id = 'gantt-print-area';
      window.print();
      setTimeout(() => {
        const s = document.getElementById('gantt-print-style');
        if (s) s.remove();
        if (ganttRef.current) ganttRef.current.removeAttribute('id');
        setExportando(false);
      }, 1000);
    };

    // Ícones SVG minimalistas
    const IconInicio = () => (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
      </svg>
    );
    const IconConclusao = () => (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/>
      </svg>
    );
    const IconTotal = () => (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
      </svg>
    );
    const IconProgresso = () => (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
      </svg>
    );

    return (
      <div className="bg-gray-900/80 rounded-2xl border border-gray-800 p-4 sm:p-6 mt-4">

        {/* Header */}
        <div className="flex flex-wrap justify-between items-center gap-3 mb-4">
          <h2 className="text-base font-medium text-white flex items-center gap-2">
            <span className="w-1 h-5 bg-orange-500 rounded-full inline-block"/>
            {t('visualSchedule')}
          </h2>

          <div className="flex flex-wrap items-center gap-3">
            {/* Legenda */}
            <div className="flex gap-3 text-xs text-gray-400">
              <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-green-500 inline-block"/>{t('concluded')}</span>
              <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-orange-500 inline-block"/>Em andamento</span>
              <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-slate-500 inline-block"/>{t('pending')}</span>
            </div>

            {/* Zoom */}
            <div className="flex rounded-lg overflow-hidden border border-gray-700">
              {['dias', 'semanas', 'meses'].map(z => (
                <button
                  key={z}
                  onClick={() => setZoom(z)}
                  className={`px-3 py-1 text-xs font-medium capitalize transition-colors ${
                    zoom === z
                      ? 'bg-orange-500 text-white'
                      : 'bg-gray-800 text-gray-400 hover:text-white'
                  }`}
                >
                  {z}
                </button>
              ))}
            </div>

            {/* Exportar — só prestador */}
            {usuarioLogado?.tipo === 'prestador' && (
              <button
                onClick={exportarImagem}
                disabled={exportando}
                className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-700 hover:bg-gray-600 text-gray-300 hover:text-white rounded-lg text-xs transition-colors"
                title="Exportar como imagem"
              >
                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"/>
                </svg>
                {exportando ? 'Exportando...' : 'Exportar'}
              </button>
            )}
          </div>
        </div>

        {/* Gantt */}
        <div className="overflow-x-auto" ref={ganttRef}>
          <div style={{ minWidth: larguraTotal + 'px' }}>

            {/* Header datas — só no scroll horizontal, espaçado */}
            <div className="flex mb-1">
              <div className="w-24 sm:w-36 flex-shrink-0"/>
              <div className="flex-1 relative h-6 border-b border-gray-800">
                {marcadores.filter((_, i) => {
                  // Filtrar marcadores próximos demais (< 8% de largura entre eles)
                  const pxMarcador = (larguraTotal - 144) / marcadores.length;
                  return pxMarcador >= 32 || i % Math.ceil(32 / pxMarcador) === 0;
                }).map((dia, i) => {
                  const d = new Date(dataInicio);
                  d.setDate(d.getDate() + dia);
                  return (
                    <div
                      key={i}
                      className="absolute flex items-center"
                      style={{ left: `${(dia / totalDias) * 100}%`, transform: 'translateX(-50%)' }}
                    >
                      <span className="text-xs text-gray-500 whitespace-nowrap">{fmt(d)}</span>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Grid + Serviços */}
            <div className="relative pt-1">

              {/* Linhas verticais */}
              {marcadores.map((dia, i) => (
                <div
                  key={i}
                  className="absolute top-0 bottom-0 w-px bg-gray-700/30 pointer-events-none"
                  style={{ left: `calc(144px + ${(dia / totalDias) * 100}% * ((100% - 144px) / 100%))` }}
                />
              ))}

              {/* Linha HOJE */}
              {diasPassados >= 0 && diasPassados <= totalDias && (
                <div
                  className="absolute top-0 bottom-8 z-10 pointer-events-none"
                  style={{ left: `calc(144px + ${(diasPassados / totalDias) * 100}% * ((100% - 144px) / 100%))` }}
                >
                  <div className="w-0.5 h-full bg-red-400 opacity-80"/>
                  <div className="absolute -top-5 -translate-x-1/2 text-xs text-red-400 font-bold whitespace-nowrap bg-gray-900 px-1.5 py-0.5 rounded border border-red-500/30">
                    Hoje
                  </div>
                </div>
              )}

              {/* Setas de dependência (SVG overlay) */}
              <svg
                className="absolute inset-0 pointer-events-none z-20"
                style={{ left: '144px', width: 'calc(100% - 144px)', overflow: 'visible' }}
              >
                {servicosComDatas.slice(1).map((s, i) => {
                  const prev = servicosComDatas[i];
                  const rowH = 56; // altura de cada linha
                  const xFimPrev = ((prev.diaInicio + (prev.duracao || 0)) / totalDias) * 100;
                  const xInicioAtual = (s.diaInicio / totalDias) * 100;
                  const yPrev = i * rowH + rowH / 2;
                  const yAtual = (i + 1) * rowH + rowH / 2;
                  if (Math.abs(xFimPrev - xInicioAtual) < 0.1) return null; // sem gap, sem seta
                  return (
                    <g key={s.id} opacity="0.4">
                      <path
                        d={`M ${xFimPrev}% ${yPrev} C ${xFimPrev + 2}% ${yPrev}, ${xInicioAtual - 2}% ${yAtual}, ${xInicioAtual}% ${yAtual}`}
                        fill="none"
                        stroke="#94a3b8"
                        strokeWidth="1.5"
                        strokeDasharray="4 2"
                        markerEnd="url(#arrow)"
                      />
                    </g>
                  );
                })}
                <defs>
                  <marker id="arrow" markerWidth="6" markerHeight="6" refX="3" refY="3" orient="auto">
                    <path d="M0,0 L0,6 L6,3 z" fill="#94a3b8"/>
                  </marker>
                </defs>
              </svg>

              {/* Linhas de serviço */}
              {servicosComDatas.map((s, i) => {
                const prog = s.etapas?.length > 0
                  ? Math.round((s.etapas.filter(e => e.concluida).length / s.etapas.length) * 100)
                  : s.status === 'concluido' ? 100 : s.status === 'em_andamento' ? 50 : 0;
                const esq = (s.diaInicio / totalDias) * 100;
                const larg = ((s.duracao || 0) / totalDias) * 100;
                const cor = getCorBarra(s.status);
                const isHover = servicoHover === s.id;

                return (
                  <div
                    key={s.id}
                    className={`flex items-center mb-1 rounded-lg transition-colors ${
                      i % 2 === 0 ? 'bg-gray-700/20' : ''
                    } ${isHover ? 'bg-gray-700/40' : ''}`}
                    style={{ minHeight: '56px' }}
                  >
                    {/* Nome + info */}
                    <div className="w-24 sm:w-36 flex-shrink-0 py-2 pr-2 sm:pr-3 pl-1">
                      <div className="flex items-center gap-1.5 min-w-0">
                        <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: cor }}/>
                        <span className="text-xs font-medium text-gray-200 truncate">{s.nome}</span>
                      </div>
                      <div className="text-xs text-gray-500 ml-3.5">{prog}% · {s.duracao}d</div>
                      {/* Botão mudar status — só prestador */}
                      {usuarioLogado?.tipo === 'prestador' && s.status !== 'concluido' && (
                        <button
                          onClick={() => atualizarStatusServico(s.id, s.status === 'pendente' ? 'em_andamento' : 'concluido')}
                          className="mt-1 ml-3.5 text-xs text-orange-400 hover:text-orange-300 underline"
                        >
                          {s.status === 'pendente' ? 'Iniciar' : 'Concluir'}
                        </button>
                      )}
                    </div>

                    {/* Área da barra */}
                    <div
                      className="flex-1 relative py-2 cursor-pointer"
                      style={{ minHeight: '56px' }}
                      onMouseEnter={(e) => {
                        setServicoHover(s.id);
                        setTooltipPos({ x: e.clientX, y: e.clientY });
                      }}
                      onMouseMove={(e) => setTooltipPos({ x: e.clientX, y: e.clientY })}
                      onMouseLeave={() => setServicoHover(null)}
                    >
                      {/* Data início — só mostra se barra for larga o suficiente */}
                      {larg > 8 && (
                        <div
                          className="absolute text-xs text-gray-400 whitespace-nowrap font-medium"
                          style={{ left: `${esq}%`, top: '0px' }}
                        >
                          {fmt(s.dataInicio)}
                        </div>
                      )}
                      {/* Data fim — só mostra se barra for larga o suficiente e não sobrepor início */}
                      {larg > 12 && (
                        <div
                          className="absolute text-xs text-gray-400 whitespace-nowrap font-medium"
                          style={{ left: `${esq + larg}%`, top: '0px', transform: 'translateX(-100%)' }}
                        >
                          {fmt(s.dataFim)}
                        </div>
                      )}

                      {/* Trilho */}
                      <div
                        className="absolute left-0 right-0 bg-gray-700/50 rounded-full"
                        style={{ top: '18px', height: '14px' }}
                      />

                      {/* Barra */}
                      <div
                        className="absolute rounded-full overflow-hidden transition-all duration-200"
                        style={{
                          left: `${esq}%`,
                          width: `${larg}%`,
                          top: '18px',
                          height: '14px',
                          background: cor,
                          opacity: isHover ? 1 : 0.85,
                          minWidth: '16px',
                          boxShadow: isHover ? `0 0 8px ${cor}80` : 'none'
                        }}
                      >
                        {/* Progresso interno */}
                        <div className="h-full bg-white/25 transition-all" style={{ width: `${prog}%` }}/>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Rodapé */}
            <div className="mt-4 pt-3 border-t border-gray-800 flex flex-wrap gap-x-6 gap-y-2">
              <span className="flex items-center gap-2 text-xs text-gray-400">
                <IconInicio/>
                <span>Início: <strong className="text-white">{parseLocalDate(obra.inicio).toLocaleDateString('pt-BR')}</strong></span>
              </span>
              <span className="flex items-center gap-2 text-xs text-gray-400">
                <IconConclusao/>
                <span>Conclusão: <strong className="text-white">{calcularDataConclusao(obra)}</strong></span>
              </span>
              <span className="flex items-center gap-2 text-xs text-gray-400">
                <IconTotal/>
                <span>Total: <strong className="text-white">{totalDias} dias</strong></span>
              </span>
              <span className="flex items-center gap-2 text-xs text-gray-400">
                <IconProgresso/>
                <span>Progresso: <strong className="text-orange-400">{calcularProgresso(obra)}%</strong></span>
              </span>
            </div>
          </div>
        </div>

        {/* Tooltip ao hover */}
        {servicoHover && (() => {
          const s = servicosComDatas.find(x => x.id === servicoHover);
          if (!s) return null;
          const prog = s.etapas?.length > 0
            ? Math.round((s.etapas.filter(e => e.concluida).length / s.etapas.length) * 100)
            : s.status === 'concluido' ? 100 : s.status === 'em_andamento' ? 50 : 0;
          const statusLabel = { concluido: t('status_concluded'), em_andamento: t('status_inProgress'), pendente: t('status_pending') };
          return (
            <div
              className="fixed z-50 bg-gray-900 border border-gray-700 rounded-xl p-3 shadow-2xl text-xs pointer-events-none"
              style={{ left: tooltipPos.x + 12, top: tooltipPos.y - 10, maxWidth: '220px' }}
            >
              <p className="font-semibold text-white mb-2">{s.nome}</p>
              <div className="space-y-1 text-gray-300">
                <p>{statusLabel[s.status]}</p>
                <p>📅 Início: <span className="text-white">{fmtFull(s.dataInicio)}</span></p>
                <p>🏁 Fim: <span className="text-white">{fmtFull(s.dataFim)}</span></p>
                <p>⏱ Duração: <span className="text-white">{s.duracao} dias</span></p>
                <p>📊 Progresso: <span className="text-orange-400 font-semibold">{prog}%</span></p>
                {s.etapas?.length > 0 && (
                  <p>📋 Etapas: <span className="text-white">{s.etapas.filter(e => e.concluida).length}/{s.etapas.length}</span></p>
                )}
              </div>
            </div>
          );
        })()}
      </div>
    );
  };

    // Componente Performance
  const PerformanceTab = ({ obra }) => {
    const [abaIndicador, setAbaIndicador] = useState('spi');

    if (!obra?.servicos || obra.servicos.length === 0) return (
      <div className="text-center py-12 text-gray-400 text-sm">Nenhum serviço cadastrado ainda.</div>
    );

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const dataInicio = parseLocalDate(obra.inicio);
    const totalDias = obra.servicos.reduce((acc, s) => acc + (s.duracao || 0), 0);
    const diasDecorridos = Math.max(0, Math.floor((hoje - dataInicio) / (1000 * 60 * 60 * 24)));
    const diasTotais = Math.max(1, totalDias);

    // SPI
    const progressoReal = calcularProgresso(obra) / 100;
    const progressoEsperado = Math.min(diasDecorridos / diasTotais, 1);
    const spi = progressoEsperado === 0 ? 1 : progressoReal / progressoEsperado;
    const spiCor = spi >= 1.05 ? '#22c55e' : spi >= 0.95 ? '#f97316' : '#ef4444';
    const spiLabel = spi >= 1.05 ? 'Adiantado' : spi >= 0.95 ? 'No Prazo' : 'Atrasado';

    // Atrasados
    let diaAtualCalc = 0;
    const servicosComPrazo = obra.servicos.map(s => {
      const inicioServico = new Date(dataInicio);
      inicioServico.setDate(inicioServico.getDate() + diaAtualCalc);
      const fimPrevisto = new Date(inicioServico);
      fimPrevisto.setDate(fimPrevisto.getDate() + (s.duracao || 0));
      diaAtualCalc += (s.duracao || 0);
      const atrasado = s.status !== 'concluido' && hoje > fimPrevisto;
      return { ...s, fimPrevisto, atrasado };
    });
    const totalServicos = obra.servicos.length;
    const atrasados = servicosComPrazo.filter(s => s.atrasado).length;

    // Curva S
    const curvaS = [];
    const intervalos = Math.min(10, diasTotais);
    for (let i = 0; i <= intervalos; i++) {
      const diaRef = Math.round((i / intervalos) * diasTotais);
      const dataRef = new Date(dataInicio);
      dataRef.setDate(dataRef.getDate() + diaRef);
      const planejado = Math.round((diaRef / diasTotais) * 100);
      let realPercent = 0;
      let diaAcum = 0;
      obra.servicos.forEach(s => {
        const fimS = diaAcum + (s.duracao || 0);
        if (s.status === 'concluido') {
          realPercent += (s.duracao / diasTotais) * 100;
        } else if (s.status === 'em_andamento' && diaRef >= diaAcum) {
          const parcial = Math.min((diaRef - diaAcum) / (s.duracao || 1), 1) * 0.5;
          realPercent += parcial * (s.duracao / diasTotais) * 100;
        }
        diaAcum = fimS;
      });
      curvaS.push({
        data: dataRef.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }),
        Planejado: planejado,
        Real: dataRef <= hoje ? Math.round(Math.min(realPercent, 100)) : null,
      });
    }

    const distribuicao = [
      { label: 'Concluídos',    count: obra.servicos.filter(s => s.status === 'concluido').length,    cor: '#22c55e' },
      { label: 'Em andamento',  count: obra.servicos.filter(s => s.status === 'em_andamento').length,  cor: '#f97316' },
      { label: 'Pendentes',     count: obra.servicos.filter(s => s.status === 'pendente').length,      cor: '#64748b' },
      { label: 'Atrasados',     count: atrasados,                                                       cor: '#ef4444' },
    ];

    return (
      <div className="space-y-4">

        {/* Mini-tabs SPI / Distribuição */}
        <div className="flex gap-1 bg-gray-900 p-1 rounded-xl border border-gray-800 w-fit">
          {[
            {
              id: 'spi',
              label: 'SPI',
              icon: (active) => (
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                  stroke={active ? 'white' : '#f97316'} strokeWidth="1.8"
                  strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
              )
            },
            {
              id: 'distribuicao',
              label: 'Distribuição',
              icon: (active) => (
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                  stroke={active ? 'white' : '#f97316'} strokeWidth="1.8"
                  strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="3" width="6" height="18" rx="1"/>
                  <rect x="9" y="8" width="6" height="13" rx="1"/>
                  <rect x="16" y="13" width="6" height="8" rx="1"/>
                </svg>
              )
            },
          ].map(tab => (
            <button
              key={tab.id}
              onClick={() => setAbaIndicador(tab.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                abaIndicador === tab.id
                  ? 'bg-orange-500 text-white shadow'
                  : 'text-gray-400 hover:text-white'
              }`}
            >
              {tab.icon(abaIndicador === tab.id)}
              {tab.label}
            </button>
          ))}
        </div>

        {/* Card SPI */}
        {abaIndicador === 'spi' && (
          <div className="bg-gray-800/40 rounded-2xl border border-gray-800 p-5">
            <div className="flex items-start justify-between mb-4">
              <div>
                <p className="text-xs text-gray-400 mb-1">SPI — Índice de Desempenho de Prazo</p>
                <p className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight" style={{ color: spiCor }}>{spi.toFixed(2)}</p>
              </div>
              <div className="px-3 py-1.5 rounded-full text-sm font-semibold" style={{ background: spiCor + '20', color: spiCor }}>
                {spiLabel}
              </div>
            </div>

            {/* Barra SPI com marcador */}
            <div className="relative w-full h-3 bg-gray-700/50 rounded-full mb-3 overflow-visible">
              {/* Zona vermelha / laranja / verde */}
              <div className="absolute inset-0 rounded-full overflow-hidden flex">
                <div className="h-full bg-red-500/40"    style={{ width: '47%' }}/>
                <div className="h-full bg-orange-500/40" style={{ width: '6%' }}/>
                <div className="h-full bg-green-500/40"  style={{ width: '47%' }}/>
              </div>
              {/* Marcador atual */}
              <div
                className="absolute top-1/2 -translate-y-1/2 w-4 h-4 rounded-full border-2 border-white shadow-lg z-10"
                style={{ left: `${Math.min(Math.max((spi / 2) * 100, 2), 97)}%`, background: spiCor, transform: 'translate(-50%, -50%)' }}
              />
              {/* Labels */}
              <div className="absolute -bottom-5 left-0 text-xs text-gray-500">0</div>
              <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 text-xs text-gray-400 font-medium">1.0</div>
              <div className="absolute -bottom-5 right-0 text-xs text-gray-500">2</div>
            </div>

            <div className="mt-7 grid grid-cols-2 gap-3 text-sm">
              <div className="bg-gray-700/30 rounded-xl p-3">
                <p className="text-xs text-gray-500 mb-1">Progresso Real</p>
                <p className="text-xl font-bold text-white">{calcularProgresso(obra)}%</p>
              </div>
              <div className="bg-gray-700/30 rounded-xl p-3">
                <p className="text-xs text-gray-500 mb-1">Progresso Esperado</p>
                <p className="text-xl font-bold text-white">{Math.round(progressoEsperado * 100)}%</p>
              </div>
              <div className="bg-gray-700/30 rounded-xl p-3">
                <p className="text-xs text-gray-500 mb-1">Dias Decorridos</p>
                <p className="text-xl font-bold text-white">{diasDecorridos}</p>
              </div>
              <div className="bg-gray-700/30 rounded-xl p-3">
                <p className="text-xs text-gray-500 mb-1">Dias Restantes</p>
                <p className="text-xl font-bold text-white">{Math.max(0, diasTotais - diasDecorridos)}</p>
              </div>
            </div>

            <p className="text-xs text-gray-600 mt-4">SPI &gt; 1.0 = adiantado · SPI = 1.0 = no prazo · SPI &lt; 1.0 = atrasado</p>
          </div>
        )}

        {/* Card Distribuição */}
        {abaIndicador === 'distribuicao' && (
          <div className="bg-gray-800/40 rounded-2xl border border-gray-800 p-5">
            <p className="text-xs text-gray-400 mb-4">Distribuição dos Serviços</p>

            <div className="grid grid-cols-2 gap-3 mb-5">
              {distribuicao.map((item, i) => (
                <div key={i} className="bg-gray-700/30 rounded-xl p-4 flex flex-col gap-1">
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-400">{item.label}</span>
                    <span className="text-2xl font-bold text-white">{item.count}</span>
                  </div>
                  <div className="w-full bg-gray-700/50 rounded-full h-1.5 mt-1">
                    <div className="h-1.5 rounded-full transition-all" style={{ width: `${totalServicos > 0 ? (item.count / totalServicos) * 100 : 0}%`, background: item.cor }}/>
                  </div>
                  <p className="text-xs font-medium mt-0.5" style={{ color: item.cor }}>
                    {totalServicos > 0 ? Math.round((item.count / totalServicos) * 100) : 0}% do total
                  </p>
                </div>
              ))}
            </div>

            {/* Barra empilhada */}
            <div className="flex w-full h-3 rounded-full overflow-hidden mb-2">
              {distribuicao.map((item, i) => (
                totalServicos > 0 && item.count > 0 ? (
                  <div
                    key={i}
                    className="h-full transition-all"
                    style={{ width: `${(item.count / totalServicos) * 100}%`, background: item.cor }}
                    title={`${item.label}: ${item.count}`}
                  />
                ) : null
              ))}
            </div>
            <div className="flex flex-wrap gap-3 mt-2">
              {distribuicao.map((item, i) => (
                <span key={i} className="flex items-center gap-1.5 text-xs text-gray-400">
                  <span className="w-2.5 h-2.5 rounded-full inline-block" style={{ background: item.cor }}/>
                  {item.label}
                </span>
              ))}
            </div>

            <div className="mt-4 pt-3 border-t border-gray-800 text-xs text-gray-500">
              Conclusão prevista: <strong className="text-white">{calcularDataConclusao(obra)}</strong>
            </div>
          </div>
        )}

        {/* Curva S — sempre visível */}
        <div className="bg-gray-800/40 rounded-2xl border border-gray-800 p-5">
          <h3 className="text-sm font-medium text-white mb-1 flex items-center gap-2">
            <span className="w-1 h-4 bg-orange-500 rounded-full inline-block"/>
            Curva S — Progresso Planejado vs Real
          </h3>
          <p className="text-xs text-gray-500 mb-4">Avanço esperado comparado ao avanço real da obra</p>
          <ResponsiveContainer width="100%" height={220}>
            <LineChart data={curvaS} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
              <XAxis dataKey="data" tick={{ fill: '#9ca3af', fontSize: 11 }} />
              <YAxis tick={{ fill: '#9ca3af', fontSize: 11 }} tickFormatter={v => `${v}%`} domain={[0, 100]} />
              <Tooltip
                contentStyle={{ background: '#1f2937', border: '1px solid #374151', borderRadius: '8px' }}
                labelStyle={{ color: '#f9fafb', fontSize: 12 }}
                formatter={(value, name) => [`${value}%`, name]}
              />
              <Legend wrapperStyle={{ fontSize: 12, color: '#9ca3af' }} />
              <ReferenceLine y={calcularProgresso(obra)} stroke="#f97316" strokeDasharray="4 4"
                label={{ value: 'Atual', fill: '#f97316', fontSize: 11 }} />
              <Line type="monotone" dataKey="Planejado" stroke="#64748b" strokeWidth={2} dot={false} strokeDasharray="5 5" />
              <Line type="monotone" dataKey="Real" stroke="#f97316" strokeWidth={2.5} dot={{ fill: '#f97316', r: 3 }} connectNulls={false} />
            </LineChart>
          </ResponsiveContainer>
          <div className="flex gap-6 mt-2 text-xs text-gray-500">
            <span className="flex items-center gap-1.5">
              <span className="inline-block w-6" style={{ borderTop: '2px dashed #64748b' }}/>
              Planejado
            </span>
            <span className="flex items-center gap-1.5">
              <span className="inline-block w-6 border-t-2 border-orange-500"/>
              Real
            </span>
          </div>
        </div>
      </div>
    );
  };

  

  // ─────────────────────────────────────────────
  // Componente: Linha do Tempo da Obra
  // ─────────────────────────────────────────────
  const LinhaDoTempoTab = () => {
    const isPrestador = usuarioLogado?.tipo === 'prestador';

    const fmtData = (iso) => {
      const d = new Date(iso);
      return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
    };
    const fmtHora = (iso) => new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

    return (
      <div className="space-y-6">
        {/* Header da aba */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="w-1 h-5 bg-orange-500 rounded-full"/>
            <h2 className="text-base font-medium text-white">Linha do Tempo</h2>
            <span className="px-2 py-0.5 bg-gray-700/60 text-gray-400 text-xs rounded-full border border-gray-600/40">
              {atualizacoes.length} {atualizacoes.length === 1 ? 'atualização' : 'atualizações'}
            </span>
          </div>
          {isPrestador && (
            <button
              onClick={() => setModalNovaAtualizacao(true)}
              className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-medium rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4"/>
              </svg>
              Nova Atualização
            </button>
          )}
        </div>

        {/* Loading */}
        {carregandoAtualizacoes && (
          <div className="flex items-center justify-center py-16">
            <div className="w-8 h-8 border-2 border-orange-500 border-t-transparent rounded-full animate-spin"/>
          </div>
        )}

        {/* Empty state */}
        {!carregandoAtualizacoes && atualizacoes.length === 0 && (
          <div className="flex flex-col items-center justify-center py-20 bg-gray-800/30 rounded-2xl border border-dashed border-gray-700">
            <div className="w-14 h-14 rounded-full bg-gray-700/50 flex items-center justify-center mb-4">
              <svg className="w-7 h-7 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 12h6"/>
              </svg>
            </div>
            <p className="text-gray-400 font-medium mb-1">Nenhuma atualização publicada</p>
            <p className="text-xs text-gray-600">
              {isPrestador ? t('noUpdatesContractor') : t('noUpdatesClient')}
            </p>
          </div>
        )}

        {/* Timeline cards */}
        {!carregandoAtualizacoes && atualizacoes.length > 0 && (
          <div className="relative">
            {/* Vertical line */}
            <div className="absolute left-5 top-6 bottom-6 w-px bg-gradient-to-b from-orange-500/60 via-orange-500/20 to-transparent hidden sm:block"/>

            <div className="space-y-6">
              {atualizacoes.map((atualiz, idx) => (
                <div key={atualiz.id} className="relative flex gap-4 sm:gap-6">

                  {/* Timeline dot */}
                  <div className="hidden sm:flex flex-col items-center flex-shrink-0">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center border-2 z-10 ${
                      idx === 0
                        ? 'bg-orange-500 border-orange-400 shadow-lg shadow-orange-500/40'
                        : 'bg-gray-800 border-gray-600'
                    }`}>
                      <svg className={`w-4 h-4 ${idx === 0 ? 'text-white' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                      </svg>
                    </div>
                  </div>

                  {/* Card */}
                  <div className="flex-1 bg-gray-900/80 rounded-2xl border border-gray-800 hover:border-orange-500/30 transition-all overflow-hidden">

                    {/* Card header */}
                    <div className="flex items-start justify-between px-5 py-4 border-b border-gray-800">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                          {idx === 0 && (
                            <span className="px-2 py-0.5 bg-orange-500/20 text-orange-400 text-xs font-medium rounded-full border border-orange-500/30">
                              {t('mostRecent')}
                            </span>
                          )}
                          <span className="text-xs text-gray-500 flex items-center gap-1">
                            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                            </svg>
                            {fmtData(atualiz.data_publicacao)}
                          </span>
                          <span className="text-xs text-gray-600 flex items-center gap-1">
                            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                            </svg>
                            {fmtHora(atualiz.data_publicacao)}
                          </span>
                        </div>
                        <h3 className="text-white font-semibold text-base leading-snug truncate pr-4">{atualiz.titulo}</h3>
                      </div>
                      {isPrestador && (
                        <button
                          onClick={() => setExcluindoAtualizacao(atualiz.id)}
                          className="p-2 text-gray-600 hover:text-red-400 hover:bg-red-500/10 rounded-xl transition-all flex-shrink-0"
                          title={t('deleteUpdate')}
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                          </svg>
                        </button>
                      )}
                    </div>

                    <div className="px-5 py-4 space-y-4">
                      {/* Descrição */}
                      {atualiz.descricao && (
                        <div>
                          <p className="text-xs text-gray-500 font-medium mb-1.5 flex items-center gap-1.5">
                            <svg className="w-3.5 h-3.5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                            </svg>
                            {t('whatWasDone')}
                          </p>
                          <p className="text-sm text-gray-300 leading-relaxed whitespace-pre-line">{atualiz.descricao}</p>
                        </div>
                      )}

                      {/* {t('nextSteps')} */}
                      {atualiz.proximos_passos && (
                        <div className="bg-orange-500/5 border border-orange-500/20 rounded-xl p-3.5">
                          <p className="text-xs text-orange-400 font-medium mb-1.5 flex items-center gap-1.5">
                            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7M5 5l7 7-7 7"/>
                            </svg>
                            {t('nextSteps')}
                          </p>
                          <p className="text-sm text-gray-300 leading-relaxed whitespace-pre-line">{atualiz.proximos_passos}</p>
                        </div>
                      )}

                      {/* Galeria de fotos */}
                      {atualiz.obra_atualizacao_fotos?.length > 0 && (
                        <div>
                          <p className="text-xs text-gray-500 font-medium mb-2 flex items-center gap-1.5">
                            <svg className="w-3.5 h-3.5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                            </svg>
                            Registros fotográficos · {atualiz.obra_atualizacao_fotos.length} {atualiz.obra_atualizacao_fotos.length === 1 ? 'foto' : 'fotos'}
                          </p>
                          <div className={`grid gap-2 ${
                            atualiz.obra_atualizacao_fotos.length === 1 ? 'grid-cols-1' :
                            atualiz.obra_atualizacao_fotos.length === 2 ? 'grid-cols-2' :
                            atualiz.obra_atualizacao_fotos.length === 3 ? 'grid-cols-3' :
                            'grid-cols-2 sm:grid-cols-4'
                          }`}>
                            {atualiz.obra_atualizacao_fotos
                              .sort((a, b) => a.ordem - b.ordem)
                              .map((foto, fi) => (
                              <div
                                key={foto.id}
                                className={`relative group overflow-hidden rounded-xl cursor-pointer bg-gray-700/40 ${
                                  atualiz.obra_atualizacao_fotos.length === 1 ? 'aspect-video' : 'aspect-square'
                                }`}
                                onClick={() => setFotoTimelineAmpliada({ url: foto.url_imagem, titulo: atualiz.titulo, idx: fi + 1, total: atualiz.obra_atualizacao_fotos.length })}
                              >
                                <img
                                  src={foto.url_imagem}
                                  alt={`Foto ${fi + 1}`}
                                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                                />
                                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center">
                                  <svg className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity drop-shadow-lg" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"/>
                                  </svg>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  // ─────────────────────────────────────────────────────────────
  // Componente: Executado x Pago — 2 Camadas (somente Prestador)
  // ─────────────────────────────────────────────────────────────

  // ═══════════════════════════════════════════════════════════════
  // Compras de Materiais — somente Prestador (cliente vê resumo)
  // ═══════════════════════════════════════════════════════════════
  const ComprasMateriaisTab = ({ obra, isPrestador }) => {
    const [compras,             setCompras]             = useState([]);
    const [carregandoCompras,   setCarregandoCompras]   = useState(true);
    const [modalNovaCompra,     setModalNovaCompra]     = useState(false);
    const [compraEmEdicao,      setCompraEmEdicao]      = useState(null);
    const [salvandoCompra,      setSalvandoCompra]      = useState(false);
    const [excluindoCompra,     setExcluindoCompra]     = useState(null);
    const [editandoOrcMat,      setEditandoOrcMat]      = useState(false);
    const [novoOrcMat,          setNovoOrcMat]          = useState('');
    const [novoOrcMaoObra,      setNovoOrcMaoObra]      = useState('');

    // Form nova compra
    const [novaCompra, setNovaCompra] = useState({
      data: new Date().toISOString().split('T')[0],
      descricao: '',
      itens: []
    });
    const [novoItem, setNovoItem] = useState({ nome: '', quantidade: '', unidade: '', valorUnit: '' });

    const fmtBRL = (v) => 'R$ ' + (v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const fmtData = (d) => d ? parseLocalDate(d).toLocaleDateString('pt-BR') : '—';
    const totalCompra = (itens) => (itens || []).reduce((t, i) => t + ((parseFloat(i.quantidade) || 0) * (parseFloat(i.valorUnit) || 0)), 0);
    const totalGasto = compras.reduce((t, c) => t + (c.total || 0), 0);
    const orcMat = obra?.orcamentoMateriais || 0;
    const orcMaoObra = obra?.orcamentoMaoDeObra || 0;

    useEffect(() => {
      if (!obra?.id) return;
      const carregarCompras = async () => {
        setCarregandoCompras(true);
        try {
          const { data, error } = await supabase
            .from('compras_materiais')
            .select('*')
            .eq('obra_id', obra.id)
            .order('data', { ascending: false });
          if (!error && data) setCompras(data.map(c => ({ ...c, itens: c.itens || [] })));
        } catch(e) {}
        setCarregandoCompras(false);
      };
      carregarCompras();
    }, [obra?.id]);

    const carregarCompras = async () => {
      setCarregandoCompras(true);
      try {
        const { data, error } = await supabase
          .from('compras_materiais')
          .select('*')
          .eq('obra_id', obra.id)
          .order('data', { ascending: false });
        if (!error && data) setCompras(data.map(c => ({ ...c, itens: c.itens || [] })));
      } catch(e) {}
      setCarregandoCompras(false);
    };

    const adicionarItem = () => {
      if (!novoItem.nome || !novoItem.quantidade || !novoItem.valorUnit) return;
      setNovaCompra(prev => ({
        ...prev,
        itens: [...prev.itens, { ...novoItem, id: Date.now() }]
      }));
      setNovoItem({ nome: '', quantidade: '', unidade: '', valorUnit: '' });
    };

    const removerItem = (id) => setNovaCompra(prev => ({ ...prev, itens: prev.itens.filter(i => i.id !== id) }));

    const salvarCompra = async () => {
      if (!novaCompra.descricao || novaCompra.itens.length === 0) return;
      setSalvandoCompra(true);
      const total = totalCompra(novaCompra.itens);
      try {
        if (compraEmEdicao) {
          await supabase.from('compras_materiais').update({
            data: novaCompra.data,
            descricao: novaCompra.descricao,
            itens: novaCompra.itens,
            total
          }).eq('id', compraEmEdicao);
        } else {
          await supabase.from('compras_materiais').insert({
            obra_id: obra.id,
            data: novaCompra.data,
            descricao: novaCompra.descricao,
            itens: novaCompra.itens,
            total
          });
        }
        await carregarCompras();
        setModalNovaCompra(false);
        setCompraEmEdicao(null);
        setNovaCompra({ data: new Date().toISOString().split('T')[0], descricao: '', itens: [] });
      } catch(e) {}
      setSalvandoCompra(false);
    };

    const excluirCompra = async (id) => {
      await supabase.from('compras_materiais').delete().eq('id', id);
      setExcluindoCompra(null);
      await carregarCompras();
    };

    const abrirEdicaoCompra = (compra) => {
      setNovaCompra({ data: compra.data || '', descricao: compra.descricao || '', itens: compra.itens || [] });
      setCompraEmEdicao(compra.id);
      setModalNovaCompra(true);
    };

    const salvarOrcamentosMateriais = async () => {
      const mat = parseFloat(novoOrcMat) || 0;
      const mao = parseFloat(novoOrcMaoObra) || 0;
      await supabase.from('obras').update({ orcamento_materiais: mat, orcamento_mao_de_obra: mao }).eq('id', obra.id);
      atualizarObraLocal(obra.id, { orcamentoMateriais: mat, orcamentoMaoDeObra: mao });
      setEditandoOrcMat(false);
    };

    const saldo = orcMat - totalGasto;
    const pctUsado = orcMat > 0 ? Math.min((totalGasto / orcMat) * 100, 100) : 0;

    // ── VISÃO CLIENTE: só mostra orçamentos contratuais ─────────────────
    if (!isPrestador) {
      return (
        <div className="bg-gray-900/80 rounded-2xl border border-gray-800 p-6">
          <div className="flex items-center gap-2 mb-5">
            <span className="w-1 h-5 bg-orange-500 rounded-full"/>
            <h3 className="text-sm font-semibold text-white">Composição do Contrato</h3>
          </div>
          {(orcMat === 0 && orcMaoObra === 0) ? (
            <p className="text-sm text-gray-500 text-center py-6">Valores do contrato não informados ainda.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="bg-gray-900 rounded-xl border border-gray-800 p-4">
                <div className="flex items-center gap-2 mb-2">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
                  </svg>
                  <span className="text-xs font-medium text-gray-400">Valor de Material (Contrato)</span>
                </div>
                <p className="text-xl font-bold text-orange-400">{fmtBRL(orcMat)}</p>
              </div>
              <div className="bg-gray-900 rounded-xl border border-gray-800 p-4">
                <div className="flex items-center gap-2 mb-2">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                  <span className="text-xs font-medium text-gray-400">Valor de Mão de Obra (Contrato)</span>
                </div>
                <p className="text-xl font-bold text-orange-400">{fmtBRL(orcMaoObra)}</p>
              </div>
            </div>
          )}
        </div>
      );
    }

    // ── VISÃO PRESTADOR: controle completo ───────────────────────────────
    return (
      <div className="space-y-4">

        {/* Resumo de orçamento */}
        <div className="bg-gray-900/80 rounded-2xl border border-orange-500/20 p-5">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <span className="w-1 h-5 bg-orange-500 rounded-full"/>
              <h3 className="text-sm font-semibold text-white">Controle de Materiais</h3>
              <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-orange-500/15 text-orange-400 border border-orange-500/25">Restrito ao Prestador</span>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setModalNovaCompra(true)}
                className="flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-xs font-medium rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all"
              >
                <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                </svg>
                Nova Compra
              </button>
              <button
                onClick={() => { setNovoOrcMat(String(orcMat)); setNovoOrcMaoObra(String(orcMaoObra)); setEditandoOrcMat(true); }}
                className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-700/60 text-gray-300 text-xs rounded-xl hover:bg-gray-700 transition-colors border border-gray-600/60"
              >
                <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                </svg>
                Orçamentos do Contrato
              </button>
            </div>
          </div>

          {/* Cards de resumo */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
            <div className="bg-gray-900 rounded-xl border border-gray-800 p-3">
              <p className="text-xs text-gray-500 mb-1">Orçamento Material (Contrato)</p>
              <p className="text-sm font-bold text-white">{fmtBRL(orcMat)}</p>
            </div>
            <div className="bg-gray-900 rounded-xl border border-gray-800 p-3">
              <p className="text-xs text-gray-500 mb-1">Total Comprado Real</p>
              <p className="text-sm font-bold text-orange-400">{fmtBRL(totalGasto)}</p>
            </div>
            <div className="bg-gray-900 rounded-xl border border-gray-800 p-3">
              <p className="text-xs text-gray-500 mb-1">Saldo de Material</p>
              <p className={`text-sm font-bold ${saldo >= 0 ? 'text-green-400' : 'text-red-400'}`}>{fmtBRL(saldo)}</p>
            </div>
            <div className="bg-gray-900 rounded-xl border border-gray-800 p-3">
              <p className="text-xs text-gray-500 mb-1">Mão de Obra (Contrato)</p>
              <p className="text-sm font-bold text-white">{fmtBRL(orcMaoObra)}</p>
            </div>
          </div>

          {/* Barra de consumo */}
          {orcMat > 0 && (
            <div>
              <div className="flex justify-between text-xs text-gray-500 mb-1">
                <span>Consumo do orçamento de materiais</span>
                <span className={pctUsado >= 90 ? 'text-red-400 font-semibold' : pctUsado >= 70 ? 'text-amber-400' : 'text-green-400'}>{pctUsado.toFixed(1)}%</span>
              </div>
              <div className="w-full h-2 bg-gray-700 rounded-full overflow-hidden">
                <div
                  className={`h-full rounded-full transition-all ${pctUsado >= 90 ? 'bg-red-500' : pctUsado >= 70 ? 'bg-amber-500' : 'bg-green-500'}`}
                  style={{ width: `${pctUsado}%` }}
                />
              </div>
            </div>
          )}

          {/* Margem impacto */}
          {totalGasto > 0 && orcMat > 0 && (
            <div className="mt-3 p-3 bg-orange-500/10 rounded-xl border border-orange-500/20">
              <p className="text-xs text-gray-400">
                <span className="text-orange-400 font-semibold">💡 Impacto na Margem: </span>
                {saldo >= 0
                  ? `Economia de ${fmtBRL(saldo)} em materiais — margem potencialmente aumentada.`
                  : `Estouro de ${fmtBRL(Math.abs(saldo))} em materiais — margem reduzida. Revise orçamento.`
                }
              </p>
            </div>
          )}
        </div>

        {/* Lista de compras */}
        <div className="bg-gray-900/80 rounded-2xl border border-gray-800 p-5">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-1 h-5 bg-orange-500 rounded-full"/>
            <h3 className="text-sm font-semibold text-white">Histórico de Compras</h3>
            <span className="text-xs text-gray-500">{compras.length} {compras.length === 1 ? 'registro' : 'registros'}</span>
          </div>

          {carregandoCompras ? (
            <div className="text-center py-8 text-gray-500 text-sm">Carregando...</div>
          ) : compras.length === 0 ? (
            <div className="text-center py-10">
              <svg className="w-12 h-12 text-gray-600 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
              </svg>
              <p className="text-gray-500 text-sm">Nenhuma compra registrada ainda.</p>
              <p className="text-gray-600 text-xs mt-1">Clique em "Nova Compra" para registrar.</p>
            </div>
          ) : (
            <div className="space-y-3">
              {compras.map((compra) => (
                <div key={compra.id} className="bg-gray-800/60 border border-gray-800 rounded-xl p-4 hover:border-orange-500/30 transition-colors">
                  <div className="flex justify-between items-start mb-3">
                    <div>
                      <div className="flex items-center gap-2 mb-1">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="4" width="18" height="16" rx="2"/>
                          <line x1="3" y1="9" x2="21" y2="9"/>
                          <line x1="8" y1="2" x2="8" y2="6"/>
                          <line x1="16" y1="2" x2="16" y2="6"/>
                        </svg>
                        <span className="text-xs text-gray-400">{fmtData(compra.data)}</span>
                      </div>
                      <p className="text-sm font-semibold text-white">{compra.descricao}</p>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-bold text-orange-400">{fmtBRL(compra.total)}</span>
                      <button onClick={() => abrirEdicaoCompra(compra)} className="p-1.5 rounded-lg text-gray-500 hover:text-orange-400 hover:bg-orange-500/10 transition-colors">
                        <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                          <path d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                        </svg>
                      </button>
                      <button onClick={() => setExcluindoCompra(compra.id)} className="p-1.5 rounded-lg text-gray-500 hover:text-red-400 hover:bg-red-500/10 transition-colors">
                        <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                          <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                  {/* Itens */}
                  {compra.itens && compra.itens.length > 0 && (
                    <div className="overflow-x-auto">
                      <table className="w-full text-xs">
                        <thead>
                          <tr className="text-gray-500 border-b border-gray-800">
                            <th className="text-left pb-1.5 font-medium">Material</th>
                            <th className="text-center pb-1.5 font-medium">Qtd</th>
                            <th className="text-center pb-1.5 font-medium">Un.</th>
                            <th className="text-right pb-1.5 font-medium">Vl. Unit.</th>
                            <th className="text-right pb-1.5 font-medium">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {compra.itens.map((item, idx) => (
                            <tr key={idx} className="border-b border-gray-800/60 last:border-0">
                              <td className="py-1.5 text-gray-300">{item.nome}</td>
                              <td className="py-1.5 text-center text-gray-400">{item.quantidade}</td>
                              <td className="py-1.5 text-center text-gray-400">{item.unidade || '—'}</td>
                              <td className="py-1.5 text-right text-gray-400">{fmtBRL(parseFloat(item.valorUnit) || 0)}</td>
                              <td className="py-1.5 text-right text-orange-400 font-medium">{fmtBRL((parseFloat(item.quantidade) || 0) * (parseFloat(item.valorUnit) || 0))}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* ── Modal Nova/Editar Compra ── */}
        {modalNovaCompra && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/70 " onClick={() => { setModalNovaCompra(false); setCompraEmEdicao(null); setNovaCompra({ data: new Date().toISOString().split('T')[0], descricao: '', itens: [] }); }}/>
            <div className="relative z-10 w-full max-w-2xl bg-gray-900 border border-gray-800 rounded-2xl shadow-2xl overflow-hidden max-h-[90vh] flex flex-col">

              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-800 flex-shrink-0">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-orange-500/15 rounded-xl">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-white">{compraEmEdicao ? 'Editar Compra' : 'Nova Compra de Materiais'}</h3>
                    <p className="text-xs text-gray-400">Registre os materiais adquiridos</p>
                  </div>
                </div>
                <button onClick={() => { setModalNovaCompra(false); setCompraEmEdicao(null); setNovaCompra({ data: new Date().toISOString().split('T')[0], descricao: '', itens: [] }); }} className="p-2 hover:bg-gray-800 rounded-xl text-gray-400 hover:text-white transition-colors">
                  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M6 18L18 6M6 6l12 12"/></svg>
                </button>
              </div>

              <div className="overflow-y-auto flex-1 px-6 py-5 space-y-4">

                {/* Data + Descrição */}
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs font-medium text-gray-400 mb-1.5">Data da Compra</label>
                    <input type="date" value={novaCompra.data} onChange={e => setNovaCompra(p => ({ ...p, data: e.target.value }))}
                      className="w-full px-3 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm focus:border-orange-500 focus:outline-none transition"/>
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-400 mb-1.5">Descrição <span className="text-orange-500">*</span></label>
                    <input type="text" value={novaCompra.descricao} onChange={e => setNovaCompra(p => ({ ...p, descricao: e.target.value }))}
                      placeholder="Ex: Materiais Iniciais — Fundação"
                      className="w-full px-3 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-500 focus:border-orange-500 focus:outline-none transition"/>
                  </div>
                </div>

                {/* Adicionar item */}
                <div className="bg-gray-800/60 rounded-xl border border-gray-800 p-4">
                  <p className="text-xs font-medium text-gray-400 mb-3">Adicionar Material</p>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-2">
                    <div className="col-span-2 sm:col-span-1">
                      <input type="text" value={novoItem.nome} onChange={e => setNovoItem(p => ({ ...p, nome: e.target.value }))}
                        placeholder="Nome do material" className="w-full px-3 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white text-xs placeholder-gray-500 focus:border-orange-500 focus:outline-none"/>
                    </div>
                    <div>
                      <input type="number" value={novoItem.quantidade} onChange={e => setNovoItem(p => ({ ...p, quantidade: e.target.value }))}
                        placeholder="Qtd" className="w-full px-3 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white text-xs placeholder-gray-500 focus:border-orange-500 focus:outline-none"/>
                    </div>
                    <div>
                      <input type="text" value={novoItem.unidade} onChange={e => setNovoItem(p => ({ ...p, unidade: e.target.value }))}
                        placeholder="Un. (m², kg...)" className="w-full px-3 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white text-xs placeholder-gray-500 focus:border-orange-500 focus:outline-none"/>
                    </div>
                    <div>
                      <input type="number" value={novoItem.valorUnit} onChange={e => setNovoItem(p => ({ ...p, valorUnit: e.target.value }))}
                        placeholder="R$ unit." className="w-full px-3 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white text-xs placeholder-gray-500 focus:border-orange-500 focus:outline-none"/>
                    </div>
                  </div>
                  <button onClick={adicionarItem} disabled={!novoItem.nome || !novoItem.quantidade || !novoItem.valorUnit}
                    className="flex items-center gap-1.5 px-3 py-1.5 bg-orange-500/20 text-orange-400 border border-orange-500/30 text-xs rounded-lg hover:bg-orange-500/30 transition-colors disabled:opacity-40 disabled:cursor-not-allowed">
                    <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                    Adicionar Item
                  </button>
                </div>

                {/* Lista de itens */}
                {novaCompra.itens.length > 0 && (
                  <div className="border border-gray-800 rounded-xl overflow-hidden">
                    <table className="w-full text-xs">
                      <thead className="bg-gray-800/60">
                        <tr className="text-gray-500">
                          <th className="text-left p-2.5 font-medium">Material</th>
                          <th className="text-center p-2.5 font-medium">Qtd</th>
                          <th className="text-center p-2.5 font-medium">Un.</th>
                          <th className="text-right p-2.5 font-medium">Vl. Unit.</th>
                          <th className="text-right p-2.5 font-medium">Total</th>
                          <th className="p-2.5"/>
                        </tr>
                      </thead>
                      <tbody>
                        {novaCompra.itens.map((item) => (
                          <tr key={item.id} className="border-t border-gray-800/60">
                            <td className="p-2.5 text-gray-300">{item.nome}</td>
                            <td className="p-2.5 text-center text-gray-400">{item.quantidade}</td>
                            <td className="p-2.5 text-center text-gray-400">{item.unidade || '—'}</td>
                            <td className="p-2.5 text-right text-gray-400">{fmtBRL(parseFloat(item.valorUnit) || 0)}</td>
                            <td className="p-2.5 text-right text-orange-400 font-medium">{fmtBRL((parseFloat(item.quantidade) || 0) * (parseFloat(item.valorUnit) || 0))}</td>
                            <td className="p-2.5 text-center">
                              <button onClick={() => removerItem(item.id)} className="text-gray-600 hover:text-red-400 transition-colors">
                                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot className="bg-gray-800/40">
                        <tr>
                          <td colSpan={4} className="p-2.5 text-right text-xs font-semibold text-gray-400">Total da Compra:</td>
                          <td className="p-2.5 text-right text-sm font-bold text-orange-400">{fmtBRL(totalCompra(novaCompra.itens))}</td>
                          <td/>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className="flex gap-3 px-6 py-4 border-t border-gray-800 flex-shrink-0">
                <button onClick={() => { setModalNovaCompra(false); setCompraEmEdicao(null); setNovaCompra({ data: new Date().toISOString().split('T')[0], descricao: '', itens: [] }); }}
                  className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-xl hover:border-gray-600 transition-all">
                  Cancelar
                </button>
                <button onClick={salvarCompra} disabled={salvandoCompra || !novaCompra.descricao || novaCompra.itens.length === 0}
                  className="flex-1 px-4 py-2.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-medium rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-2">
                  {salvandoCompra ? (
                    <><svg className="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none"><circle className="opacity-50" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/></svg>Salvando...</>
                  ) : (
                    <><svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"/></svg>{compraEmEdicao ? 'Salvar Alterações' : 'Registrar Compra'}</>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal orçamentos do contrato */}
        {editandoOrcMat && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/70 " onClick={() => setEditandoOrcMat(false)}/>
            <div className="relative z-10 w-full max-w-md bg-gray-900 border border-gray-800 rounded-2xl shadow-2xl p-6">
              <h3 className="text-sm font-semibold text-white mb-4">Valores do Contrato (visível ao cliente)</h3>
              <div className="space-y-3 mb-4">
                <div>
                  <label className="block text-xs font-medium text-gray-400 mb-1.5">Valor de Material (contrato com cliente)</label>
                  <input type="number" value={novoOrcMat} onChange={e => setNovoOrcMat(e.target.value)}
                    placeholder="Ex: 25000" className="w-full px-3 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm focus:border-orange-500 focus:outline-none"/>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-400 mb-1.5">Valor de Mão de Obra (contrato com cliente)</label>
                  <input type="number" value={novoOrcMaoObra} onChange={e => setNovoOrcMaoObra(e.target.value)}
                    placeholder="Ex: 19000" className="w-full px-3 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm focus:border-orange-500 focus:outline-none"/>
                </div>
                <p className="text-xs text-gray-500">💡 Esses valores são exibidos no painel do cliente. Os custos reais de compra só aparecem para o prestador.</p>
              </div>
              <div className="flex gap-3">
                <button onClick={() => setEditandoOrcMat(false)} className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-xl hover:border-gray-600 transition-all">Cancelar</button>
                <button onClick={salvarOrcamentosMateriais} className="flex-1 px-4 py-2.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-medium rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all">Salvar</button>
              </div>
            </div>
          </div>
        )}

        {/* Confirmar exclusão */}
        {excluindoCompra && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/70 " onClick={() => setExcluindoCompra(null)}/>
            <div className="relative z-10 w-full max-w-sm bg-gray-900 border border-gray-800 rounded-2xl p-6 text-center">
              <svg className="w-10 h-10 text-red-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
              </svg>
              <p className="text-white font-semibold mb-1">Excluir compra?</p>
              <p className="text-gray-400 text-sm mb-5">Esta ação não pode ser desfeita.</p>
              <div className="flex gap-3">
                <button onClick={() => setExcluindoCompra(null)} className="flex-1 px-4 py-2 bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-xl hover:border-gray-600 transition">Cancelar</button>
                <button onClick={() => excluirCompra(excluindoCompra)} className="flex-1 px-4 py-2 bg-red-500/20 border border-red-500/40 text-red-400 text-sm rounded-xl hover:bg-red-500/30 transition font-medium">Excluir</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  // ═══════════════════════════════════════════════════════════════
  // Controle de Prestadores — somente Prestador
  // ═══════════════════════════════════════════════════════════════
  const ControlePrestadoresTab = ({ obras, obraAtual }) => {
    const [vista,           setVista]           = useState('cards');
    const [filtroObraId,    setFiltroObraId]    = useState(obraAtual?.id || 'todas');
    const [filtroPrestador, setFiltroPrestador] = useState('');
    const [filtroStatusFin, setFiltroStatusFin] = useState('todos');
    const [filtroStatusPrazo,setFiltroStatusPrazo]= useState('todos');

    // ── Edição inline ──────────────────────────────────────────
    const [editandoKey,  setEditandoKey]  = useState(null);   // key da linha em edição
    const [formEdicao,   setFormEdicao]   = useState({});     // campos do form
    const [salvando,     setSalvando]     = useState(false);

    const abrirEdicao = (l) => {
      setEditandoKey(l.key);
      setFormEdicao({
        nomePrestador:       l.prestador === '—' ? '' : l.prestador,
        contratado:          String(l.contratado || ''),
        pago:                String(l.pago || ''),
        dataInicioAcordada:  l.dataInicio  || '',
        dataEntregaAcordada: l.dataEntrega || '',
      });
    };

    const fecharEdicao = () => { setEditandoKey(null); setFormEdicao({}); };

    const salvarEdicao = async (servicoId) => {
      setSalvando(true);
      const contratado = parseFloat(formEdicao.contratado) || 0;
      const pago       = parseFloat(formEdicao.pago)       || 0;
      await supabase.from('servicos').update({
        nome_prestador:         formEdicao.nomePrestador        || null,
        valor_custo_contratado: contratado,
        valor_pago_etapa:       pago,
        custo:                  contratado,
        data_inicio_acordada:   formEdicao.dataInicioAcordada   || null,
        data_entrega_acordada:  formEdicao.dataEntregaAcordada  || null,
      }).eq('id', servicoId);
      if (obraAtual) {
        atualizarServicoLocal(obraAtual.id, servicoId, {
          nomePrestador: formEdicao.nomePrestador || '',
          valorCustoContratado: contratado,
          valorPago: pago,
          dataInicioAcordada: formEdicao.dataInicioAcordada || null,
          dataEntregaAcordada: formEdicao.dataEntregaAcordada || null,
        });
      }
      setSalvando(false);
      fecharEdicao();
    };

    // ── Formatação ──────────────────────────────────────────────
    const fmtBRL  = (v) => v !== null && v !== undefined
      ? v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 0, maximumFractionDigits: 0 })
      : '—';
    const fmtData = (d) => d ? new Date(d + 'T12:00:00').toLocaleDateString('pt-BR') : '—';

    // ── Build flat list ──────────────────────────────────────────
    const todasLinhas = useMemo(() => {
      const hoje = new Date(); hoje.setHours(0,0,0,0);
      const result = [];
      obras.forEach(obra => {
        obra.servicos.forEach(s => {
          const contratado = s.valorCustoContratado || 0;
          const pago       = s.valorPago || 0;
          const saldo      = contratado - pago;
          const pctPago    = contratado > 0 ? (pago / contratado) * 100 : 0;

          let statusFin;
          if (pago > contratado && contratado > 0)   statusFin = 'ALERTA';
          else if (pctPago >= 100 && contratado > 0) statusFin = 'QUITADO';
          else if (pctPago > 0)                      statusFin = 'PARCIAL';
          else                                        statusFin = 'PENDENTE';

          let statusPrazo = 'SEM_DATA';
          if (s.dataEntregaAcordada) {
            const entrega  = new Date(s.dataEntregaAcordada + 'T12:00:00');
            const diffDias = Math.floor((entrega - hoje) / 86400000);
            if (s.status === 'concluido') statusPrazo = 'CONCLUIDO';
            else if (diffDias < 0)        statusPrazo = 'ATRASADO';
            else if (diffDias <= 5)       statusPrazo = 'PROXIMO';
            else                          statusPrazo = 'OK';
          }

          result.push({
            key: `${obra.id}-${s.id}`,
            obraId: obra.id, obraNome: obra.nome,
            servicoId: s.id, etapa: s.nome,
            prestador: s.nomePrestador || '—',
            contratado, pago, saldo, pctPago,
            statusFin, statusPrazo,
            dataInicio:  s.dataInicioAcordada,
            dataEntrega: s.dataEntregaAcordada,
            statusEtapa: s.status,
          });
        });
      });
      return result;
    }, [obras]);

    const linhas = todasLinhas.filter(l => {
      if (filtroObraId !== 'todas' && l.obraId !== filtroObraId) return false;
      if (filtroPrestador && !l.prestador.toLowerCase().includes(filtroPrestador.toLowerCase())) return false;
      if (filtroStatusFin !== 'todos'   && l.statusFin   !== filtroStatusFin)   return false;
      if (filtroStatusPrazo !== 'todos' && l.statusPrazo !== filtroStatusPrazo) return false;
      return true;
    });

    // ── Totais ──────────────────────────────────────────────────
    const totalContratado = linhas.reduce((t, l) => t + l.contratado, 0);
    const totalPago       = linhas.reduce((t, l) => t + l.pago,       0);
    const totalAPagar     = linhas.reduce((t, l) => t + Math.max(0, l.saldo), 0);
    const prestAtivos     = new Set(linhas.filter(l => l.statusFin !== 'QUITADO' && l.prestador !== '—').map(l => l.prestador)).size;
    const comAtraso       = linhas.filter(l => l.statusPrazo === 'ATRASADO').length;

    // ── Ícones SVG ──────────────────────────────────────────────
    const IcoCheck  = ({c='#22c55e'})    => <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke={c} strokeWidth={2.5} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"/></svg>;
    const IcoWarn   = ({c='#eab308'})    => <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke={c} strokeWidth={2}   viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/></svg>;
    const IcoCrit   = ({c='#ef4444'})    => <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke={c} strokeWidth={2}   viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>;
    const IcoClock  = ({c='currentColor'})=> <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke={c} strokeWidth={2}   viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>;
    const IcoUser   = ({c='currentColor'})=> <svg className="w-4 h-4 flex-shrink-0"    fill="none" stroke={c} strokeWidth={2}   viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/></svg>;
    const IcoPencil = ({c='currentColor'})=> <svg className="w-3.5 h-3.5"              fill="none" stroke={c} strokeWidth={2}   viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>;
    const IcoTable  = ({c='currentColor'})=> <svg className="w-4 h-4"                  fill="none" stroke={c} strokeWidth={2}   viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M3 14h18M10 4v16M4 4h16a1 1 0 011 1v14a1 1 0 01-1 1H4a1 1 0 01-1-1V5a1 1 0 011-1z"/></svg>;
    const IcoGrid   = ({c='currentColor'})=> <svg className="w-4 h-4"                  fill="none" stroke={c} strokeWidth={2}   viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"/></svg>;
    const IcoSave   = ({c='currentColor'})=> <svg className="w-3.5 h-3.5"              fill="none" stroke={c} strokeWidth={2}   viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"/></svg>;

    // ── Badges ──────────────────────────────────────────────────
    const BadgeFin = ({ st }) => {
      const cfg = {
        QUITADO:  { label: 'Quitado',  cls: 'text-green-400  bg-green-500/15  border-green-500/30',   ico: <IcoCheck/> },
        PARCIAL:  { label: 'Parcial',  cls: 'text-yellow-400 bg-yellow-500/15 border-yellow-500/30',  ico: <IcoWarn c='#eab308'/> },
        PENDENTE: { label: 'Pendente', cls: 'text-gray-400   bg-gray-500/15   border-gray-500/30',    ico: <IcoClock c='#64748b'/> },
        ALERTA:   { label: 'Alerta',   cls: 'text-red-400    bg-red-500/15    border-red-500/30',     ico: <IcoCrit/> },
      };
      const { label, cls, ico } = cfg[st] || cfg.PENDENTE;
      return <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold border ${cls}`}>{ico}{label}</span>;
    };

    const BadgePrazo = ({ st }) => {
      const cfg = {
        OK:        { label: 'No prazo',  cls: 'text-green-400  bg-green-500/15  border-green-500/30',  ico: <IcoCheck/> },
        PROXIMO:   { label: 'Próximo',   cls: 'text-yellow-400 bg-yellow-500/15 border-yellow-500/30', ico: <IcoWarn c='#eab308'/> },
        ATRASADO:  { label: 'Atrasado',  cls: 'text-red-400    bg-red-500/15    border-red-500/30',    ico: <IcoCrit/> },
        CONCLUIDO: { label: 'Concluído', cls: 'text-blue-400   bg-blue-500/15   border-blue-500/30',   ico: <IcoCheck c='#60a5fa'/> },
        SEM_DATA:  { label: 'Sem data',  cls: 'text-gray-600   bg-gray-800/60   border-gray-800',   ico: <span className="text-gray-600 text-xs">—</span> },
      };
      const { label, cls, ico } = cfg[st] || cfg.SEM_DATA;
      return <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold border ${cls}`}>{ico}{label}</span>;
    };

    // ── Summary Card ─────────────────────────────────────────────
    const SCard = ({ icone, label, valor, corValor, destaque }) => (
      <div className={`bg-gray-800/60 rounded-2xl p-4 border transition-all ${destaque ? 'border-red-500/40 bg-red-500/5' : 'border-gray-800'}`}>
        <div className="flex items-center gap-2 mb-2">{icone}<p className="text-xs text-gray-500 font-light">{label}</p></div>
        <p className={`text-lg font-bold ${corValor}`}>{valor}</p>
      </div>
    );

    const IcoMoeda  = ({c}) => <svg className="w-4 h-4" fill="none" stroke={c} strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>;
    const IcoUsers  = ({c}) => <svg className="w-4 h-4" fill="none" stroke={c} strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/></svg>;
    const IcoAlerta = ({c}) => <svg className="w-4 h-4" fill="none" stroke={c} strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/></svg>;
    const IcoPago   = ({c}) => <svg className="w-4 h-4" fill="none" stroke={c} strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/></svg>;
    const IcoPagar  = ({c}) => <svg className="w-4 h-4" fill="none" stroke={c} strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z"/></svg>;

    // ── Input padrão do modal ────────────────────────────────────
    // ── Preview cálculo dentro do modal ─────────────────────────
    const previewContratado = parseFloat(formEdicao.contratado) || 0;
    const previewPago       = parseFloat(formEdicao.pago)       || 0;
    const previewSaldo      = previewContratado - previewPago;
    const previewPct        = previewContratado > 0 ? (previewPago / previewContratado) * 100 : 0;
    const previewBarC       = previewPago > previewContratado ? '#ef4444' : previewPct >= 100 ? '#22c55e' : previewPct > 0 ? '#eab308' : '#475569';

    return (
      <div className="space-y-5">

        {/* ── MODAL DE EDIÇÃO ─────────────────────────────────── */}
        {editandoKey && (() => {
          const linhaSel = todasLinhas.find(l => l.key === editandoKey);
          if (!linhaSel) return null;
          return (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
              <div className="absolute inset-0 bg-black/70 " onClick={fecharEdicao}/>
              <div className="relative z-10 w-full max-w-lg bg-gray-900 border border-gray-800 rounded-2xl shadow-xl overflow-hidden">

                {/* Header */}
                <div className="flex items-center justify-between px-6 py-5 border-b border-gray-800">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-gradient-to-br from-orange-500 to-amber-500 rounded-xl">
                      <IcoPencil c='white'/>
                    </div>
                    <div>
                      <h2 className="text-base font-semibold text-white">Editar Prestador</h2>
                      <p className="text-xs text-gray-500 mt-0.5">{linhaSel.etapa} · {linhaSel.obraNome}</p>
                    </div>
                  </div>
                  <button onClick={fecharEdicao} className="p-1.5 hover:bg-gray-800 rounded-lg transition-colors">
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
                    </svg>
                  </button>
                </div>

                {/* Campos */}
                <div className="px-6 py-5 space-y-4 max-h-[70vh] overflow-y-auto">

                  {/* Identificação */}
                  <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">Identificação</p>
                    <div>
                      <label className="block text-xs font-medium text-gray-400 mb-1.5">
                        <span className="mr-1 text-orange-400">●</span>
                        Nome do Prestador
                      </label>
                      <input type="text"
                        value={formEdicao.nomePrestador}
                        onChange={e => setFormEdicao({...formEdicao, nomePrestador: e.target.value})}
                        placeholder="Ex: João Pedreiro"
                        className="w-full px-3 py-2 text-sm bg-gray-800 border border-gray-700 rounded-xl text-white placeholder-gray-600 focus:outline-none focus:border-orange-500 transition-colors"
                      />
                    </div>
                  </div>

                  <div className="border-t border-gray-800"/>

                  {/* Valores Financeiros */}
                  <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">Valores Financeiros</p>
                    <div className="space-y-3">
                      <div>
                        <label className="block text-xs font-medium text-gray-400 mb-1.5">
                          <span className="mr-1 text-amber-400">●</span>
                          Valor Contratado (R$)
                        </label>
                        <input type="number"
                          value={formEdicao.contratado}
                          onChange={e => setFormEdicao({...formEdicao, contratado: e.target.value})}
                          placeholder="Ex: 50000"
                          className="w-full px-3 py-2 text-sm bg-gray-800 border border-gray-700 rounded-xl text-white placeholder-gray-600 focus:outline-none focus:border-amber-500 transition-colors"
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-400 mb-1.5">
                          <span className="mr-1 text-green-400">●</span>
                          Valor Pago (R$)
                        </label>
                        <input type="number"
                          value={formEdicao.pago}
                          onChange={e => setFormEdicao({...formEdicao, pago: e.target.value})}
                          placeholder="Ex: 25000"
                          className="w-full px-3 py-2 text-sm bg-gray-800 border border-gray-700 rounded-xl text-white placeholder-gray-600 focus:outline-none focus:border-green-500 transition-colors"
                        />
                      </div>
                    </div>

                    {/* Preview financeiro */}
                    {previewContratado > 0 && (
                      <div className="mt-3 p-3 rounded-xl border" style={{ borderColor: previewBarC + '40', background: previewBarC + '10' }}>
                        <div className="flex justify-between text-xs mb-1.5">
                          <span className="text-gray-400">Progresso do pagamento</span>
                          <span className="font-bold" style={{ color: previewBarC }}>{previewPct.toFixed(1)}%</span>
                        </div>
                        <div className="w-full bg-gray-700/50 rounded-full h-1.5 mb-2">
                          <div className="h-1.5 rounded-full transition-all" style={{ width: `${Math.min(previewPct, 100)}%`, background: previewBarC }}/>
                        </div>
                        <div className="grid grid-cols-3 gap-2 text-xs text-center">
                          <div>
                            <p className="text-gray-500">Contratado</p>
                            <p className="font-semibold text-gray-300">{fmtBRL(previewContratado)}</p>
                          </div>
                          <div>
                            <p className="text-gray-500">Pago</p>
                            <p className="font-semibold text-green-400">{fmtBRL(previewPago)}</p>
                          </div>
                          <div>
                            <p className="text-gray-500">Saldo</p>
                            <p className={`font-semibold ${previewSaldo > 0 ? 'text-yellow-400' : 'text-gray-500'}`}>
                              {previewSaldo > 0 ? fmtBRL(previewSaldo) : '—'}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="border-t border-gray-800"/>

                  {/* Datas */}
                  <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">Prazo</p>
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="block text-xs font-medium text-gray-400 mb-1.5">{t('startDate')} Acordada</label>
                        <input type="date"
                          value={formEdicao.dataInicioAcordada}
                          onChange={e => setFormEdicao({...formEdicao, dataInicioAcordada: e.target.value})}
                          className="w-full px-3 py-2 text-sm bg-gray-800 border border-gray-700 rounded-xl text-white focus:outline-none focus:border-orange-500 transition-colors"
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-400 mb-1.5">Data de Entrega Acordada</label>
                        <input type="date"
                          value={formEdicao.dataEntregaAcordada}
                          onChange={e => setFormEdicao({...formEdicao, dataEntregaAcordada: e.target.value})}
                          className="w-full px-3 py-2 text-sm bg-gray-800 border border-gray-700 rounded-xl text-white focus:outline-none focus:border-orange-500 transition-colors"
                        />
                      </div>
                    </div>
                  </div>

                </div>

                {/* Footer */}
                <div className="flex gap-3 px-6 py-4 border-t border-gray-800">
                  <button onClick={fecharEdicao}
                    className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-xl hover:border-gray-600 hover:text-white transition-all">
                    Cancelar
                  </button>
                  <button onClick={() => salvarEdicao(linhaSel.servicoId)} disabled={salvando}
                    className="flex-1 px-4 py-2.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-medium rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all flex items-center justify-center gap-2 disabled:opacity-60">
                    {salvando
                      ? <><svg className="w-4 h-4 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/></svg>Salvando...</>
                      : <><IcoSave c='white'/>{t('save')}</>
                    }
                  </button>
                </div>

              </div>
            </div>
          );
        })()}

        {/* ── CARDS DE RESUMO ──────────────────────────────────── */}
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
          <SCard icone={<IcoMoeda  c='#f97316'/>} label="Total Contratado"   valor={fmtBRL(totalContratado)} corValor="text-orange-400"/>
          <SCard icone={<IcoPago   c='#22c55e'/>} label="Total Pago"         valor={fmtBRL(totalPago)}       corValor="text-green-400"/>
          <SCard icone={<IcoPagar  c='#eab308'/>} label="Total a Pagar"      valor={fmtBRL(totalAPagar)}     corValor="text-yellow-400"/>
          <SCard icone={<IcoUsers  c='#60a5fa'/>} label="Prestadores Ativos" valor={String(prestAtivos)}     corValor="text-blue-400"/>
          <SCard icone={<IcoAlerta c='#ef4444'/>} label="Com Atraso"         valor={String(comAtraso)}       corValor={comAtraso > 0 ? 'text-red-400' : 'text-gray-400'} destaque={comAtraso > 0}/>
        </div>

        {/* ── FILTROS ──────────────────────────────────────────── */}
        <div className="bg-gray-800/40 rounded-2xl border border-gray-800 p-4">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            <div>
              <label className="block text-xs text-gray-500 mb-1.5">Obra</label>
              <div className="relative">
                <select value={filtroObraId} onChange={e => setFiltroObraId(e.target.value)}
                  className="w-full appearance-none px-3 py-2 text-sm bg-gray-900 border border-gray-700 rounded-xl text-white focus:border-orange-500 focus:outline-none pr-8">
                  <option value="todas">Todas as obras</option>
                  {obras.map(o => <option key={o.id} value={o.id}>{o.nome}</option>)}
                </select>
                <svg className="absolute right-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7"/></svg>
              </div>
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1.5">Prestador</label>
              <input type="text" placeholder="Buscar prestador..." value={filtroPrestador}
                onChange={e => setFiltroPrestador(e.target.value)}
                className="w-full px-3 py-2 text-sm bg-gray-900 border border-gray-700 rounded-xl text-white placeholder-gray-600 focus:border-orange-500 focus:outline-none"/>
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1.5">Status Financeiro</label>
              <div className="relative">
                <select value={filtroStatusFin} onChange={e => setFiltroStatusFin(e.target.value)}
                  className="w-full appearance-none px-3 py-2 text-sm bg-gray-900 border border-gray-700 rounded-xl text-white focus:border-orange-500 focus:outline-none pr-8">
                  <option value="todos">Todos</option>
                  <option value="PENDENTE">{t('pending')}</option>
                  <option value="PARCIAL">Parcial</option>
                  <option value="QUITADO">Quitado</option>
                  <option value="ALERTA">Alerta</option>
                </select>
                <svg className="absolute right-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7"/></svg>
              </div>
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1.5">Status de Prazo</label>
              <div className="relative">
                <select value={filtroStatusPrazo} onChange={e => setFiltroStatusPrazo(e.target.value)}
                  className="w-full appearance-none px-3 py-2 text-sm bg-gray-900 border border-gray-700 rounded-xl text-white focus:border-orange-500 focus:outline-none pr-8">
                  <option value="todos">Todos</option>
                  <option value="OK">No prazo</option>
                  <option value="PROXIMO">Próximo do prazo</option>
                  <option value="ATRASADO">Atrasado</option>
                  <option value="CONCLUIDO">{t('concluded')}</option>
                  <option value="SEM_DATA">Sem data</option>
                </select>
                <svg className="absolute right-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7"/></svg>
              </div>
            </div>
          </div>
        </div>

        {/* ── TOGGLE VISTA ─────────────────────────────────────── */}
        <div className="flex items-center justify-between">
          <p className="text-xs text-gray-500">
            <span className="text-white font-semibold">{linhas.length}</span> etapa{linhas.length !== 1 ? 's' : ''} encontrada{linhas.length !== 1 ? 's' : ''}
          </p>
          <div className="flex gap-1 bg-gray-800/60 p-1 rounded-xl border border-gray-800">
            {[
              { id: 'tabela', ico: <IcoTable c={vista === 'tabela' ? 'white' : '#f97316'}/>, label: 'Tabela' },
              { id: 'cards',  ico: <IcoGrid  c={vista === 'cards'  ? 'white' : '#f97316'}/>, label: 'Cards'  },
            ].map(v => (
              <button key={v.id} onClick={() => setVista(v.id)}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${
                  vista === v.id ? 'bg-orange-500 text-white shadow' : 'text-gray-400 hover:text-white'
                }`}>
                {v.ico}{v.label}
              </button>
            ))}
          </div>
        </div>

        {/* ── VISTA TABELA ─────────────────────────────────────── */}
        {vista === 'tabela' && (
          <div className="bg-gray-800/40 rounded-2xl border border-gray-800 overflow-hidden">
            {linhas.length === 0 ? (
              <div className="text-center py-16 text-gray-500">
                <svg className="w-12 h-12 mx-auto mb-3 opacity-30" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
                <p className="text-sm">Nenhum resultado para os filtros aplicados</p>
                <p className="text-xs mt-1 text-gray-600">Cadastre prestadores nas etapas para visualizá-los aqui</p>
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-gray-800">
                      <th className="text-left px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Prestador</th>
                      <th className="text-left px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Etapa · Obra</th>
                      <th className="text-right px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Contratado</th>
                      <th className="text-right px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Pago</th>
                      <th className="text-right px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Saldo</th>
                      <th className="text-center px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">% Pago</th>
                      <th className="text-center px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Financeiro</th>
                      <th className="text-center px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Início</th>
                      <th className="text-center px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Entrega</th>
                      <th className="text-center px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Prazo</th>
                      <th className="text-center px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {linhas.map((l, i) => {
                      const barW = Math.min(l.pctPago, 100);
                      const barC = l.statusFin === 'QUITADO' ? '#22c55e' : l.statusFin === 'ALERTA' ? '#ef4444' : l.statusFin === 'PARCIAL' ? '#eab308' : '#475569';
                      return (
                        <tr key={l.key} className={`border-b border-gray-700/30 hover:bg-gray-700/20 transition-colors ${i % 2 === 0 ? '' : 'bg-gray-900/20'}`}>
                          <td className="px-4 py-3">
                            <div className="flex items-center gap-2">
                              <div className="w-7 h-7 rounded-full bg-orange-500/20 border border-orange-500/30 flex items-center justify-center flex-shrink-0">
                                <IcoUser c='#f97316'/>
                              </div>
                              <span className="text-white font-medium text-xs">{l.prestador}</span>
                            </div>
                          </td>
                          <td className="px-4 py-3">
                            <p className="text-white text-xs font-medium">{l.etapa}</p>
                            <p className="text-gray-500 text-xs mt-0.5 truncate max-w-[160px]">{l.obraNome}</p>
                          </td>
                          <td className="px-4 py-3 text-right">
                            <span className="text-gray-300 text-xs font-semibold">{fmtBRL(l.contratado)}</span>
                          </td>
                          <td className="px-4 py-3 text-right">
                            <span className="text-green-400 text-xs font-semibold">{fmtBRL(l.pago)}</span>
                          </td>
                          <td className="px-4 py-3 text-right">
                            <span className={`text-xs font-semibold ${l.saldo <= 0 ? 'text-gray-500' : 'text-yellow-400'}`}>
                              {l.saldo <= 0 ? '—' : fmtBRL(l.saldo)}
                            </span>
                          </td>
                          <td className="px-4 py-3">
                            <div className="w-20 mx-auto">
                              <span style={{ color: barC }} className="text-xs font-semibold">{l.pctPago.toFixed(0)}%</span>
                              <div className="w-full bg-gray-700/50 rounded-full h-1.5 mt-0.5">
                                <div className="h-1.5 rounded-full" style={{ width: `${barW}%`, background: barC }}/>
                              </div>
                            </div>
                          </td>
                          <td className="px-4 py-3 text-center"><BadgeFin st={l.statusFin}/></td>
                          <td className="px-4 py-3 text-center"><span className="text-xs text-gray-400">{fmtData(l.dataInicio)}</span></td>
                          <td className="px-4 py-3 text-center"><span className="text-xs text-gray-400">{fmtData(l.dataEntrega)}</span></td>
                          <td className="px-4 py-3 text-center"><BadgePrazo st={l.statusPrazo}/></td>
                          <td className="px-4 py-3 text-center">
                            <button onClick={() => abrirEdicao(l)}
                              className="p-1.5 hover:bg-orange-500/20 border border-transparent hover:border-gray-700 rounded-lg transition-all group">
                              <IcoPencil c='#9ca3af'/>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr className="border-t-2 border-gray-600/60 bg-gray-900/40">
                      <td colSpan={2} className="px-4 py-3 text-xs font-semibold text-gray-400">Total ({linhas.length} etapas)</td>
                      <td className="px-4 py-3 text-right text-xs font-bold text-orange-400">{fmtBRL(totalContratado)}</td>
                      <td className="px-4 py-3 text-right text-xs font-bold text-green-400">{fmtBRL(totalPago)}</td>
                      <td className="px-4 py-3 text-right text-xs font-bold text-yellow-400">{fmtBRL(totalAPagar)}</td>
                      <td colSpan={6}/>
                    </tr>
                  </tfoot>
                </table>
              </div>
            )}
          </div>
        )}

        {/* ── VISTA CARDS ──────────────────────────────────────── */}
        {vista === 'cards' && (
          <div>
            {linhas.length === 0 ? (
              <div className="bg-gray-800/40 rounded-2xl border border-gray-800 text-center py-16 text-gray-500">
                <svg className="w-12 h-12 mx-auto mb-3 opacity-30" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
                <p className="text-sm">Nenhum resultado para os filtros aplicados</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
                {linhas.map(l => {
                  const barW = Math.min(l.pctPago, 100);
                  const barC = l.statusFin === 'QUITADO' ? '#22c55e' : l.statusFin === 'ALERTA' ? '#ef4444' : l.statusFin === 'PARCIAL' ? '#eab308' : '#475569';
                  return (
                    <div key={l.key} className="bg-gray-800/60 rounded-2xl border border-gray-800 p-4 hover:border-gray-700 transition-all group">

                      {/* Header do card */}
                      <div className="flex items-start justify-between mb-3">
                        <div className="flex items-center gap-2.5">
                          <div className="w-9 h-9 rounded-full bg-orange-500/20 border border-orange-500/30 flex items-center justify-center flex-shrink-0">
                            <IcoUser c='#f97316'/>
                          </div>
                          <div>
                            <p className="text-sm font-semibold text-white leading-tight">{l.prestador}</p>
                            <p className="text-xs text-gray-500 mt-0.5">{l.etapa}</p>
                            <p className="text-xs text-gray-600 truncate max-w-[140px]">{l.obraNome}</p>
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <BadgeFin st={l.statusFin}/>
                          {/* Botão editar */}
                          <button onClick={() => abrirEdicao(l)}
                            className="p-1.5 hover:bg-orange-500/20 border border-transparent hover:border-gray-700 rounded-lg transition-all opacity-0 group-hover:opacity-100">
                            <IcoPencil c='#f97316'/>
                          </button>
                        </div>
                      </div>

                      {/* Barra pagamento */}
                      <div className="mb-3">
                        <div className="flex justify-between text-xs mb-1">
                          <span className="text-gray-500">Pagamento</span>
                          <span className="font-semibold" style={{ color: barC }}>{l.pctPago.toFixed(1)}%</span>
                        </div>
                        <div className="w-full bg-gray-700/50 rounded-full h-2 overflow-hidden">
                          <div className="h-2 rounded-full transition-all duration-500 relative" style={{ width: `${barW}%`, background: barC }}>
                            <div className="absolute inset-0 bg-white/10 rounded-full"/>
                          </div>
                        </div>
                      </div>

                      {/* Valores */}
                      <div className="grid grid-cols-3 gap-2 mb-3">
                        <div className="text-center bg-gray-800/60 rounded-xl p-2">
                          <p className="text-xs text-gray-600 mb-0.5">Contratado</p>
                          <p className="text-xs font-bold text-gray-300">{fmtBRL(l.contratado)}</p>
                        </div>
                        <div className="text-center bg-gray-800/60 rounded-xl p-2">
                          <p className="text-xs text-gray-600 mb-0.5">Pago</p>
                          <p className="text-xs font-bold text-green-400">{fmtBRL(l.pago)}</p>
                        </div>
                        <div className="text-center bg-gray-800/60 rounded-xl p-2">
                          <p className="text-xs text-gray-600 mb-0.5">Saldo</p>
                          <p className={`text-xs font-bold ${l.saldo > 0 ? 'text-yellow-400' : 'text-gray-500'}`}>
                            {l.saldo > 0 ? fmtBRL(l.saldo) : '—'}
                          </p>
                        </div>
                      </div>

                      {/* Datas + Prazo + Botão editar visível */}
                      <div className="flex items-center justify-between pt-2 border-t border-gray-800">
                        <div className="text-xs text-gray-500">
                          {l.dataEntrega ? (
                            <span className="flex items-center gap-1">
                              <IcoClock c='#64748b'/>
                              Entrega: <span className="text-gray-400">{fmtData(l.dataEntrega)}</span>
                            </span>
                          ) : (
                            <button onClick={() => abrirEdicao(l)}
                              className="flex items-center gap-1 text-orange-400/60 hover:text-orange-400 transition-colors">
                              <IcoPencil c='currentColor'/>
                              Definir prazo
                            </button>
                          )}
                        </div>
                        <BadgePrazo st={l.statusPrazo}/>
                      </div>

                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

      </div>
    );
  };

  const ExecutadoPagoSection = ({ obra }) => {
    if (!obra) return null;

    const fmtPct = (v) => v !== null && v !== undefined ? `${parseFloat(v).toFixed(2)}%` : '—';
    const fmtBRL2 = (v) => v !== null && v !== undefined
      ? v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })
      : '—';

    // ── Dados base ──────────────────────────────────────────────
    const valorContrato      = obra.valorContrato || 0;
    const valorRecebido      = obra.valorRecebido ?? null;
    const servicos           = obra.servicos || [];
    const totalPagoMO        = servicos.reduce((t, s) => t + (s.valorPago || 0), 0);
    const totalComprasMat    = comprasMatPorObra[obra.id] || 0;
    const totalPagoEtapas    = totalPagoMO + totalComprasMat; // MO + Materiais
    const configurado        = valorRecebido !== null && valorContrato > 0;

    // ── Percentuais ─────────────────────────────────────────────
    const pctExecutado  = parseFloat(calcularProgresso(obra).toFixed(2));
    const pctRecebido   = configurado ? parseFloat(Math.min((valorRecebido / valorContrato) * 100, 999).toFixed(2)) : null;
    const pctPago       = valorContrato > 0 ? parseFloat(((totalPagoEtapas / valorContrato) * 100).toFixed(2)) : null;

    // ── Diferenciais ────────────────────────────────────────────
    const difB1 = configurado ? parseFloat((pctExecutado - pctRecebido).toFixed(2)) : null;
    const difB2 = configurado && pctPago !== null ? parseFloat((pctRecebido - pctPago).toFixed(2)) : null;
    const saldoRS = configurado ? parseFloat((valorRecebido - totalPagoEtapas).toFixed(2)) : null;

    // ── Classificações ───────────────────────────────────────────
    const statusB1 = difB1 === null ? null : difB1 <= 5 ? 'VERDE' : difB1 <= 15 ? 'AMARELO' : 'VERMELHO';
    const statusB2 = difB2 === null ? null : difB2 >= 0 ? 'VERDE' : difB2 >= -5 ? 'AMARELO' : 'VERMELHO';
    const statusGeral = !configurado ? 'NEUTRO'
      : (statusB1 === 'VERMELHO' || statusB2 === 'VERMELHO') ? 'VERMELHO'
      : (statusB1 === 'AMARELO'  || statusB2 === 'AMARELO')  ? 'AMARELO'
      : 'VERDE';

    const cor = { VERDE: '#22c55e', AMARELO: '#eab308', VERMELHO: '#ef4444', NEUTRO: '#64748b' };
    const bg  = { VERDE: 'rgba(34,197,94,0.08)', AMARELO: 'rgba(234,179,8,0.08)', VERMELHO: 'rgba(239,68,68,0.08)', NEUTRO: 'rgba(100,116,139,0.06)' };
    const brd = { VERDE: 'rgba(34,197,94,0.25)', AMARELO: 'rgba(234,179,8,0.25)', VERMELHO: 'rgba(239,68,68,0.25)', NEUTRO: 'rgba(100,116,139,0.20)' };
    const corB1 = cor[statusB1 || 'NEUTRO'];
    const corB2 = cor[statusB2 || 'NEUTRO'];

    // ── Labels ──────────────────────────────────────────────────
    const labelB1 = difB1 === null ? '—' : difB1 < 0 ? 'Caixa Protegido' : difB1 <= 5 ? 'Equilíbrio Financeiro' : difB1 <= 15 ? 'Atenção ao Fluxo' : 'Financiando o Cliente';
    const labelB2 = difB2 === null ? '—' : difB2 >= 0 ? 'Operação Saudável' : difB2 >= -5 ? 'Atenção ao Caixa' : 'Risco de Caixa';

    // ── Textos ──────────────────────────────────────────────────
    const textoB1 = difB1 === null ? 'Configure o valor recebido para ativar a análise.'
      : difB1 < 0   ? `Você recebeu ${Math.abs(difB1).toFixed(2)}% a mais do que executou — caixa protegido.`
      : difB1 <= 5  ? `Execução e recebimento em equilíbrio (diferença de ${difB1.toFixed(2)}%).`
      : difB1 <= 15 ? `Você executou ${difB1.toFixed(2)}% além do recebido — monitorar o fluxo.`
      : `Você executou ${difB1.toFixed(2)}% além do recebido — está financiando o cliente.`;

    const textoB2 = difB2 === null ? 'Configure o valor recebido para ativar a análise.'
      : difB2 >= 10 ? `Saldo positivo de ${difB2.toFixed(2)}% — operação saudável. Verifique se não há retenção excessiva.`
      : difB2 >= 0  ? `Recebimento cobre os pagamentos — saldo positivo de ${difB2.toFixed(2)}%.`
      : difB2 >= -5 ? `Pagamentos superam recebimentos em ${Math.abs(difB2).toFixed(2)}% — atenção ao caixa.`
      : `Risco de caixa: você pagou ${Math.abs(difB2).toFixed(2)}% a mais do que recebeu.`;

    // ── Ícones SVG inline (padrão do sistema) ───────────────────
    const IcoEngrenagem = ({ c = 'currentColor' }) => (
      <svg className="w-3.5 h-3.5" fill="none" stroke={c} strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
      </svg>
    );
    const IcoMoeda = ({ c = 'currentColor' }) => (
      <svg className="w-3.5 h-3.5" fill="none" stroke={c} strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
      </svg>
    );
    const IcoPagamento = ({ c = 'currentColor' }) => (
      <svg className="w-3.5 h-3.5" fill="none" stroke={c} strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
      </svg>
    );
    const IcoCaixa = ({ c = 'currentColor' }) => (
      <svg className="w-3.5 h-3.5" fill="none" stroke={c} strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
      </svg>
    );
    const IcoTendencia = ({ c = 'currentColor' }) => (
      <svg className="w-3.5 h-3.5" fill="none" stroke={c} strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
      </svg>
    );
    const IcoCheck = ({ c = 'currentColor' }) => (
      <svg className="w-3.5 h-3.5" fill="none" stroke={c} strokeWidth={2.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"/>
      </svg>
    );
    const IcoWarn = ({ c = 'currentColor' }) => (
      <svg className="w-3.5 h-3.5" fill="none" stroke={c} strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
      </svg>
    );
    const IcoCrit = ({ c = 'currentColor' }) => (
      <svg className="w-3.5 h-3.5" fill="none" stroke={c} strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    );

    // ícone de status por cor
    const IcoStatus = ({ st }) => {
      if (st === 'VERDE')    return <IcoCheck   c="#22c55e"/>;
      if (st === 'AMARELO')  return <IcoWarn    c="#eab308"/>;
      if (st === 'VERMELHO') return <IcoCrit    c="#ef4444"/>;
      return <span className="text-gray-600 text-xs">—</span>;
    };

    // ── Helper: Barra comparativa ────────────────────────────────
    const BarraComparativa = ({ iconeA, labelA, valA, corA, iconeB, labelB, valB, corB }) => {
      const maxVal = Math.max(valA || 0, valB || 0, 1);
      const wA = valA !== null ? Math.min((valA / maxVal) * 100, 100) : 0;
      const wB = valB !== null ? Math.min((valB / maxVal) * 100, 100) : 0;
      return (
        <div className="space-y-2.5">
          <div>
            <div className="flex justify-between text-xs text-gray-400 mb-1">
              <span className="flex items-center gap-1.5">{iconeA}<span>{labelA}</span></span>
              <span style={{ color: corA }} className="font-semibold">{fmtPct(valA)}</span>
            </div>
            <div className="w-full bg-gray-700/60 rounded-full h-2.5 overflow-hidden">
              <div className="h-2.5 rounded-full transition-all duration-700 relative" style={{ width: `${wA}%`, background: corA }}>
                <div className="absolute inset-0 bg-white/10 rounded-full"/>
              </div>
            </div>
          </div>
          <div>
            <div className="flex justify-between text-xs text-gray-400 mb-1">
              <span className="flex items-center gap-1.5">{iconeB}<span>{labelB}</span></span>
              <span style={{ color: valB !== null ? corB : '#64748b' }} className="font-semibold">
                {valB !== null ? fmtPct(valB) : 'Não configurado'}
              </span>
            </div>
            <div className="w-full bg-gray-700/60 rounded-full h-2.5 overflow-hidden">
              {valB !== null ? (
                <div className="h-2.5 rounded-full transition-all duration-700 relative" style={{ width: `${wB}%`, background: corB }}>
                  <div className="absolute inset-0 bg-white/10 rounded-full"/>
                </div>
              ) : (
                <div className="h-2.5 rounded-full bg-gray-600/30 w-full"/>
              )}
            </div>
          </div>
        </div>
      );
    };

    // ── Resumo — item do topo ────────────────────────────────────
    const ResumoItem = ({ icone, label, value, corValor }) => (
      <div className="text-center">
        <div className="flex items-center justify-center gap-1 mb-0.5">{icone}<p className="text-xs text-gray-500 leading-tight">{label}</p></div>
        <p className="text-sm font-bold leading-tight" style={{ color: corValor }}>{value}</p>
      </div>
    );

    const corSaldo = saldoRS !== null ? (saldoRS >= 0 ? '#22c55e' : '#ef4444') : '#64748b';

    return (
      <div className="rounded-2xl border p-3.5 sm:p-5 mb-5 transition-all" style={{ background: bg[statusGeral], borderColor: brd[statusGeral] }}>

        {/* ── HEADER ─────────────────────────────────────────────── */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-4 sm:mb-5">
          <div className="flex items-center gap-2 flex-wrap min-w-0">
            <span className="w-1 h-5 rounded-full flex-shrink-0" style={{ background: cor[statusGeral] }}/>
            <h3 className="text-sm font-semibold text-white">Executado × Pago</h3>
            <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-orange-500/15 text-orange-400 border border-orange-500/25 hidden sm:inline">
              Restrito ao Prestador
            </span>
          </div>
          <button
            onClick={() => { setValorRecebidoInput(obra.valorRecebido ?? ''); setEditandoRecebimento(true); }}
            className="flex items-center gap-1.5 px-3 py-1.5 text-xs text-gray-400 border border-gray-700 rounded-xl hover:border-orange-500/50 hover:text-orange-400 transition-all flex-shrink-0 self-start sm:self-auto"
          >
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
            </svg>
            <span className="hidden sm:inline">Editar Recebimentos</span>
            <span className="sm:hidden">Editar</span>
          </button>
        </div>

        {/* ── RESUMO CONSOLIDADO (topo) ───────────────────────────── */}
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 mb-4 sm:mb-5 p-2.5 sm:p-3 rounded-xl bg-gray-800/40 border border-gray-800">
          <ResumoItem icone={<IcoEngrenagem c="#f97316"/>} label="Execução Física"  value={fmtPct(pctExecutado)} corValor="#f97316"/>
          <ResumoItem icone={<IcoMoeda     c="#60a5fa"/>} label="% Recebido"        value={fmtPct(pctRecebido)}  corValor="#60a5fa"/>
          <ResumoItem icone={<IcoPagamento c="#a78bfa"/>} label="% Pago"            value={fmtPct(pctPago)}      corValor="#a78bfa"/>
          <ResumoItem icone={<IcoCaixa     c={corSaldo}/>} label="Saldo (R$)"       value={fmtBRL2(saldoRS)}     corValor={corSaldo}/>
          <div className="text-center">
            <div className="flex items-center justify-center gap-1 mb-0.5">
              <IcoStatus st={statusGeral}/>
              <p className="text-xs text-gray-500 leading-tight">Status Geral</p>
            </div>
            <p className="text-sm font-bold leading-tight" style={{ color: cor[statusGeral] }}>
              {statusGeral === 'VERDE' ? 'Saudável' : statusGeral === 'AMARELO' ? 'Atenção' : statusGeral === 'VERMELHO' ? 'Risco' : 'Sem dados'}
            </p>
          </div>
        </div>

        {/* ── BLOCO 1 — Execução Física × Recebimento ─────────────── */}
        <div className="rounded-xl p-3 sm:p-4 mb-3 border" style={{ background: 'rgba(15,23,42,0.40)', borderColor: corB1 + '35' }}>
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-1.5 sm:gap-2 mb-3">
            <div className="flex items-center gap-2 min-w-0">
              <span className="w-1 h-4 rounded-full flex-shrink-0" style={{ background: corB1 }}/>
              <p className="text-xs font-semibold text-gray-300 truncate">Bloco 1 — Execução Física × Recebimento do Cliente</p>
            </div>
            <span className="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold flex-shrink-0 self-start sm:self-auto" style={{ color: corB1, background: corB1 + '20', border: `1px solid ${corB1}40` }}>
              <IcoStatus st={statusB1}/>{labelB1}
            </span>
          </div>

          {/* 3 métricas */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-3 mb-4">
            <div className="bg-gray-800/60 rounded-xl p-2.5 sm:p-3 border border-gray-800 text-center">
              <div className="flex items-center justify-center gap-1 mb-1"><IcoEngrenagem c="#f97316"/><p className="text-xs text-gray-400">Execução Física</p></div>
              <p className="text-xl sm:text-2xl font-black text-orange-400">{fmtPct(pctExecutado)}</p>
              <p className="text-xs text-gray-600 mt-1">Progresso ponderado</p>
            </div>
            <div className="bg-gray-800/60 rounded-xl p-2.5 sm:p-3 border border-gray-800 text-center">
              <div className="flex items-center justify-center gap-1 mb-1"><IcoMoeda c="#60a5fa"/><p className="text-xs text-gray-400">% Recebido</p></div>
              {configurado ? (
                <>
                  <p className="text-xl sm:text-2xl font-black text-blue-400">{fmtPct(pctRecebido)}</p>
                  <p className="text-xs text-gray-600 mt-1">{fmtBRL2(valorRecebido)} recebidos</p>
                </>
              ) : (
                <>
                  <p className="text-xl sm:text-2xl font-black text-gray-500">—</p>
                  <button onClick={() => { setValorRecebidoInput(''); setEditandoRecebimento(true); }}
                    className="mt-1 px-2 py-0.5 bg-orange-500/15 border border-orange-500/30 text-orange-400 text-xs rounded-lg hover:bg-orange-500/25 transition-all">
                    + Configurar
                  </button>
                </>
              )}
            </div>
            <div className="rounded-xl p-2.5 sm:p-3 border text-center" style={{ background: corB1 + '12', borderColor: corB1 + '40' }}>
              <div className="flex items-center justify-center gap-1 mb-1"><IcoTendencia c={corB1}/><p className="text-xs font-medium" style={{ color: corB1 }}>Diferença</p></div>
              <p className="text-xl sm:text-2xl font-black" style={{ color: corB1 }}>
                {difB1 !== null ? (difB1 >= 0 ? '+' : '') + fmtPct(difB1) : '—'}
              </p>
              <p className="text-xs mt-1" style={{ color: corB1 + 'aa' }}>Execução − Recebido</p>
            </div>
          </div>

          {/* Barra comparativa */}
          <BarraComparativa
            iconeA={<IcoEngrenagem c="#f97316"/>} labelA="Execução Física"        valA={pctExecutado} corA="#f97316"
            iconeB={<IcoMoeda     c={corB1}/>}  labelB="% Recebido do Cliente"   valB={pctRecebido}  corB={corB1}
          />

          {/* Interpretação */}
          <div className="mt-3 flex items-start gap-1.5">
            <IcoStatus st={statusB1}/>
            <p className="text-xs leading-relaxed" style={{ color: corB1 === '#64748b' ? '#64748b' : corB1 + 'dd' }}>{textoB1}</p>
          </div>
        </div>

        {/* ── BLOCO 2 — Recebimento × Pagamento ───────────────────── */}
        <div className="rounded-xl p-3 sm:p-4 border" style={{ background: 'rgba(15,23,42,0.40)', borderColor: corB2 + '35' }}>
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-1.5 sm:gap-2 mb-3">
            <div className="flex items-center gap-2 min-w-0">
              <span className="w-1 h-4 rounded-full flex-shrink-0" style={{ background: corB2 }}/>
              <p className="text-xs font-semibold text-gray-300 truncate">Bloco 2 — Recebimento × Pagamento aos Prestadores</p>
            </div>
            <span className="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold flex-shrink-0 self-start sm:self-auto" style={{ color: corB2, background: corB2 + '20', border: `1px solid ${corB2}40` }}>
              <IcoStatus st={statusB2}/>{labelB2}
            </span>
          </div>

          {/* 4 métricas */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3 mb-4">
            <div className="bg-gray-800/60 rounded-xl p-2.5 sm:p-3 border border-gray-800 text-center">
              <div className="flex items-center justify-center gap-1 mb-1"><IcoMoeda c="#60a5fa"/><p className="text-xs text-gray-400">% Recebido</p></div>
              <p className="text-xl sm:text-2xl font-black text-blue-400">{configurado ? fmtPct(pctRecebido) : '—'}</p>
              <p className="text-xs text-gray-600 mt-1">{configurado ? fmtBRL2(valorRecebido) : 'Não configurado'}</p>
            </div>
            <div className="bg-gray-800/60 rounded-xl p-2.5 sm:p-3 border border-gray-800 text-center">
              <div className="flex items-center justify-center gap-1 mb-1"><IcoPagamento c="#a78bfa"/><p className="text-xs text-gray-400">% Pago</p></div>
              <p className="text-xl sm:text-2xl font-black text-violet-400">{fmtPct(pctPago)}</p>
              <p className="text-xs text-gray-600 mt-1">{fmtBRL2(totalPagoEtapas)} pagos</p>
            </div>
            <div className="rounded-xl p-2.5 sm:p-3 border text-center" style={{ background: corB2 + '12', borderColor: corB2 + '40' }}>
              <div className="flex items-center justify-center gap-1 mb-1"><IcoTendencia c={corB2}/><p className="text-xs font-medium" style={{ color: corB2 }}>Dif. de Caixa</p></div>
              <p className="text-xl sm:text-2xl font-black" style={{ color: corB2 }}>
                {difB2 !== null ? (difB2 >= 0 ? '+' : '') + fmtPct(difB2) : '—'}
              </p>
              <p className="text-xs mt-1" style={{ color: corB2 + 'aa' }}>Recebido − Pago</p>
            </div>
            <div className="rounded-xl p-2.5 sm:p-3 border text-center" style={{ background: saldoRS !== null ? (saldoRS >= 0 ? 'rgba(34,197,94,0.10)' : 'rgba(239,68,68,0.10)') : 'rgba(100,116,139,0.08)', borderColor: saldoRS !== null ? (saldoRS >= 0 ? 'rgba(34,197,94,0.35)' : 'rgba(239,68,68,0.35)') : 'rgba(100,116,139,0.25)' }}>
              <div className="flex items-center justify-center gap-1 mb-1"><IcoCaixa c={corSaldo}/><p className="text-xs font-medium" style={{ color: corSaldo }}>Saldo Financeiro</p></div>
              <p className="text-lg font-black leading-tight" style={{ color: corSaldo }}>{fmtBRL2(saldoRS)}</p>
              <p className="text-xs mt-1" style={{ color: corSaldo + '99' }}>
                {saldoRS !== null ? (saldoRS >= 0 ? 'Recebido > Pago' : 'Pago > Recebido') : '—'}
              </p>
            </div>
          </div>

          {/* Barra comparativa */}
          <BarraComparativa
            iconeA={<IcoMoeda     c="#60a5fa"/>} labelA="% Recebido do Cliente"    valA={pctRecebido} corA="#60a5fa"
            iconeB={<IcoPagamento c="#a78bfa"/>} labelB="% Pago aos Prestadores"   valB={pctPago}     corB="#a78bfa"
          />

          {/* Interpretação */}
          <div className="mt-3 flex items-start gap-1.5">
            <IcoStatus st={statusB2}/>
            <p className="text-xs leading-relaxed" style={{ color: corB2 === '#64748b' ? '#64748b' : corB2 + 'dd' }}>{textoB2}</p>
          </div>
        </div>
      </div>
    );
  };

  // ─────────────────────────────────────────────────────────────
  // Diagnóstico Estratégico de Saúde da Obra (somente Prestador)
  // 3 Pilares: Prazo (30%) · Margem Real (40%) · Risco Financeiro (30%)
  // ─────────────────────────────────────────────────────────────
  const calcularSaude = (obra) => {
    if (!obra) return null;

    const servicos = obra.servicos || [];

    // ── Dados consolidados das etapas (fonte única de verdade) ────
    const totalVendaEtapas  = servicos.reduce((t, s) => t + (s.valorVenda           || 0), 0);
    const totalCustoContrat = servicos.reduce((t, s) => t + (s.valorCustoContratado || 0), 0);
    const totalPagoMO       = servicos.reduce((t, s) => t + (s.valorPago            || 0), 0);
    const totalComprasMat   = comprasMatPorObra[obra.id] || 0;
    const totalPagoEtapas   = totalPagoMO + totalComprasMat; // MO + Materiais
    const valorRecebido     = obra.valorRecebido || 0;
    const valorContrato     = obra.valorContrato || 0;
    const meta              = obra.metaMargem    || 20;   // % meta de margem

    // ── PILAR 1 – PRAZO (SPI) ─────────────────────────────────────
    const diasTotais     = servicos.reduce((t, s) => t + (s.duracao || 0), 0);
    const diasDecorridos = Math.max(0, Math.floor((new Date() - new Date(obra.inicio)) / 86400000));
    const progressoReal  = calcularProgresso(obra) / 100;          // 0..1
    const progEsperado   = diasTotais > 0 ? Math.min(diasDecorridos / diasTotais, 1) : 0;
    const spi            = progEsperado === 0 ? 1 : progressoReal / progEsperado;

    // Nota prazo 0–100
    let notaPrazo;
    if (spi >= 1.00)       notaPrazo = 100;
    else if (spi >= 0.90)  notaPrazo = 60 + ((spi - 0.90) / 0.10) * 40;
    else if (spi >= 0.80)  notaPrazo = 20 + ((spi - 0.80) / 0.10) * 40;
    else                   notaPrazo = Math.max(0, (spi / 0.80) * 20);

    const statusPrazo = spi >= 1.00 ? 'EM_DIA' : spi >= 0.90 ? 'ATENCAO' : 'ATRASO';
    const textoPrazo  = spi >= 1.00
      ? 'Execução no ritmo planejado ou adiantada.'
      : spi >= 0.90
      ? `Leve atraso detectado. Ritmo atual ${(spi * 100).toFixed(0)}% do esperado — monitorar.`
      : spi >= 0.80
      ? `Atraso relevante. Ritmo atual ${(spi * 100).toFixed(0)}% do esperado — ação necessária.`
      : `Atraso crítico. Ritmo atual ${(spi * 100).toFixed(0)}% do esperado — replanejamento urgente.`;

    // ── PILAR 2 – MARGEM REAL (baseada em valores pagos) ──────────
    // Fórmula: (TotalVendido − TotalPago) / TotalVendido × 100
    const margemReal       = totalVendaEtapas > 0
      ? ((totalVendaEtapas - totalPagoEtapas) / totalVendaEtapas) * 100 : null;
    const margemContratada = totalVendaEtapas > 0
      ? ((totalVendaEtapas - totalCustoContrat) / totalVendaEtapas) * 100 : null;
    const difVsMeta        = margemReal !== null ? margemReal - meta : null;

    // Nota margem 0–100
    let notaMargem;
    if (margemReal === null) {
      notaMargem = null;
    } else if (margemReal >= meta) {
      notaMargem = 100;
    } else if (margemReal >= meta - 5) {
      notaMargem = 60 + ((margemReal - (meta - 5)) / 5) * 40;
    } else if (margemReal >= 0) {
      notaMargem = Math.max(0, (margemReal / Math.max(meta - 5, 1)) * 60);
    } else {
      notaMargem = 0;
    }

    const statusMargem = notaMargem === null ? 'SEMDATA'
      : notaMargem >= 80 ? 'SAUDAVEL' : notaMargem >= 60 ? 'ATENCAO' : 'CRITICO';
    const textoMargem  = margemReal === null
      ? 'Configure os valores vendidos e pagos nas etapas para calcular a margem.'
      : margemReal >= meta
      ? `Margem ${margemReal.toFixed(2)}% — acima da meta de ${meta}%. Resultado positivo.`
      : margemReal >= meta - 5
      ? `Margem ${margemReal.toFixed(2)}% — ${Math.abs(difVsMeta).toFixed(2)}% abaixo da meta. Dentro da tolerância.`
      : margemReal >= 0
      ? `Margem ${margemReal.toFixed(2)}% — ${Math.abs(difVsMeta).toFixed(2)}% abaixo da meta. Ação necessária.`
      : `Margem negativa (${margemReal.toFixed(2)}%) — custos pagos superam o vendido. Risco crítico.`;

    // ── PILAR 3 – RISCO FINANCEIRO (CAIXA REAL) ───────────────────
    // Saldo de Caixa = Recebido − Pago (valores absolutos)
    const financeiroDadosDisponiveis = valorContrato > 0 || totalVendaEtapas > 0;
    const base                       = totalVendaEtapas > 0 ? totalVendaEtapas : valorContrato;
    const saldoCaixa                 = valorRecebido - totalPagoEtapas;
    const pctSaldoCaixa              = base > 0 ? (saldoCaixa / base) * 100 : null;
    const pctRecebido                = base > 0 ? (valorRecebido / base) * 100 : null;
    const pctPago                    = base > 0 ? (totalPagoEtapas / base) * 100 : null;

    // Nota financeiro 0–100
    let notaFinanceiro;
    if (pctSaldoCaixa === null) {
      notaFinanceiro = null;
    } else if (pctSaldoCaixa >= 0) {
      notaFinanceiro = 100;
    } else if (pctSaldoCaixa >= -10) {
      notaFinanceiro = 60 + ((pctSaldoCaixa + 10) / 10) * 40;
    } else if (pctSaldoCaixa >= -25) {
      notaFinanceiro = 20 + ((pctSaldoCaixa + 25) / 15) * 40;
    } else {
      notaFinanceiro = 0;
    }

    const statusFinanceiro = notaFinanceiro === null ? 'SEMDATA'
      : notaFinanceiro >= 80 ? 'SAUDAVEL' : notaFinanceiro >= 60 ? 'ATENCAO' : 'RISCO';
    const textoFinanceiro  = pctSaldoCaixa === null
      ? 'Configure o valor do contrato e o valor recebido do cliente.'
      : saldoCaixa >= 0
      ? `Operação saudável. Recebido supera o pago em R$ ${saldoCaixa.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}.`
      : pctSaldoCaixa >= -10
      ? `Leve exposição de caixa. A obra financia R$ ${Math.abs(saldoCaixa).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} do cliente — monitorar.`
      : pctSaldoCaixa >= -25
      ? `Risco de caixa moderado. Financiando ${Math.abs(pctSaldoCaixa).toFixed(1)}% do valor da obra — acionar cobrança.`
      : `Risco de caixa crítico. Financiando ${Math.abs(pctSaldoCaixa).toFixed(1)}% do valor da obra — intervenção urgente.`;

    // ── SCORE GERAL (pesos: Prazo 30% · Margem 40% · Financeiro 30%) ──
    const notasValidas = [
      { nota: notaPrazo,      peso: 0.30 },
      { nota: notaMargem,     peso: 0.40 },
      { nota: notaFinanceiro, peso: 0.30 },
    ].filter(x => x.nota !== null);
    const pesoTotal  = notasValidas.reduce((t, x) => t + x.peso, 0);
    const scoreGeral = pesoTotal > 0
      ? notasValidas.reduce((t, x) => t + x.nota * x.peso, 0) / pesoTotal
      : null;

    const statusGeral = scoreGeral === null ? 'SEMDATA'
      : scoreGeral >= 80 ? 'SAUDAVEL' : scoreGeral >= 60 ? 'ATENCAO' : 'CRITICO';

    return {
      // Pilar 1
      spi, notaPrazo, statusPrazo, textoPrazo, progressoReal, progEsperado, diasDecorridos, diasTotais,
      // Pilar 2
      margemReal, margemContratada, meta, difVsMeta, notaMargem, statusMargem, textoMargem,
      totalVendaEtapas, totalPagoEtapas, totalCustoContrat,
      // Pilar 3
      saldoCaixa, pctSaldoCaixa, pctRecebido, pctPago, notaFinanceiro, statusFinanceiro, textoFinanceiro,
      valorRecebido, valorContrato,
      // Score geral
      scoreGeral, statusGeral,
    };
  };

  const SaudeSection = ({ obra }) => {
    if (!obra) return null;
    const s = calcularSaude(obra);
    if (!s) return null;

    const fmtPct = (v, dec = 2) => v !== null && v !== undefined ? v.toFixed(dec) + '%' : '—';
    const fmtBRL = (v) => 'R$ ' + (v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    // ── Paleta por status geral ────────────────────────────────────
    const paletaGeral = {
      SAUDAVEL: { bg: 'rgba(34,197,94,0.06)',  border: 'rgba(34,197,94,0.25)',  cor: '#22c55e', label: 'SAUDÁVEL', badgeCls: 'bg-green-500/15 text-green-400 border-green-500/25' },
      ATENCAO:  { bg: 'rgba(234,179,8,0.06)',  border: 'rgba(234,179,8,0.25)',  cor: '#eab308', label: 'ATENÇÃO',  badgeCls: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/25' },
      CRITICO:  { bg: 'rgba(239,68,68,0.06)',  border: 'rgba(239,68,68,0.25)',  cor: '#ef4444', label: 'CRÍTICO',  badgeCls: 'bg-red-500/15 text-red-400 border-red-500/25' },
      SEMDATA:  { bg: 'rgba(100,116,139,0.06)',border: 'rgba(100,116,139,0.20)',cor: '#64748b', label: 'SEM DADOS',badgeCls: 'bg-gray-700/40 text-gray-400 border-gray-600/30' },
    };
    const pg = paletaGeral[s.statusGeral];

    // ── Helpers de cor por nota ────────────────────────────────────
    const corNota    = (n) => n === null ? '#64748b' : n >= 80 ? '#22c55e' : n >= 60 ? '#eab308' : '#ef4444';
    const bgNota     = (n) => n === null ? 'rgba(100,116,139,0.10)' : n >= 80 ? 'rgba(34,197,94,0.10)' : n >= 60 ? 'rgba(234,179,8,0.10)' : 'rgba(239,68,68,0.10)';
    const chipStatus = (st, txt) => {
      const cls = st === 'EM_DIA' || st === 'SAUDAVEL'
        ? 'bg-green-500/15 text-green-400 border-green-500/25'
        : st === 'ATENCAO'
        ? 'bg-yellow-500/15 text-yellow-400 border-yellow-500/25'
        : st === 'SEMDATA'
        ? 'bg-gray-700/40 text-gray-500 border-gray-600/30'
        : 'bg-red-500/15 text-red-400 border-red-500/25';
      return <span className={`px-2 py-0.5 rounded-full text-xs font-semibold border ${cls}`}>{txt}</span>;
    };

    // ── Ícone SVG inline por status ───────────────────────────────
    const IcoCheck  = () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"/></svg>;
    const IcoWarn   = () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2}   viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/></svg>;
    const IcoCrit   = () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2}   viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>;
    const IcoClock  = () => <svg className="w-4 h-4"   fill="none" stroke="currentColor" strokeWidth={2}   viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>;
    const IcoTrend  = () => <svg className="w-4 h-4"   fill="none" stroke="currentColor" strokeWidth={2}   viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/></svg>;
    const IcoCaixa  = () => <svg className="w-4 h-4"   fill="none" stroke="currentColor" strokeWidth={2}   viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/></svg>;

    const iconStatus = (st) => {
      if (st === 'EM_DIA' || st === 'SAUDAVEL') return <IcoCheck/>;
      if (st === 'ATENCAO') return <IcoWarn/>;
      if (st === 'SEMDATA') return <span className="text-gray-600 text-xs">—</span>;
      return <IcoCrit/>;
    };

    // ── Barra de progresso ─────────────────────────────────────────
    const Barra = ({ pct, cor, height = 'h-2' }) => (
      <div className={`w-full bg-gray-700/50 rounded-full ${height} overflow-hidden`}>
        <div className={`${height} rounded-full transition-all duration-700`}
          style={{ width: `${Math.min(Math.max(pct || 0, 0), 100)}%`, background: cor }}/>
      </div>
    );

    // ── Score geral: gauge circular via SVG ───────────────────────
    const score = s.scoreGeral;
    const GaugeScore = () => {
      const r = 36, cx = 44, cy = 44;
      const circum = 2 * Math.PI * r;
      const pct    = score !== null ? Math.min(Math.max(score, 0), 100) : 0;
      const dash   = (pct / 100) * circum;
      const cor    = corNota(score);
      return (
        <svg width="88" height="88" viewBox="0 0 88 88">
          <circle cx={cx} cy={cy} r={r} fill="none" stroke="rgba(100,116,139,0.20)" strokeWidth="8"/>
          <circle cx={cx} cy={cy} r={r} fill="none" stroke={cor} strokeWidth="8"
            strokeDasharray={`${dash} ${circum}`}
            strokeDashoffset={circum * 0.25}
            strokeLinecap="round" style={{ transition: 'stroke-dasharray 0.7s ease' }}/>
          <text x={cx} y={cy - 5} textAnchor="middle" fill={cor} fontSize="16" fontWeight="900" fontFamily="inherit">
            {score !== null ? Math.round(score) : '—'}
          </text>
          <text x={cx} y={cy + 11} textAnchor="middle" fill="#6b7280" fontSize="9" fontFamily="inherit">
            / 100
          </text>
        </svg>
      );
    };

    return (
      <div className="rounded-2xl border p-3.5 sm:p-5 mb-5 transition-all"
        style={{ background: pg.bg, borderColor: pg.border }}>

        {/* ── Header ─────────────────────────────────────────────── */}
        <div className="flex items-center justify-between mb-4 sm:mb-5">
          <div className="flex items-center gap-2 min-w-0">
            <span className="w-1 h-5 rounded-full flex-shrink-0" style={{ background: pg.cor }}/>
            <h3 className="text-sm font-semibold text-white">Saúde da Obra</h3>
            <span className="text-xs text-gray-500 font-light hidden sm:inline">— diagnóstico estratégico</span>
          </div>
          <span className={`px-2.5 py-1 rounded-full text-xs font-bold border flex-shrink-0 ${pg.badgeCls}`}>
            {pg.label}
          </span>
        </div>

        {/* ── Score Geral + Pilares ───────────────────────────────── */}
        <div className="flex flex-col lg:flex-row gap-5">

          {/* Gauge Score */}
          <div className="flex flex-col items-center justify-center lg:border-r lg:border-gray-800 lg:pr-6 lg:min-w-[160px] gap-2">
            <GaugeScore/>
            <div className="text-center">
              <p className="text-xs text-gray-400 font-medium">Score de Saúde</p>
              <p className="text-xs text-gray-600 mt-0.5">Pesos: Prazo 30% · Margem 40% · Caixa 30%</p>
            </div>
          </div>

          {/* 3 Pilares */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">

            {/* ── PILAR 1: PRAZO ─────────────────────────────────── */}
            <div className="bg-gray-800/60 rounded-xl p-3 sm:p-4 border border-gray-800 flex flex-col gap-3">
              {/* Título */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1.5">
                  <span className="text-blue-400"><IcoClock/></span>
                  <p className="text-xs font-semibold text-gray-300 uppercase tracking-wider">Prazo</p>
                </div>
                {chipStatus(s.statusPrazo,
                  s.statusPrazo === 'EM_DIA' ? 'Em dia' : s.statusPrazo === 'ATENCAO' ? 'Atenção' : 'Atraso')}
              </div>

              {/* Métrica principal */}
              <div>
                <div className="flex items-baseline gap-1.5">
                  <span className="text-2xl font-black text-white">SPI {s.spi.toFixed(2)}</span>
                </div>
                <p className="text-xs mt-0.5" style={{ color: corNota(s.notaPrazo) }}>
                  Nota: {s.notaPrazo.toFixed(0)}/100
                </p>
              </div>

              {/* Barra */}
              <Barra pct={Math.min(s.spi * 100, 100)} cor={corNota(s.notaPrazo)}/>

              {/* Sub-métricas */}
              <div className="grid grid-cols-2 gap-x-2 text-xs text-gray-500">
                <span>Real: <strong className="text-gray-300">{(s.progressoReal * 100).toFixed(1)}%</strong></span>
                <span>Planejado: <strong className="text-gray-300">{(s.progEsperado * 100).toFixed(1)}%</strong></span>
                <span>Decorridos: <strong className="text-gray-300">{s.diasDecorridos}d</strong></span>
                <span>Total: <strong className="text-gray-300">{s.diasTotais}d</strong></span>
              </div>

              {/* Texto interpretativo */}
              <p className="text-xs text-gray-500 leading-relaxed border-t border-gray-800 pt-2">
                {s.textoPrazo}
              </p>
            </div>

            {/* ── PILAR 2: MARGEM REAL ───────────────────────────── */}
            <div className="bg-gray-800/60 rounded-xl p-3 sm:p-4 border border-gray-800 flex flex-col gap-3">
              {/* Título */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1.5">
                  <span className="text-purple-400"><IcoTrend/></span>
                  <p className="text-xs font-semibold text-gray-300 uppercase tracking-wider">Margem Real</p>
                </div>
                {chipStatus(s.statusMargem,
                  s.statusMargem === 'SAUDAVEL' ? 'Saudável' : s.statusMargem === 'ATENCAO' ? 'Atenção' : s.statusMargem === 'SEMDATA' ? 'Sem dados' : 'Crítico')}
              </div>

              {/* Métrica principal */}
              <div>
                <div className="flex items-baseline gap-2">
                  <span className="text-2xl font-black text-white">
                    {s.margemReal !== null ? s.margemReal.toFixed(2) + '%' : '—'}
                  </span>
                  {s.difVsMeta !== null && (
                    <span className="text-xs font-semibold" style={{ color: s.difVsMeta >= 0 ? '#22c55e' : '#ef4444' }}>
                      {s.difVsMeta >= 0 ? '+' : ''}{s.difVsMeta.toFixed(2)}% vs meta
                    </span>
                  )}
                </div>
                <p className="text-xs mt-0.5" style={{ color: corNota(s.notaMargem) }}>
                  {s.notaMargem !== null ? `Nota: ${s.notaMargem.toFixed(0)}/100` : 'Sem dados para calcular'}
                </p>
              </div>

              {/* Barra comparativa: margem real vs meta */}
              <div className="space-y-1.5">
                <div className="flex justify-between text-xs text-gray-600">
                  <span>Margem real</span>
                  <span style={{ color: corNota(s.notaMargem) }}>{fmtPct(s.margemReal)}</span>
                </div>
                <Barra pct={s.margemReal !== null ? Math.max(s.margemReal, 0) : 0} cor={corNota(s.notaMargem)}/>
                <div className="flex justify-between text-xs text-gray-600">
                  <span>Meta</span>
                  <span className="text-purple-400">{s.meta}%</span>
                </div>
                <Barra pct={s.meta} cor="rgba(168,85,247,0.50)"/>
              </div>

              {/* Sub-métricas */}
              <div className="grid grid-cols-2 gap-x-2 text-xs text-gray-500">
                <span>Vendido: <strong className="text-blue-300">{fmtBRL(s.totalVendaEtapas).replace('R$ ','R$')}</strong></span>
                <span>Pago: <strong className="text-red-300">{fmtBRL(s.totalPagoEtapas).replace('R$ ','R$')}</strong></span>
                <span>Contratado: <strong className="text-amber-300">{fmtBRL(s.totalCustoContrat).replace('R$ ','R$')}</strong></span>
                {s.margemContratada !== null && (
                  <span>Mg. Contrat.: <strong className="text-amber-300">{s.margemContratada.toFixed(2)}%</strong></span>
                )}
              </div>

              {/* Texto interpretativo */}
              <p className="text-xs text-gray-500 leading-relaxed border-t border-gray-800 pt-2">
                {s.textoMargem}
              </p>
            </div>

            {/* ── PILAR 3: RISCO FINANCEIRO ──────────────────────── */}
            <div className="bg-gray-800/60 rounded-xl p-3 sm:p-4 border border-gray-800 flex flex-col gap-3">
              {/* Título */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1.5">
                  <span className="text-green-400"><IcoCaixa/></span>
                  <p className="text-xs font-semibold text-gray-300 uppercase tracking-wider">Risco Caixa</p>
                </div>
                {chipStatus(s.statusFinanceiro,
                  s.statusFinanceiro === 'SAUDAVEL' ? 'Saudável' : s.statusFinanceiro === 'ATENCAO' ? 'Atenção' : s.statusFinanceiro === 'SEMDATA' ? 'Sem dados' : 'Risco')}
              </div>

              {/* Métrica principal: Saldo Caixa */}
              <div>
                <div className="flex items-baseline gap-2">
                  <span className="text-2xl font-black" style={{ color: s.saldoCaixa >= 0 ? '#22c55e' : '#ef4444' }}>
                    {s.saldoCaixa >= 0 ? '+' : ''}{fmtBRL(s.saldoCaixa)}
                  </span>
                </div>
                <p className="text-xs mt-0.5" style={{ color: corNota(s.notaFinanceiro) }}>
                  {s.notaFinanceiro !== null ? `Nota: ${s.notaFinanceiro.toFixed(0)}/100` : 'Configure o valor recebido'}
                </p>
              </div>

              {/* Barras comparativas: Recebido vs Pago */}
              <div className="space-y-1.5">
                <div className="flex justify-between text-xs text-gray-600">
                  <span>Recebido do cliente</span>
                  <span className="text-green-400">{fmtPct(s.pctRecebido, 1)}</span>
                </div>
                <Barra pct={s.pctRecebido} cor="#22c55e"/>
                <div className="flex justify-between text-xs text-gray-600">
                  <span>Pago aos prestadores</span>
                  <span className="text-red-400">{fmtPct(s.pctPago, 1)}</span>
                </div>
                <Barra pct={s.pctPago} cor="#ef4444"/>
              </div>

              {/* Sub-métricas */}
              <div className="grid grid-cols-2 gap-x-2 text-xs text-gray-500">
                <span>Recebido: <strong className="text-green-300">{fmtBRL(s.valorRecebido).replace('R$ ','R$')}</strong></span>
                <span>Pago: <strong className="text-red-300">{fmtBRL(s.totalPagoEtapas).replace('R$ ','R$')}</strong></span>
                <span>Diferença %: <strong style={{ color: corNota(s.notaFinanceiro) }}>
                  {s.pctSaldoCaixa !== null ? (s.pctSaldoCaixa >= 0 ? '+' : '') + s.pctSaldoCaixa.toFixed(1) + '%' : '—'}
                </strong></span>
              </div>

              {/* Texto interpretativo */}
              <p className="text-xs text-gray-500 leading-relaxed border-t border-gray-800 pt-2">
                {s.textoFinanceiro}
              </p>
            </div>

          </div>{/* fim grid 3 pilares */}
        </div>{/* fim flex geral */}

        {/* ── Nota de rodapé ──────────────────────────────────────── */}
        <p className="text-xs text-gray-700 mt-4 text-right">
          Fonte: Board de Etapas · Executado × Pago · Atualizado em tempo real
        </p>
      </div>
    );
  };

  // Componente: Indicador Crítico de Margem (somente Prestador)
  // ─────────────────────────────────────────────────────────────
  // Componente: Indicador Crítico — Margem da Obra + BDI (v3)
  // Modelo: empresa sem equipe própria / 100% terceirizado
  // Integra: serviços + compras reais de materiais + BDI
  // ─────────────────────────────────────────────────────────────
  const MargemSection = ({ obra }) => {
    const fmtBRL = (v) => 'R$ ' + (v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const fmtPct = (v) => v !== null && v !== undefined ? v.toFixed(2) + '%' : '—';

    // ── Hooks — DEVEM vir antes de qualquer return condicional ──
    const [totalComprasMat, setTotalComprasMat] = useState(0);
    const [editandoBDI,     setEditandoBDI]     = useState(false);
    const [bdiForm,         setBdiForm]         = useState({ indiretos: '', margem: '' });

    useEffect(() => {
      if (!obra?.id) return;
      const fetchCompras = async () => {
        try {
          const { data } = await supabase
            .from('compras_materiais')
            .select('total')
            .eq('obra_id', obra.id);
          setTotalComprasMat((data || []).reduce((t, c) => t + (c.total || 0), 0));
        } catch(e) {}
      };
      fetchCompras();
    }, [obra?.id]);

    // ── Guard após os hooks ─────────────────────────────────────
    if (!obra) return null;

    const salvarBDI = async () => {
      const ind = parseFloat(bdiForm.indiretos) || 0;
      const mar = parseFloat(bdiForm.margem)    || 0;
      await supabase.from('obras').update({ bdi_indiretos: ind, bdi_margem: mar }).eq('id', obra.id);
      atualizarObraLocal(obra.id, { bdiIndiretos: ind, bdiMargem: mar });
      setEditandoBDI(false);
    };

    // ── Dados da obra ──────────────────────────────────────────
    const valorContrato    = obra.valorContrato || 0;
    const valorRecebidoCli = obra.valorRecebido || 0;
    const servicos         = obra.servicos || [];
    const bdiIndiretos     = obra.bdiIndiretos || 0;  // % custos indiretos
    const bdiMargem        = obra.bdiMargem    || 0;  // % margem sobre total

    // ── Totais das etapas ──────────────────────────────────────
    const totalVendaEtapas  = servicos.reduce((t, s) => t + (s.valorVenda           || 0), 0);
    const totalCustoContrat = servicos.reduce((t, s) => t + (s.valorCustoContratado || 0), 0);
    const totalPagoEtapas   = servicos.reduce((t, s) => t + (s.valorPago            || 0), 0);
    const totalSaldoPagar   = Math.max(0, totalCustoContrat - totalPagoEtapas);

    // ── BDI — cálculo conforme modelo do print ────────────────
    // Custos Diretos = Orçamento MO + Orçamento Materiais
    const orcMO              = obra.orcamentoMaoDeObra  || 0;
    const orcMat             = obra.orcamentoMateriais  || 0;
    const custosDiretos      = orcMO + orcMat;
    // Custos Indiretos = Diretos × % Indiretos
    const custosIndiretos    = custosDiretos * (bdiIndiretos / 100);
    // Subtotal Operacional
    const subtotalOperac     = custosDiretos + custosIndiretos;
    // Total BDI = Subtotal / (1 − %Margem)   [margem sobre o total]
    const totalComBDI        = bdiMargem < 100 && bdiMargem > 0
      ? subtotalOperac / (1 - bdiMargem / 100) : subtotalOperac;
    const valorMargemBDI     = totalComBDI - subtotalOperac;

    // ── Margem Real com materiais ──────────────────────────────
    // Custo total real = pago aos prestadores + compras de materiais
    const custoRealTotal    = totalPagoEtapas + totalComprasMat;
    const margemRealAtual   = totalVendaEtapas > 0
      ? ((totalVendaEtapas - custoRealTotal) / totalVendaEtapas) * 100 : null;
    // Margem contratada (sem materiais reais — base de planejamento)
    const margemContratada  = totalVendaEtapas > 0
      ? ((totalVendaEtapas - totalCustoContrat) / totalVendaEtapas) * 100 : null;

    const divergenciaContrato = valorContrato > 0 && totalVendaEtapas > 0
      && Math.abs(valorContrato - totalVendaEtapas) > 0.01;

    // ── Cor helpers ───────────────────────────────────────────
    const corMargem = (m) => {
      if (m === null) return '#64748b';
      if (m >= 20)   return '#22c55e';
      if (m >= 15)   return '#86efac';
      if (m >= 0)    return '#eab308';
      return '#ef4444';
    };
    const bgMargem = (m) => {
      if (m === null) return 'rgba(100,116,139,0.10)';
      if (m >= 20)   return 'rgba(34,197,94,0.10)';
      if (m >= 15)   return 'rgba(134,239,172,0.10)';
      if (m >= 0)    return 'rgba(234,179,8,0.10)';
      return 'rgba(239,68,68,0.10)';
    };
    const labelMargem = (m) => {
      if (m === null) return 'Não calculável';
      if (m >= 20)   return 'Margem saudável';
      if (m >= 15)   return 'Margem aceitável';
      if (m >= 0)    return 'Margem baixa';
      return 'Margem negativa';
    };

    const semDados = totalVendaEtapas === 0 && valorContrato === 0;
    const temBDI   = bdiIndiretos > 0 || bdiMargem > 0;
    const temMat   = totalComprasMat > 0;

    return (
      <div className="bg-gray-900/80 rounded-2xl border border-orange-500/20 p-3.5 sm:p-5 mb-5">

        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-4 sm:mb-5">
          <div className="flex items-center gap-2 min-w-0">
            <span className="w-1 h-5 bg-orange-500 rounded-full flex-shrink-0"/>
            <h3 className="text-sm font-semibold text-white truncate">Indicador Crítico — Margem da Obra</h3>
            <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-orange-500/15 text-orange-400 border border-orange-500/25 hidden sm:inline flex-shrink-0">
              Restrito ao Prestador
            </span>
          </div>
          <div className="flex gap-2 flex-shrink-0 self-start sm:self-auto">
            <button
              onClick={() => { setBdiForm({ indiretos: String(bdiIndiretos), margem: String(bdiMargem) }); setEditandoBDI(true); }}
              className="flex items-center gap-1.5 px-3 py-1.5 text-xs text-gray-400 border border-gray-700 rounded-xl hover:border-orange-500/50 hover:text-orange-400 transition-all"
            >
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 11h.01M12 11h.01M15 11h.01M4 19h16a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2z"/>
              </svg>
              BDI
            </button>
            <button
              onClick={() => { setDadosMargem({ valorContrato: obra.valorContrato || '', valorRecebido: obra.valorRecebido !== null && obra.valorRecebido !== undefined ? String(obra.valorRecebido) : '', metaMargem: String(obra.metaMargem || 20) }); setEditandoMargem(true); }}
              className="flex items-center gap-1.5 px-3 py-1.5 text-xs text-gray-400 border border-gray-700 rounded-xl hover:border-orange-500/50 hover:text-orange-400 transition-all"
            >
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
              </svg>
              <span className="hidden sm:inline">Editar Contrato</span>
              <span className="sm:hidden">Editar</span>
            </button>
          </div>
        </div>

        {/* ── Alerta Divergência ── */}
        {divergenciaContrato && (
          <div className="mb-4 flex items-start gap-2.5 px-4 py-3 rounded-xl bg-yellow-500/08 border border-yellow-500/30">
            <svg className="w-4 h-4 text-yellow-400 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
            </svg>
            <div>
              <p className="text-xs font-semibold text-yellow-400 mb-0.5">Divergência detectada</p>
              <p className="text-xs text-gray-400 leading-relaxed">
                A soma das etapas (<span className="text-blue-400 font-medium">{fmtBRL(totalVendaEtapas)}</span>) não corresponde ao valor total do contrato (<span className="text-white font-medium">{fmtBRL(valorContrato)}</span>).
              </p>
            </div>
          </div>
        )}

        {semDados ? (
          <div className="text-center py-8 border border-dashed border-gray-700 rounded-xl">
            <p className="text-sm text-gray-500 mb-3">
              Configure o <span className="text-orange-400 font-medium">{t('contractValue')}</span> e os valores financeiros de cada etapa.
            </p>
            <button
              onClick={() => { setDadosMargem({ valorContrato: '', metaMargem: '20' }); setEditandoMargem(true); }}
              className="px-4 py-2 bg-orange-500/15 border border-orange-500/30 text-orange-400 text-sm rounded-xl hover:bg-orange-500/25 transition-all"
            >
              + Configurar agora
            </button>
          </div>
        ) : (
          <>
            {/* ── BLOCO 1: Estrutura Contratada ── */}
            <div className="mb-4">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-2 h-2 rounded-full bg-blue-400"/>
                <p className="text-xs font-semibold text-blue-400 uppercase tracking-wider">Bloco 1 — Estrutura Contratada</p>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
                {[
                  { label: t('contractValue'),          value: fmtBRL(valorContrato),    cor: 'text-white',    desc: 'Total acordado com cliente' },
                  { label: 'Total Vendido nas Etapas',  value: fmtBRL(totalVendaEtapas), cor: 'text-blue-400', desc: 'Soma do valor de venda por etapa' },
                  { label: 'Total Contratado c/ Prest.',value: fmtBRL(totalCustoContrat),cor: 'text-amber-400', desc: 'Soma dos custos acordados' },
                  { label: 'Margem Contratada',
                    value: fmtPct(margemContratada),
                    cor: margemContratada !== null ? (margemContratada >= 15 ? 'text-green-400' : margemContratada >= 0 ? 'text-yellow-400' : 'text-red-400') : 'text-gray-500',
                    desc: labelMargem(margemContratada) },
                ].map((item, i) => (
                  <div key={i} className="bg-gray-700/30 rounded-xl p-2.5 sm:p-3.5 border border-gray-800">
                    <p className="text-xs text-gray-500 mb-1 leading-tight">{item.label}</p>
                    <p className={`text-base font-bold ${item.cor}`}>{item.value}</p>
                    <p className="text-xs text-gray-600 mt-1">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* ── BLOCO 2: Execução Financeira + Materiais ── */}
            <div className="mb-4">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-2 h-2 rounded-full bg-green-400"/>
                <p className="text-xs font-semibold text-green-400 uppercase tracking-wider">Bloco 2 — Execução Financeira</p>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
                {[
                  { label: 'Total Recebido do Cliente',  value: fmtBRL(valorRecebidoCli),  cor: 'text-green-400',  desc: 'Já recebido do cliente' },
                  { label: 'Pago aos Prestadores (MO)',  value: fmtBRL(totalPagoEtapas),   cor: 'text-red-400',    desc: 'Mão de obra desembolsada' },
                  { label: 'Compras de Materiais (Real)',value: fmtBRL(totalComprasMat),   cor: temMat ? 'text-amber-400' : 'text-gray-500', desc: temMat ? 'Registrado no módulo Materiais' : 'Nenhuma compra registrada' },
                  { label: 'Margem Real c/ Materiais',
                    value: fmtPct(margemRealAtual),
                    cor: margemRealAtual !== null ? (margemRealAtual >= 15 ? 'text-green-400' : margemRealAtual >= 0 ? 'text-yellow-400' : 'text-red-400') : 'text-gray-500',
                    desc: margemRealAtual !== null ? labelMargem(margemRealAtual) : 'Configure etapas' },
                ].map((item, i) => (
                  <div key={i} className="bg-gray-700/30 rounded-xl p-2.5 sm:p-3.5 border border-gray-800">
                    <p className="text-xs text-gray-500 mb-1 leading-tight">{item.label}</p>
                    <p className={`text-base font-bold ${item.cor}`}>{item.value}</p>
                    <p className="text-xs text-gray-600 mt-1">{item.desc}</p>
                  </div>
                ))}
              </div>

              {/* Comparativo margem: planejada vs real (com materiais) */}
              {margemContratada !== null && margemRealAtual !== null && temMat && (
                <div className="mt-3 flex items-center gap-3 px-4 py-2.5 rounded-xl bg-gray-900 border border-gray-800">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
                  </svg>
                  <p className="text-xs text-gray-400">
                    <span className="text-white font-semibold">Impacto dos Materiais na Margem: </span>
                    Margem planejada <span className="text-blue-400 font-semibold">{fmtPct(margemContratada)}</span>
                    {' → '} Margem real c/ compras <span className={`font-semibold ${margemRealAtual >= 15 ? 'text-green-400' : margemRealAtual >= 0 ? 'text-yellow-400' : 'text-red-400'}`}>{fmtPct(margemRealAtual)}</span>
                    {margemContratada > margemRealAtual
                      ? <span className="text-red-400 ml-1">↓ {fmtPct(margemContratada - margemRealAtual)} de redução</span>
                      : <span className="text-green-400 ml-1">↑ {fmtPct(margemRealAtual - margemContratada)} de ganho</span>
                    }
                  </p>
                </div>
              )}
            </div>

            {/* ── BLOCO 3: BDI — Estrutura da Proposta ── */}
            {temBDI && (
              <div className="mb-4">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-purple-400"/>
                    <p className="text-xs font-semibold text-purple-400 uppercase tracking-wider">Bloco 3 — BDI · Composição do Preço</p>
                    <span className="text-xs text-gray-600">Indiretos {fmtPct(bdiIndiretos)} · Margem {fmtPct(bdiMargem)}</span>
                  </div>
                </div>

                {/* Tabela BDI estilo print */}
                <div className="rounded-xl border border-gray-800 overflow-hidden overflow-x-auto">
                  <table className="w-full text-xs min-w-[480px]">
                    <thead>
                      <tr className="bg-gray-700/40 border-b border-gray-800">
                        <th className="text-left px-3 sm:px-4 py-2 sm:py-2.5 text-gray-400 font-medium">DESCRIÇÃO</th>
                        <th className="text-center px-2 sm:px-3 py-2 sm:py-2.5 text-gray-400 font-medium">%</th>
                        <th className="text-right px-3 sm:px-4 py-2 sm:py-2.5 text-gray-400 font-medium">VALOR</th>
                        <th className="text-left px-2 sm:px-3 py-2 sm:py-2.5 text-gray-400 font-medium hidden sm:table-cell">OBSERVAÇÃO</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-b border-gray-800/60">
                        <td className="px-3 sm:px-4 py-2 sm:py-2.5 text-gray-300 font-medium whitespace-nowrap">Custos Diretos (MO + Mat.)</td>
                        <td className="px-2 sm:px-3 py-2 sm:py-2.5 text-center text-gray-500">—</td>
                        <td className="px-3 sm:px-4 py-2 sm:py-2.5 text-right text-white font-semibold whitespace-nowrap">{fmtBRL(custosDiretos)}</td>
                        <td className="px-2 sm:px-3 py-2 sm:py-2.5 text-gray-500 hidden sm:table-cell">Base de cálculo</td>
                      </tr>
                      <tr className="border-b border-gray-800/60">
                        <td className="px-3 sm:px-4 py-2 sm:py-2.5 text-gray-300">Custos Indiretos</td>
                        <td className="px-2 sm:px-3 py-2 sm:py-2.5 text-center text-amber-400 font-semibold">{fmtPct(bdiIndiretos)}</td>
                        <td className="px-3 sm:px-4 py-2 sm:py-2.5 text-right text-amber-400 whitespace-nowrap">{fmtBRL(custosIndiretos)}</td>
                        <td className="px-2 sm:px-3 py-2 sm:py-2.5 text-gray-500 hidden sm:table-cell">Adm, encargos, seguros</td>
                      </tr>
                      <tr className="border-b border-gray-800 bg-gray-700/20">
                        <td className="px-3 sm:px-4 py-2 sm:py-2.5 text-gray-200 font-semibold">Subtotal Operacional</td>
                        <td className="px-2 sm:px-3 py-2 sm:py-2.5 text-center text-gray-500">—</td>
                        <td className="px-3 sm:px-4 py-2 sm:py-2.5 text-right text-white font-semibold whitespace-nowrap">{fmtBRL(subtotalOperac)}</td>
                        <td className="px-2 sm:px-3 py-2 sm:py-2.5 text-gray-500 hidden sm:table-cell"/>
                      </tr>
                      <tr className="border-b border-gray-800/60">
                        <td className="px-3 sm:px-4 py-2 sm:py-2.5 text-gray-300">BDI (Margem)</td>
                        <td className="px-2 sm:px-3 py-2 sm:py-2.5 text-center text-green-400 font-semibold">{fmtPct(bdiMargem)}</td>
                        <td className="px-3 sm:px-4 py-2 sm:py-2.5 text-right text-green-400 font-semibold whitespace-nowrap">{fmtBRL(valorMargemBDI)}</td>
                        <td className="px-2 sm:px-3 py-2 sm:py-2.5 text-gray-500 hidden sm:table-cell">Resultado líquido</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr className="bg-gradient-to-r from-orange-500/20 to-amber-500/10 border-t-2 border-orange-500/40">
                        <td className="px-3 sm:px-4 py-2.5 sm:py-3 text-xs sm:text-sm font-bold text-white whitespace-nowrap">TOTAL BDI</td>
                        <td className="px-2 sm:px-3 py-2.5 sm:py-3 text-center text-gray-400">—</td>
                        <td className="px-3 sm:px-4 py-2.5 sm:py-3 text-right text-base sm:text-lg font-black text-orange-400 whitespace-nowrap">{fmtBRL(totalComBDI)}</td>
                        <td className="px-2 sm:px-3 py-2.5 sm:py-3 text-gray-500 text-xs hidden sm:table-cell">Calculado com BDI</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                {/* Comparativo BDI vs Contrato assinado */}
                {valorContrato > 0 && Math.abs(totalComBDI - valorContrato) > 1 && (
                  <div className="mt-2 flex items-center gap-2 px-3 py-2 rounded-lg bg-yellow-500/10 border border-yellow-500/20">
                    <svg width="13" height="13" fill="none" stroke="#eab308" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                    </svg>
                    <p className="text-xs text-yellow-400">
                      Valor calculado pelo BDI ({fmtBRL(totalComBDI)}) difere do contrato assinado ({fmtBRL(valorContrato)}).
                    </p>
                  </div>
                )}
              </div>
            )}

            {!temBDI && (
              <div className="mb-4 flex items-center gap-3 px-4 py-3 rounded-xl border border-dashed border-gray-800 bg-gray-900/30">
                <svg width="16" height="16" fill="none" stroke="#64748b" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 11h.01M12 11h.01M15 11h.01M4 19h16a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
                <p className="text-xs text-gray-500">
                  Configure o <span className="text-orange-400 font-medium">BDI</span> para visualizar a composição do preço com custos indiretos e margem calculada.
                </p>
                <button onClick={() => { setBdiForm({ indiretos: '', margem: '' }); setEditandoBDI(true); }}
                  className="ml-auto flex-shrink-0 px-2.5 py-1 bg-orange-500/15 border border-orange-500/30 text-orange-400 text-xs rounded-lg hover:bg-orange-500/25 transition-all">
                  + Configurar BDI
                </button>
              </div>
            )}

            {/* ── Tabela por Etapa ── */}
            {servicos.length > 0 && (
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-2 h-2 rounded-full bg-purple-400"/>
                  <p className="text-xs font-semibold text-purple-400 uppercase tracking-wider">Detalhamento por Etapa</p>
                </div>
                <div className="rounded-xl border border-gray-800 overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="w-full text-xs">
                      <thead>
                        <tr className="bg-gray-700/40 border-b border-gray-800">
                          <th className="text-left px-3 py-2.5 text-gray-400 font-medium w-6">#</th>
                          <th className="text-left px-3 py-2.5 text-gray-400 font-medium">Etapa</th>
                          <th className="text-right px-3 py-2.5 text-blue-400 font-medium">Venda</th>
                          <th className="text-right px-3 py-2.5 text-amber-400 font-medium">Custo Contratado</th>
                          <th className="text-right px-3 py-2.5 text-red-400 font-medium">Pago</th>
                          <th className="text-right px-3 py-2.5 text-gray-400 font-medium">Saldo</th>
                          <th className="text-right px-3 py-2.5 text-gray-400 font-medium">Margem</th>
                          <th className="text-center px-3 py-2.5 text-gray-400 font-medium">Ação</th>
                        </tr>
                      </thead>
                      <tbody>
                        {servicos.map((s, idx) => {
                          const venda  = s.valorVenda           || 0;
                          const custo  = s.valorCustoContratado || 0;
                          const pago   = s.valorPago            || 0;
                          const saldo  = Math.max(0, custo - pago);
                          const margem = venda > 0 ? ((venda - custo) / venda) * 100 : null;
                          const corM   = corMargem(margem);
                          const bgM    = bgMargem(margem);
                          return (
                            <tr key={s.id} className="border-b border-gray-700/30 hover:bg-gray-700/20 transition-colors">
                              <td className="px-3 py-2.5 text-gray-600">{idx + 1}</td>
                              <td className="px-3 py-2.5">
                                <div className="flex items-center gap-2">
                                  <div className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${s.status === 'concluido' ? 'bg-green-400' : s.status === 'em_andamento' ? 'bg-orange-400' : 'bg-gray-600'}`}/>
                                  <span className="text-gray-200 font-medium whitespace-nowrap">{s.nome}</span>
                                </div>
                              </td>
                              <td className="px-3 py-2.5 text-right text-blue-300 font-medium whitespace-nowrap">{venda > 0 ? fmtBRL(venda) : <span className="text-gray-600">—</span>}</td>
                              <td className="px-3 py-2.5 text-right text-amber-300 whitespace-nowrap">{custo > 0 ? fmtBRL(custo) : <span className="text-gray-600">—</span>}</td>
                              <td className="px-3 py-2.5 text-right text-red-300 whitespace-nowrap">{pago > 0 ? fmtBRL(pago) : <span className="text-gray-600">—</span>}</td>
                              <td className="px-3 py-2.5 text-right whitespace-nowrap">
                                {saldo > 0
                                  ? <span className="text-amber-300">{fmtBRL(saldo)}</span>
                                  : custo > 0
                                  ? <span className="text-green-400 flex items-center justify-end gap-1">
                                      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7"/></svg>
                                      Quitado
                                    </span>
                                  : <span className="text-gray-600">—</span>
                                }
                              </td>
                              <td className="px-3 py-2.5 text-right">
                                {margem !== null ? (
                                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold" style={{ color: corM, background: bgM }}>
                                    {margem.toFixed(2)}%
                                  </span>
                                ) : <span className="text-gray-600">—</span>}
                              </td>
                              <td className="px-3 py-2.5 text-center">
                                <button
                                  onClick={() => { setEditandoFinanceiroServico(s.id); setDadosFinanceiroServico({ valorVenda: String(s.valorVenda || ''), valorCustoContratado: String(s.valorCustoContratado || ''), valorPago: String(s.valorPago || '') }); }}
                                  className="p-1.5 text-gray-500 hover:text-orange-400 hover:bg-orange-500/10 rounded-lg transition-all"
                                  title="Editar financeiro desta etapa"
                                >
                                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                                  </svg>
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr className="bg-gray-700/30 border-t border-gray-600/50">
                          <td colSpan={2} className="px-3 py-2.5 text-xs font-semibold text-gray-300">TOTAL</td>
                          <td className="px-3 py-2.5 text-right text-blue-400 font-semibold whitespace-nowrap">{fmtBRL(totalVendaEtapas)}</td>
                          <td className="px-3 py-2.5 text-right text-amber-400 font-semibold whitespace-nowrap">{fmtBRL(totalCustoContrat)}</td>
                          <td className="px-3 py-2.5 text-right text-red-400 font-semibold whitespace-nowrap">{fmtBRL(totalPagoEtapas)}</td>
                          <td className="px-3 py-2.5 text-right text-amber-300 font-semibold whitespace-nowrap">{fmtBRL(totalSaldoPagar)}</td>
                          <td className="px-3 py-2.5 text-right">
                            {margemContratada !== null ? (
                              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold"
                                style={{ color: corMargem(margemContratada), background: bgMargem(margemContratada) }}>
                                {margemContratada.toFixed(2)}%
                              </span>
                            ) : '—'}
                          </td>
                          <td/>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {/* ── Modal BDI ── */}
        {editandoBDI && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/70 " onClick={() => setEditandoBDI(false)}/>
            <div className="relative z-10 w-full max-w-md bg-gray-900 border border-gray-800 rounded-2xl shadow-2xl p-6">
              <div className="flex items-center gap-3 mb-5">
                <div className="p-2 bg-orange-500/15 rounded-xl">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f97316" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 11h.01M12 11h.01M15 11h.01M4 19h16a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                  </svg>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-white">Configurar BDI</h3>
                  <p className="text-xs text-gray-400">Benefícios e Despesas Indiretas</p>
                </div>
              </div>

              <div className="space-y-4 mb-5">
                <div>
                  <label className="block text-xs font-medium text-gray-400 mb-1.5">
                    % Custos Indiretos
                    <span className="ml-1 text-gray-600">(adm, encargos, seguros, canteiro)</span>
                  </label>
                  <div className="relative">
                    <input type="number" value={bdiForm.indiretos} onChange={e => setBdiForm(p => ({ ...p, indiretos: e.target.value }))}
                      placeholder="Ex: 22"
                      className="w-full px-3 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-500 focus:border-orange-500 focus:outline-none pr-8"/>
                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">%</span>
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-400 mb-1.5">
                    % Margem (BDI)
                    <span className="ml-1 text-gray-600">(resultado líquido sobre o total)</span>
                  </label>
                  <div className="relative">
                    <input type="number" value={bdiForm.margem} onChange={e => setBdiForm(p => ({ ...p, margem: e.target.value }))}
                      placeholder="Ex: 20"
                      className="w-full px-3 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-500 focus:border-orange-500 focus:outline-none pr-8"/>
                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">%</span>
                  </div>
                </div>

                {/* Preview do cálculo */}
                {(parseFloat(bdiForm.indiretos) > 0 || parseFloat(bdiForm.margem) > 0) && custosDiretos > 0 && (() => {
                  const ind = parseFloat(bdiForm.indiretos) || 0;
                  const mar = parseFloat(bdiForm.margem) || 0;
                  const indVal = custosDiretos * (ind / 100);
                  const sub = custosDiretos + indVal;
                  const tot = mar < 100 && mar > 0 ? sub / (1 - mar / 100) : sub;
                  return (
                    <div className="p-3 bg-gray-800/60 rounded-xl border border-gray-800 text-xs space-y-1.5">
                      <p className="text-gray-500 font-medium mb-2">Prévia do cálculo:</p>
                      <div className="flex justify-between text-gray-400"><span>Custos Diretos</span><span className="text-white">{fmtBRL(custosDiretos)}</span></div>
                      <div className="flex justify-between text-gray-400"><span>+ Indiretos ({ind}%)</span><span className="text-amber-400">+ {fmtBRL(indVal)}</span></div>
                      <div className="flex justify-between text-gray-300 font-medium border-t border-gray-700 pt-1.5"><span>Subtotal</span><span>{fmtBRL(sub)}</span></div>
                      <div className="flex justify-between text-gray-400"><span>+ BDI Margem ({mar}%)</span><span className="text-green-400">+ {fmtBRL(tot - sub)}</span></div>
                      <div className="flex justify-between text-orange-400 font-bold border-t border-gray-700 pt-1.5"><span>Total c/ BDI</span><span>{fmtBRL(tot)}</span></div>
                    </div>
                  );
                })()}

                <p className="text-xs text-gray-600">
                  💡 O BDI é aplicado sobre os custos diretos reais (MO paga + materiais comprados). A margem é calculada sobre o total final da proposta.
                </p>
              </div>

              <div className="flex gap-3">
                <button onClick={() => setEditandoBDI(false)}
                  className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-xl hover:border-gray-600 transition-all">
                  Cancelar
                </button>
                <button onClick={salvarBDI}
                  className="flex-1 px-4 py-2.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-medium rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all flex items-center justify-center gap-2">
                  <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"/></svg>
                  Salvar BDI
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };


  // Relatório PDF — renderiza sobre tudo quando ativo
  if (mostrarRelatorio && obraSelecionada) {
    return <RelatorioView obra={obraSelecionada} onClose={() => setMostrarRelatorio(false)} />;
  }

  // Tela de Escolha
  if (telaAtual === 'escolha') {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4 py-8 overflow-y-auto">
        <div className="max-w-5xl w-full">
          <div className="text-center mb-8 sm:mb-16">
            <div className="flex flex-col items-center mb-4 sm:mb-6">
              <LogoNOA className="w-36 sm:w-48 h-36 sm:h-48" />
              <p className="text-center text-gray-500 mt-2 mb-2" style={{fontFamily: "'Garet', 'Gill Sans', 'Century Gothic', sans-serif", fontWeight: '400', fontSize: "0.875rem", letterSpacing: "0.03em"}}>Desenvolvido por NOA Empreiteira</p>
            </div>
            <h1 className="text-4xl sm:text-5xl text-white mb-3 tracking-wider uppercase" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
              {t('appName')}
            </h1>
            <p className="text-gray-400 text-base">{t('appTagline')}</p>
          </div>

          <div className="grid md:grid-cols-2 gap-5">
            <button
              onClick={() => setTelaAtual('login-prestador')}
              className="group bg-gray-900 rounded-2xl p-5 sm:p-8 border border-gray-800 hover:border-orange-500/60 transition-all duration-200 hover:shadow-md text-left"
            >
              <div className="inline-block mb-4 p-2.5 bg-gradient-to-r from-orange-500 to-amber-500 rounded-lg">
                <Building2 className="w-8 h-8 text-white" />
              </div>
              <h2 className="text-xl sm:text-2xl font-medium text-white mb-2">{t('contractor')}</h2>
              <p className="text-gray-400">{t('contractorDesc')}</p>
            </button>

            <button
              onClick={() => setTelaAtual('login-cliente')}
              className="group bg-gray-900 rounded-2xl p-5 sm:p-8 border border-gray-800 hover:border-orange-500/60 transition-all duration-200 hover:shadow-md text-left"
            >
              <div className="inline-block mb-4 p-2.5 bg-gradient-to-r from-orange-500 to-amber-500 rounded-lg">
                <User className="w-8 h-8 text-white" />
              </div>
              <h2 className="text-xl sm:text-2xl font-medium text-white mb-2">{t('client')}</h2>
              <p className="text-gray-400">{t('clientDesc')}</p>
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Tela de Login Prestador
  if (telaAtual === 'login-prestador') {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
        <div className="bg-gray-900 rounded-2xl shadow-xl p-5 sm:p-8 w-full max-w-md border border-gray-800">
          <button
            onClick={() => setTelaAtual('escolha')}
            className="text-gray-400 hover:text-orange-400 mb-6 flex items-center gap-2 transition-colors"
          >
            {t('back')}
          </button>

          <div className="text-center mb-8">
            <div className="flex flex-col items-center mb-4">
              <LogoNOA className="w-28 sm:w-36 h-28 sm:h-36" />
              <p className="text-center text-gray-500 mt-2 mb-2" style={{fontFamily: "'Garet', 'Gill Sans', 'Century Gothic', sans-serif", fontWeight: '400', fontSize: "0.875rem", letterSpacing: "0.03em"}}>Desenvolvido por NOA Empreiteira</p>
            </div>
            <h2 className="text-2xl sm:text-3xl font-semibold text-white mb-2">Login <span className="text-orange-400">Prestador</span></h2>
            <p className="text-gray-400">{t('loginContractorSub')}</p>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">{t('email')}</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-orange-400 w-5 h-5" />
                <input
                  type="email"
                  value={emailPrestador}
                  onChange={(e) => setEmailPrestador(e.target.value)}
                  className="w-full pl-11 pr-4 py-3 bg-gray-800 border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500/30 transition-all"
                  placeholder="seu@email.com"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">{t('password')}</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-orange-400 w-5 h-5" />
                <input
                  type="password"
                  value={senhaPrestador}
                  onChange={(e) => setSenhaPrestador(e.target.value)}
                  className="w-full pl-11 pr-4 py-3 bg-gray-800 border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500/30 transition-all"
                  placeholder="••••••••"
                />
              </div>
            </div>

            <button
              onClick={loginPrestador}
              className="w-full bg-gradient-to-r from-orange-500 to-amber-500 text-white py-3 rounded-xl font-medium hover:from-orange-600 hover:to-amber-600 transition-all"
            >
              {t('enter')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Tela de Login Cliente
  // ── Tela: Email Magic Link Enviado ──────────────────────────────
  if (telaAtual === 'email-enviado') {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
        <div className="bg-gray-900 rounded-2xl shadow-xl p-8 w-full max-w-md border border-gray-800 text-center">
          <div className="flex flex-col items-center mb-6">
            <LogoNOA className="w-28 sm:w-36 h-28 sm:h-36" />
          </div>

          {/* Ícone de email enviado */}
          <div className="w-20 h-20 bg-gradient-to-r from-orange-500 to-amber-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <Mail className="w-10 h-10 text-white" />
          </div>

          <h2 className="text-2xl font-semibold text-white mb-3">
            Verifique seu <span className="text-orange-400">email</span>
          </h2>

          <p className="text-gray-400 mb-2">
            Enviamos um link de acesso para
          </p>
          <p className="text-orange-400 font-medium mb-6 break-all">
            {emailCliente}
          </p>

          <div className="p-4 bg-orange-500/10 rounded-xl border border-orange-500/15 mb-6 text-left">
            <p className="text-sm text-gray-300">
              📧 <span className="text-orange-400 font-medium">Como acessar:</span>
            </p>
            <ol className="text-sm text-gray-400 mt-2 space-y-1 list-decimal list-inside">
              <li>{LANG === 'pt' ? 'Abra o email que enviamos' : 'Open the email we sent'}</li>
              <li>Clique no botão <span className="text-white font-medium">{LANG === 'pt' ? '"Acessar minha obra"' : '"Access my project"'}</span></li>
              <li>Você será redirecionado automaticamente</li>
            </ol>
          </div>

          <p className="text-xs text-gray-500 mb-6">
            O link expira em 1 hora. Não encontrou o email? Verifique a pasta de spam.
          </p>

          <button
            onClick={() => { setTelaAtual('login-cliente'); setErroLogin(''); }}
            className="w-full border border-gray-700 text-gray-300 py-3 rounded-xl hover:border-orange-500/50 hover:text-orange-400 transition-all"
          >
            {t('back')} e tentar outro email
          </button>
        </div>
      </div>
    );
  }

  if (telaAtual === 'login-cliente') {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
        <div className="bg-gray-900 rounded-2xl shadow-xl p-8 w-full max-w-md border border-gray-800">
          <button
            onClick={() => setTelaAtual('escolha')}
            className="text-gray-400 hover:text-orange-400 mb-6 flex items-center gap-2 transition-colors"
          >
            {t('back')}
          </button>

          <div className="text-center mb-8">
            <div className="flex flex-col items-center mb-4">
              <LogoNOA className="w-28 sm:w-36 h-28 sm:h-36" />
              <p className="text-center text-gray-500 mt-2 mb-2" style={{fontFamily: "'Garet', 'Gill Sans', 'Century Gothic', sans-serif", fontWeight: '400', fontSize: "0.875rem", letterSpacing: "0.03em"}}>Desenvolvido por NOA Empreiteira</p>
            </div>
            <h2 className="text-3xl font-semibold text-white mb-2">{t('loginClient')}</h2>
            <p className="text-gray-400">{t('loginClientSub')}</p>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">{t('emailRegistered')}</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-orange-400 w-5 h-5" />
                <input
                  type="email"
                  value={emailCliente}
                  onChange={(e) => setEmailCliente(e.target.value)}
                  className="w-full pl-11 pr-4 py-3 bg-gray-800 border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500/30 transition-all"
                  placeholder="seu@email.com"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">Senha</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-orange-400 w-5 h-5" />
                <input
                  type="password"
                  value={senhaCliente}
                  onChange={(e) => setSenhaCliente(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && loginCliente()}
                  className="w-full pl-11 pr-4 py-3 bg-gray-800 border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500/30 transition-all"
                  placeholder="Digite sua senha"
                />
              </div>
            </div>

            {erroLogin && (
              <div className="flex items-center gap-2 p-3 bg-red-500/10 border border-red-500/30 rounded-xl">
                <AlertCircle className="w-4 h-4 text-red-400 flex-shrink-0" />
                <p className="text-sm text-red-400">{erroLogin}</p>
              </div>
            )}

            <button
              onClick={loginCliente}
              disabled={carregando}
              className="w-full bg-gradient-to-r from-orange-500 to-amber-500 text-white py-3 rounded-xl font-medium hover:from-orange-600 hover:to-amber-600 transition-all disabled:opacity-60 flex items-center justify-center gap-2"
            >
              {carregando ? (
                <><svg className="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24"><circle className="opacity-50" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/></svg> Entrando...</>
              ) : 'Acessar minha obra'}
            </button>
          </div>

          <div className="mt-6 p-4 bg-orange-500/10 rounded-xl border border-orange-500/15">
            <p className="text-sm text-gray-300">
              <Lock className="w-4 h-4 inline text-orange-400 mr-1" />
              <span className="text-orange-400 font-medium">Acesso seguro:</span> Use o email e senha fornecidos pelo seu prestador.
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Home do Prestador
  if (telaAtual === 'home-prestador') {
    return (
      <div className="min-h-screen bg-gray-950">
        {/* Header */}
        <header className="bg-gray-900 border-b border-gray-800 shadow-sm">
          <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-3 sm:py-4">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                <LogoNOA className="w-16 sm:w-20 h-16 sm:h-20" />
                <div>
                  <h1 className="text-xl text-white tracking-wider uppercase" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
                    Gestão de <span className="text-orange-400">Obras</span>
                  </h1>
                  <p className="text-xs text-gray-500">{t('contractorPanel')}</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="text-right mr-2 hidden sm:block">
                  <p className="text-xs text-gray-500">Total de Obras</p>
                  <p className="text-2xl font-bold text-orange-400">{obras.length}</p>
                </div>
                <button
                  onClick={logout}
                  className="flex items-center gap-2 px-4 py-2 bg-gray-800 border border-gray-700 text-gray-300 rounded-xl hover:border-gray-600 hover:text-white transition-all"
                >
                  <LogOut className="w-4 h-4" />
                  Sair
                </button>
              </div>
            </div>
          </div>
        </header>

        <main className="relative z-10 max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-4 sm:py-8">

          {/* Cards de estatísticas */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 mb-6 sm:mb-8">
            <div className="bg-gray-900 rounded-2xl p-3.5 sm:p-5 border border-gray-800 hover:border-gray-700 transition-all">
              <div className="flex items-center justify-between">
                <div className="min-w-0">
                  <p className="text-xs text-gray-500 mb-1 truncate">{t('activeProjects')}</p>
                  <p className="text-xl sm:text-3xl font-bold text-orange-400">
                    {obras.filter(o => o.status === 'em_andamento').length}
                  </p>
                </div>
                <Building2 className="w-7 sm:w-9 h-7 sm:h-9 text-orange-500 opacity-60 flex-shrink-0" />
              </div>
            </div>

            <div className="bg-gray-900 rounded-2xl p-3.5 sm:p-5 border border-gray-800 hover:border-gray-700 transition-all">
              <div className="flex items-center justify-between">
                <div className="min-w-0">
                  <p className="text-xs text-gray-500 mb-1 truncate">{t('totalRevenue')}</p>
                  <p className="text-lg font-bold text-green-400">
                    R$ {(obras.reduce((acc, o) => acc + o.orcamentoTotal, 0) / 1000).toFixed(0)}k
                  </p>
                </div>
                <DollarSign className="w-7 sm:w-9 h-7 sm:h-9 text-green-500 opacity-60 flex-shrink-0" />
              </div>
            </div>

            <div className="bg-gray-900 rounded-2xl p-3.5 sm:p-5 border border-gray-800 hover:border-gray-700 transition-all">
              <div className="flex items-center justify-between">
                <div className="min-w-0">
                  <p className="text-xs text-gray-500 mb-1 truncate">{t('billed')}</p>
                  <p className="text-base sm:text-lg font-bold text-amber-400">
                    {(() => {
                      const totalRecebido = obras.reduce((acc, o) => acc + (o.valorRecebido || 0), 0);
                      const totalPago     = obras.reduce((acc, o) => acc + o.servicos.reduce((t, s) => t + (s.valorPago || 0), 0), 0);
                      const totalCompras  = obras.reduce((acc, o) => acc + (comprasMatPorObra[o.id] || 0), 0);
                      const margem        = totalRecebido - totalPago - totalCompras;
                      return <span>R$ {(margem / 1000).toFixed(0)}k</span>;
                    })()}
                  </p>
                </div>
                <BarChart3 className="w-7 sm:w-9 h-7 sm:h-9 text-amber-500 opacity-60 flex-shrink-0" />
              </div>
            </div>

            <div className="bg-gray-900 rounded-2xl p-3.5 sm:p-5 border border-gray-800 hover:border-gray-700 transition-all">
              <div className="flex items-center justify-between">
                <div className="min-w-0">
                  <p className="text-xs text-gray-500 mb-1 truncate">{t('avgProgress')}</p>
                  <p className="text-2xl sm:text-3xl font-bold text-orange-400">
                    {Math.round(obras.reduce((acc, o) => acc + calcularProgresso(o), 0) / obras.length)}%
                  </p>
                </div>
                <TrendingUp className="w-7 sm:w-9 h-7 sm:h-9 text-orange-500 opacity-60 flex-shrink-0" />
              </div>
            </div>
          </div>

          {/* Lista de obras */}
          <div className="bg-gray-900/80 rounded-2xl border border-gray-800 p-4 sm:p-6">
            <div className="flex items-center justify-between mb-4 sm:mb-6">
              <h2 className="text-base sm:text-lg font-medium text-white flex items-center gap-2">
                <span className="w-1 h-5 bg-orange-500 rounded-full inline-block"></span>
                Minhas Obras
              </h2>
              <button
                onClick={() => setMostrarModalNovaObra(true)}
                className="flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-xs sm:text-sm font-medium rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all"
              >
                <Plus className="w-4 h-4" />
                <span className="hidden sm:inline">Nova</span> Obra
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {obras.map((obra) => {
                const progresso = calcularProgresso(obra);
                const servicosConcluidos = obra.servicos.filter(s => s.status === 'concluido').length;
                const totalServicos = obra.servicos.length;

                return (
                  <div
                    key={obra.id}
                    className="group bg-gray-900 border border-gray-800 rounded-2xl p-5 hover:border-gray-700 hover:shadow-md transition-all duration-200"
                  >
                    <div className="flex justify-between items-start mb-4">
                      <div className="flex gap-3 flex-1">
                        {/* Foto miniatura - estilo foto de perfil */}
                        <label className="relative w-16 h-16 rounded-xl overflow-hidden flex-shrink-0 cursor-pointer group/foto ring-2 ring-gray-700 group-hover:ring-orange-500/40 transition-all">
                          {obra.fotoCapa ? (
                            <img src={obra.fotoCapa.url} alt="Capa" className="w-full h-full object-cover" />
                          ) : (
                            <div className="w-full h-full bg-gray-800 border border-dashed border-gray-600 flex items-center justify-center">
                              <Building2 className="w-7 h-7 text-gray-500" />
                            </div>
                          )}
                          <div className="absolute inset-0 bg-black/60 flex items-center justify-center opacity-0 group-hover/foto:opacity-100 transition-opacity">
                            <svg className="w-5 h-5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                          </div>
                          <input
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (!file) return;
                              setCarregando(true);
                              const ext = file.name.split('.').pop().toLowerCase();
                              const path = `${obra.id}/${Date.now()}.${ext}`;
                              const { error: upErr } = await supabase.storage.from('fotos-obras').upload(path, file, { upsert: true });
                              if (!upErr) {
                                const { data: { publicUrl } } = supabase.storage.from('fotos-obras').getPublicUrl(path);
                                const { data: novaFoto } = await supabase.from('fotos').insert({ obra_id: obra.id, url: publicUrl, nome: file.name, is_capa: false }).select().single();
                                if (novaFoto) {
                                  const fotoLocal = { id: novaFoto.id, url: publicUrl, nome: file.name, data: novaFoto.created_at };
                                  await definirFotoCapa(obra.id, fotoLocal);
                                  atualizarObraLocal(obra.id, { fotos: [...(obra.fotos || []), fotoLocal] });
                                }
                              }
                              setCarregando(false);
                            }}
                          />
                        </label>

                        <div className="flex-1 min-w-0">
                          <h3 className="text-base font-semibold text-white group-hover:text-orange-300 transition-colors mb-1.5 truncate">
                            {obra.nome}
                          </h3>
                          {(() => {
                            const st = obra.status || 'em_andamento';
                            const statusConfig = {
                              mobilizacao: { label: 'Mobilização', bg: 'bg-blue-500/15', text: 'text-blue-400', border: 'border-blue-500/30' },
                              em_andamento: { label: 'Em Andamento', bg: 'bg-orange-500/15', text: 'text-orange-400', border: 'border-orange-500/30' },
                              finalizada: { label: 'Finalizada', bg: 'bg-green-500/15', text: 'text-green-400', border: 'border-green-500/30' },
                            };
                            const cfg = statusConfig[st] || statusConfig.em_andamento;
                            const statusOrder = ['mobilizacao', 'em_andamento', 'finalizada'];
                            return (
                              <div className="relative inline-block mb-1.5">
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    setStatusDropdownAberto(statusDropdownAberto === obra.id ? null : obra.id);
                                  }}
                                  className={`inline-flex items-center gap-1 px-2.5 py-0.5 ${cfg.bg} ${cfg.text} border ${cfg.border} rounded-full text-xs font-medium cursor-pointer hover:opacity-80 transition-opacity`}
                                >
                                  {cfg.label}
                                  <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7"/></svg>
                                </button>
                                {statusDropdownAberto === obra.id && (
                                  <div className="absolute top-full left-0 mt-1 bg-gray-800 border border-gray-700 rounded-xl shadow-xl z-50 overflow-hidden min-w-[140px]">
                                    {statusOrder.map((key) => {
                                      const c = statusConfig[key];
                                      return (
                                        <button
                                          key={key}
                                          type="button"
                                          onClick={async (e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            await supabase.from('obras').update({ status: key }).eq('id', obra.id);
                                            atualizarObraLocal(obra.id, { status: key });
                                            setStatusDropdownAberto(null);
                                          }}
                                          className={`w-full text-left px-3 py-2 text-xs font-medium hover:bg-gray-700 transition-colors ${c.text} ${st === key ? 'bg-gray-700/50' : ''}`}
                                        >
                                          {c.label}
                                        </button>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            );
                          })()}
                          <p className="text-sm text-gray-400 flex items-center gap-1 font-light">
                            <User className="w-3.5 h-3.5 flex-shrink-0" />
                            {obra.cliente}
                          </p>
                          <p className="text-xs text-gray-500 mt-0.5 truncate">{obra.endereco}</p>

                          {editandoEmail === obra.id ? (
                            <div className="mt-2 flex gap-2">
                              <input
                                type="email"
                                value={novoEmail}
                                onChange={(e) => setNovoEmail(e.target.value)}
                                placeholder="Email do cliente"
                                className="flex-1 px-2 py-1 text-xs bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:border-orange-500 focus:outline-none"
                              />
                              <button onClick={() => atualizarEmailCliente(obra.id)} className="px-2 py-1 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-xs rounded-lg">{t('save')}</button>
                              <button onClick={() => { setEditandoEmail(null); setNovoEmail(''); }} className="px-2 py-1 bg-gray-700 text-gray-300 text-xs rounded-lg">×</button>
                            </div>
                          ) : (
                            <div className="mt-1.5 flex items-center gap-1.5">
                              <Mail className="w-3 h-3 text-gray-600" />
                              <span className="text-xs text-gray-500 truncate">{obra.emailCliente}</span>
                              <button onClick={() => { setEditandoEmail(obra.id); setNovoEmail(obra.emailCliente); }} className="text-xs text-orange-500 hover:text-orange-400 flex-shrink-0">Editar</button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Barra de progresso */}
                    <div className="relative mb-4">
                      <div className="flex justify-between items-center mb-1.5">
                        <span className="text-xs text-gray-400 font-light">{t('progress')}</span>
                        <span className="text-xs font-bold text-orange-400">{progresso}%</span>
                      </div>
                      <div className="w-full bg-gray-700/60 rounded-full h-2">
                        <div
                          className="bg-gradient-to-r from-orange-500 to-amber-400 h-2 rounded-full transition-all duration-500 shadow-none"
                          style={{ width: `${progresso}%` }}
                        />
                      </div>
                    </div>

                    {/* Métricas */}
                    <div className="grid grid-cols-3 gap-3 mb-4">
                      <div className="bg-gray-800/60 rounded-xl p-2.5 text-center">
                        <p className="text-xs text-gray-500 mb-0.5 font-light">{t('budget')}</p>
                        <p className="text-xs font-bold text-white">R$ {(obra.orcamentoTotal / 1000).toFixed(0)}k</p>
                      </div>
                      <div className="bg-gray-800/60 rounded-xl p-2.5 text-center">
                        <p className="text-xs text-gray-500 mb-0.5 font-light">{t('services')}</p>
                        <p className="text-xs font-bold text-white">{servicosConcluidos}/{totalServicos}</p>
                      </div>
                      <div className="bg-gray-800/60 rounded-xl p-2.5 text-center">
                        <p className="text-xs text-gray-500 mb-0.5 font-light">Previsão</p>
                        <p className="text-xs font-bold text-white">{calcularDataConclusao(obra)}</p>
                      </div>
                    </div>

                    {/* Rodapé do card */}
                    <div className="flex justify-between items-center pt-3 border-t border-gray-800">
                      <div className="flex items-center gap-1.5 text-xs text-gray-500 font-light">
                        <Calendar className="w-3.5 h-3.5" />
                        <span>Início: {parseLocalDate(obra.inicio).toLocaleDateString('pt-BR')}</span>
                      </div>
                      <div className="flex items-center gap-3">
                        <button
                          onClick={() => abrirEdicaoObra(obra)}
                          className="flex items-center gap-1 text-xs text-gray-400 hover:text-orange-400 transition-colors"
                          title="Editar obra"
                        >
                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                          </svg>
                          Editar
                        </button>
                        <button
                          onClick={() => selecionarObra(obra)}
                          className="flex items-center gap-1.5 text-xs text-orange-400 font-medium hover:text-orange-300 hover:gap-2.5 transition-all"
                        >
                          Ver detalhes
                          <span>→</span>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          )}
        </main>

        {/* Modal Nova Obra */}
        {mostrarModalNovaObra && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/70 " onClick={() => setMostrarModalNovaObra(false)} />
            <div className="relative z-10 w-full max-w-lg bg-gray-900 border border-gray-800 rounded-2xl shadow-xl overflow-hidden">
              <div className="flex items-center justify-between px-6 py-5 border-b border-gray-800">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-br from-orange-500 to-amber-500 rounded-xl">
                    <Building2 className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h2 className="text-base font-semibold text-white">Nova Obra</h2>
                    <p className="text-xs text-gray-400 font-light">Preencha os dados para cadastrar</p>
                  </div>
                </div>
                <button onClick={() => setMostrarModalNovaObra(false)} className="p-2 hover:bg-gray-800 rounded-xl transition-colors text-gray-400 hover:text-white">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="px-6 py-5 space-y-4">
                <div>
                  <label className="block text-xs font-medium text-gray-400 mb-1.5">{t('projectName')} <span className="text-orange-500">*</span></label>
                  <input type="text" placeholder="Ex: Construção Residencial - Casa Silva"
                    value={novaObra.nome} onChange={e => setNovaObra({ ...novaObra, nome: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-orange-500 focus:outline-none transition-colors" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs font-medium text-gray-400 mb-1.5">Cliente <span className="text-orange-500">*</span></label>
                    <input type="text" placeholder="Nome do cliente"
                      value={novaObra.cliente} onChange={e => setNovaObra({ ...novaObra, cliente: e.target.value })}
                      className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-orange-500 focus:outline-none transition-colors" />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-400 mb-1.5">E-mail do Cliente <span className="text-orange-500">*</span></label>
                    <input type="email" placeholder="cliente@email.com"
                      value={novaObra.emailCliente} onChange={e => setNovaObra({ ...novaObra, emailCliente: e.target.value })}
                      className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-orange-500 focus:outline-none transition-colors" />
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-400 mb-1.5">Endereço</label>
                  <input type="text" placeholder="Ex: Rua das Flores, 123 - Centro"
                    value={novaObra.endereco} onChange={e => setNovaObra({ ...novaObra, endereco: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-orange-500 focus:outline-none transition-colors" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs font-medium text-gray-400 mb-1.5">{t('startDate')} <span className="text-orange-500">*</span></label>
                    <input type="date" value={novaObra.inicio} onChange={e => setNovaObra({ ...novaObra, inicio: e.target.value })}
                      className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm focus:border-orange-500 focus:outline-none transition-colors" />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-400 mb-1.5">Orçamento Total (R$) <span className="text-orange-500">*</span></label>
                    <input type="number" placeholder="Ex: 150000"
                      value={novaObra.orcamentoTotal} onChange={e => setNovaObra({ ...novaObra, orcamentoTotal: e.target.value })}
                      className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-orange-500 focus:outline-none transition-colors" />
                  </div>
                </div>
                <p className="text-xs text-gray-600 font-light"><span className="text-orange-500">*</span> Campos obrigatórios. Serviços podem ser adicionados após criar a obra.</p>
              </div>
              <div className="flex gap-3 px-6 py-4 border-t border-gray-800">
                <button onClick={() => setMostrarModalNovaObra(false)}
                  className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-xl hover:border-gray-600 hover:text-white transition-all">
                  Cancelar
                </button>
                <button onClick={adicionarObra}
                  disabled={!novaObra.nome || !novaObra.cliente || !novaObra.emailCliente || !novaObra.inicio || !novaObra.orcamentoTotal}
                  className="flex-1 px-4 py-2.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-medium rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-2">
                  <Plus className="w-4 h-4" />
                  Cadastrar Obra
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Modal Editar Obra ── */}
        {editandoObra && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/70 " onClick={() => setEditandoObra(null)} />
            <div className="relative z-10 w-full max-w-lg bg-gray-900 border border-gray-800 rounded-2xl shadow-xl overflow-hidden">

              {/* Header */}
              <div className="flex items-center justify-between px-6 py-5 border-b border-gray-800">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-orange-500/15 rounded-xl">
                    <svg className="w-5 h-5 text-orange-400" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-white">Editar Obra</h3>
                    <p className="text-xs text-gray-400 font-light">Atualize as informações da obra</p>
                  </div>
                </div>
                <button onClick={() => setEditandoObra(null)} className="p-2 hover:bg-gray-800 rounded-xl transition-colors text-gray-400 hover:text-white">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
                  </svg>
                </button>
              </div>

              {/* Campos */}
              <div className="px-6 py-5 space-y-4 max-h-[60vh] overflow-y-auto">

                <div>
                  <label className="block text-xs font-medium text-gray-400 mb-1.5">Nome da Obra <span className="text-orange-500">*</span></label>
                  <input
                    type="text"
                    value={formEditObra.nome}
                    onChange={e => setFormEditObra(p => ({ ...p, nome: e.target.value }))}
                    placeholder="Ex: Reforma Cozinha — Família Silva"
                    className="w-full px-3.5 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500/30 focus:outline-none transition"
                  />
                </div>

                <div>
                  <label className="block text-xs font-medium text-gray-400 mb-1.5">Nome do Cliente <span className="text-orange-500">*</span></label>
                  <input
                    type="text"
                    value={formEditObra.cliente}
                    onChange={e => setFormEditObra(p => ({ ...p, cliente: e.target.value }))}
                    placeholder="Ex: João Santos"
                    className="w-full px-3.5 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500/30 focus:outline-none transition"
                  />
                </div>

                <div>
                  <label className="block text-xs font-medium text-gray-400 mb-1.5">Email do Cliente <span className="text-orange-500">*</span></label>
                  <input
                    type="email"
                    value={formEditObra.emailCliente}
                    onChange={e => setFormEditObra(p => ({ ...p, emailCliente: e.target.value }))}
                    placeholder="cliente@email.com"
                    className="w-full px-3.5 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500/30 focus:outline-none transition"
                  />
                </div>

                <div>
                  <label className="block text-xs font-medium text-gray-400 mb-1.5">Endereço</label>
                  <input
                    type="text"
                    value={formEditObra.endereco}
                    onChange={e => setFormEditObra(p => ({ ...p, endereco: e.target.value }))}
                    placeholder="Rua, número, bairro, cidade"
                    className="w-full px-3.5 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500/30 focus:outline-none transition"
                  />
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs font-medium text-gray-400 mb-1.5">Data de Início <span className="text-orange-500">*</span></label>
                    <input
                      type="date"
                      value={formEditObra.inicio}
                      onChange={e => setFormEditObra(p => ({ ...p, inicio: e.target.value }))}
                      className="w-full px-3.5 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm focus:border-orange-500 focus:ring-1 focus:ring-orange-500/30 focus:outline-none transition"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-400 mb-1.5">Orçamento (R$) <span className="text-orange-500">*</span></label>
                    <input
                      type="number"
                      value={formEditObra.orcamentoTotal}
                      onChange={e => setFormEditObra(p => ({ ...p, orcamentoTotal: e.target.value }))}
                      placeholder="0"
                      className="w-full px-3.5 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500/30 focus:outline-none transition"
                    />
                  </div>
                </div>

                <p className="text-xs text-gray-600 font-light"><span className="text-orange-500">*</span> Campos obrigatórios.</p>
              </div>

              {/* Botões */}
              <div className="flex gap-3 px-6 py-4 border-t border-gray-800">
                <button
                  onClick={() => setEditandoObra(null)}
                  className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-xl hover:border-gray-600 hover:text-white transition-all"
                >
                  Cancelar
                </button>
                <button
                  onClick={salvarEdicaoObra}
                  disabled={!formEditObra.nome || !formEditObra.cliente || !formEditObra.emailCliente || !formEditObra.inicio || !formEditObra.orcamentoTotal}
                  className="flex-1 px-4 py-2.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-medium rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"/>
                  </svg>
                  Salvar Alterações
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // Detalhes da Obra
  if (telaAtual === 'detalhes-obra' && obraSelecionada) {
    const progressoReal = calcularProgresso(obraSelecionada);
    // ── Gasto real: soma valorPago + compras materiais (prestador) | valorRecebido (cliente) ──
    const totalPagoObra   = obraSelecionada.servicos.reduce((t, s) => t + (s.valorPago || 0), 0) + (comprasMatPorObra[obraSelecionada.id] || 0);
    const totalVendaConcl = obraSelecionada.servicos.filter(s => s.status === 'concluido').reduce((t, s) => t + (s.valorVenda || s.custo || 0), 0);
    const valorPagoCliente = obraSelecionada.valorRecebido || 0;
    const gastoExibido    = usuarioLogado?.tipo === 'prestador' ? totalPagoObra : valorPagoCliente;
    const labelGasto      = usuarioLogado?.tipo === 'prestador' ? 'Gasto' : 'Investimento';
    const dadosCustos = [
      { name: 'Planejado',  value: obraSelecionada.orcamentoTotal },
      { name: labelGasto,   value: gastoExibido },
      { name: 'Restante',   value: Math.max(0, obraSelecionada.orcamentoTotal - gastoExibido) }
    ];
    const COLORS = ['#3b82f6', '#10b981', '#f59e0b'];

    return (
      <div className="min-h-screen bg-gray-950">
        {/* Header */}
        <header className="bg-gray-900 border-b border-gray-800 shadow-sm">
          <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-3 sm:py-4">
            <div className="flex justify-between items-center gap-2">
              <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
                {usuarioLogado?.tipo === 'prestador' && (
                  <button onClick={voltarHome} className="p-2 hover:bg-gray-800 rounded-xl transition-colors group flex-shrink-0">
                    <svg className="w-5 h-5 text-gray-400 group-hover:text-orange-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                  </button>
                )}

                {obraSelecionada?.fotoCapa ? (
                  <div className="w-9 h-9 sm:w-11 sm:h-11 rounded-xl overflow-hidden ring-2 ring-orange-500/30 flex-shrink-0">
                    <img src={obraSelecionada.fotoCapa.url} alt="Capa" className="w-full h-full object-cover" />
                  </div>
                ) : (
                  <LogoNOA className="w-12 sm:w-14 h-12 sm:h-14 flex-shrink-0" />
                )}

                <div className="min-w-0">
                  <h1 className="text-sm sm:text-lg font-medium text-white leading-tight truncate">{obraSelecionada.nome}</h1>
                  <p className="text-xs text-gray-500 truncate">{obraSelecionada.cliente}</p>
                </div>
              </div>

              <div className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0">
                {usuarioLogado?.tipo === 'prestador' && (
                  <button
                    onClick={() => setMostrarRelatorio(true)}
                    className="flex items-center gap-1.5 px-2.5 sm:px-4 py-2 bg-orange-500/10 border border-orange-500/30 text-orange-400 rounded-xl hover:border-orange-500/50 hover:bg-orange-500/15 transition-all font-medium text-sm"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                    <span className="hidden sm:inline">Relatório</span>
                  </button>
                )}
                <button
                  onClick={logout}
                  className="flex items-center gap-1.5 px-2.5 sm:px-4 py-2 bg-gray-800 border border-gray-700 text-gray-300 rounded-xl hover:border-gray-600 hover:text-white transition-all text-sm"
                >
                  <LogOut className="w-4 h-4" />
                  <span className="hidden sm:inline">Sair</span>
                </button>
              </div>
            </div>
          </div>
        </header>

        <main className="relative z-10 max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-4 sm:py-8">

          {/* Cards de métricas */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
            <div className="bg-gray-900 rounded-2xl p-4 border border-gray-800 hover:border-gray-700 transition-all min-w-0">
              <div className="flex items-center justify-between gap-1">
                <div className="min-w-0 flex-1">
                  <p className="text-xs text-gray-400 font-light mb-1 truncate">{t('progress')}</p>
                  <p className="text-xl sm:text-2xl font-bold text-orange-400">{progressoReal}%</p>
                </div>
                <TrendingUp className="w-8 h-8 text-orange-500 opacity-50 flex-shrink-0" />
              </div>
            </div>

            <div className="bg-gray-900 rounded-2xl p-4 border border-gray-800 hover:border-gray-700 transition-all min-w-0">
              {editandoOrcamento && usuarioLogado?.tipo === 'prestador' ? (
                <div>
                  <p className="text-xs text-gray-400 font-light mb-2">Orçamento Atual da Obra</p>
                  <div className="flex items-center gap-2">
                    <input
                      type="number"
                      autoFocus
                      value={novoOrcamento}
                      onChange={e => setNovoOrcamento(e.target.value)}
                      onKeyDown={e => { if (e.key === 'Enter') salvarOrcamento(); if (e.key === 'Escape') { setEditandoOrcamento(false); setNovoOrcamento(''); } }}
                      placeholder={String(obraSelecionada.orcamentoTotal)}
                      className="flex-1 min-w-0 px-2 py-1.5 text-sm bg-gray-900 border border-orange-500/60 rounded-lg text-white placeholder-gray-600 focus:outline-none focus:border-orange-500 transition-colors"
                    />
                    <button onClick={salvarOrcamento} className="flex-shrink-0 p-1.5 bg-orange-500 hover:bg-orange-600 rounded-lg transition-colors">
                      <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7"/></svg>
                    </button>
                    <button onClick={() => { setEditandoOrcamento(false); setNovoOrcamento(''); }} className="flex-shrink-0 p-1.5 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors">
                      <svg className="w-3.5 h-3.5 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/></svg>
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex items-center justify-between gap-1">
                  <div className="min-w-0 flex-1">
                    <p className="text-xs text-gray-400 font-light mb-1 truncate">Orçamento Atual da Obra</p>
                    <p className="text-base sm:text-lg font-bold text-green-400 truncate">R$ {(obraSelecionada.orcamentoTotal/1000).toFixed(0)}k</p>
                  </div>
                  <div className="flex items-center gap-2">
                    {usuarioLogado?.tipo === 'prestador' && (
                      <button
                        onClick={() => { setNovoOrcamento(String(obraSelecionada.orcamentoTotal)); setEditandoOrcamento(true); }}
                        className="p-1.5 hover:bg-orange-500/20 border border-transparent hover:border-gray-700 rounded-lg transition-all"
                        title="Editar orçamento"
                      >
                        <svg className="w-3.5 h-3.5 text-gray-500 hover:text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>
                      </button>
                    )}
                    <DollarSign className="w-9 h-9 text-green-500 opacity-50" />
                  </div>
                </div>
              )}
            </div>

            <div className="bg-gray-900 rounded-2xl p-4 border border-gray-800 hover:border-gray-700 transition-all min-w-0">
              <div className="flex items-center justify-between gap-1">
                <div className="min-w-0 flex-1">
                  <p className="text-xs text-gray-400 font-light mb-1 truncate">{usuarioLogado?.tipo === 'cliente' ? 'Investimento Atual' : 'Gasto Atual'}</p>
                  <p className="text-base sm:text-lg font-bold text-amber-400 truncate">R$ {(gastoExibido/1000).toFixed(0)}k</p>
                </div>
                <BarChart3 className="w-8 h-8 text-amber-500 opacity-50 flex-shrink-0" />
              </div>
            </div>

            <div className="bg-gray-900 rounded-2xl p-4 border border-gray-800 hover:border-gray-700 transition-all min-w-0">
              <div className="flex items-center justify-between gap-1">
                <div className="min-w-0 flex-1">
                  <p className="text-xs text-gray-400 font-light mb-1 truncate">Previsão</p>
                  <p className="text-sm sm:text-base font-bold text-white">{calcularDataConclusao(obraSelecionada)}</p>
                </div>
                <Calendar className="w-8 h-8 text-orange-500 opacity-50 flex-shrink-0" />
              </div>
            </div>
          </div>

          {/* Executado x Pago — somente Prestador */}
          {usuarioLogado?.tipo === 'prestador' && (
            <ExecutadoPagoSection obra={obraSelecionada} />
          )}

          {/* Indicador de Saúde da Obra — somente Prestador */}
          {usuarioLogado?.tipo === 'prestador' && (
            <SaudeSection obra={obraSelecionada} />
          )}

          {/* Indicador Crítico de Margem — somente Prestador */}
          {usuarioLogado?.tipo === 'prestador' && (
            <MargemSection obra={obraSelecionada} />
          )}

          {/* Abas de navegação — somente prestador vê Performance */}
          {usuarioLogado?.tipo === 'prestador' ? (
            <div className="flex gap-1 mb-4 bg-gray-900 p-1 rounded-xl border border-gray-800 overflow-x-auto">
              {[
                {
                  id: 'cronograma',
                  label: 'Cronograma',
                  icon: (active) => (
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                      stroke={active ? 'white' : '#f97316'} strokeWidth="1.8"
                      strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="4" width="18" height="16" rx="2"/>
                      <line x1="3" y1="9" x2="21" y2="9"/>
                      <line x1="8" y1="2" x2="8" y2="6"/>
                      <line x1="16" y1="2" x2="16" y2="6"/>
                      <line x1="7" y1="14" x2="17" y2="14"/>
                      <line x1="7" y1="18" x2="13" y2="18"/>
                    </svg>
                  )
                },
                {
                  id: 'performance',
                  label: 'Performance',
                  icon: (active) => (
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                      stroke={active ? 'white' : '#f97316'} strokeWidth="1.8"
                      strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
                    </svg>
                  )
                },
                {
                  id: 'timeline',
                  label: 'Linha do Tempo',
                  icon: (active) => (
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                      stroke={active ? 'white' : '#f97316'} strokeWidth="1.8"
                      strokeLinecap="round" strokeLinejoin="round">
                      <line x1="12" y1="2" x2="12" y2="22"/>
                      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                    </svg>
                  )
                },
                {
                  id: 'prestadores',
                  label: 'Controle de Prestadores',
                  icon: (active) => (
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                      stroke={active ? 'white' : '#f97316'} strokeWidth="1.8"
                      strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                      <circle cx="9" cy="7" r="4"/>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                    </svg>
                  )
                },
                {
                  id: 'compras',
                  label: 'Compras de Materiais',
                  icon: (active) => (
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                      stroke={active ? 'white' : '#f97316'} strokeWidth="1.8"
                      strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
                    </svg>
                  )
                },
              ].map(aba => (
                <button
                  key={aba.id}
                  onClick={() => setAbaDetalhes(aba.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                    abaDetalhes === aba.id
                      ? 'bg-orange-500 text-white shadow'
                      : 'text-gray-400 hover:text-white'
                  }`}
                >
                  {aba.icon(abaDetalhes === aba.id)}
                  {aba.label}
                </button>
              ))}
            </div>
          ) : (
            <div className="flex gap-1 mb-4 bg-gray-900 p-1 rounded-xl border border-gray-800 overflow-x-auto">
              {[
                {
                  id: 'cronograma',
                  label: 'Cronograma',
                  icon: (active) => (
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                      stroke={active ? 'white' : '#f97316'} strokeWidth="1.8"
                      strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="4" width="18" height="16" rx="2"/>
                      <line x1="3" y1="9" x2="21" y2="9"/>
                      <line x1="8" y1="2" x2="8" y2="6"/>
                      <line x1="16" y1="2" x2="16" y2="6"/>
                    </svg>
                  )
                },
                {
                  id: 'timeline',
                  label: 'Linha do Tempo',
                  icon: (active) => (
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                      stroke={active ? 'white' : '#f97316'} strokeWidth="1.8"
                      strokeLinecap="round" strokeLinejoin="round">
                      <line x1="12" y1="2" x2="12" y2="22"/>
                      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                    </svg>
                  )
                },
                {
                  id: 'compras',
                  label: 'Materiais',
                  icon: (active) => (
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                      stroke={active ? 'white' : '#f97316'} strokeWidth="1.8"
                      strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
                    </svg>
                  )
                },
              ].map(aba => (
                <button
                  key={aba.id}
                  onClick={() => setAbaDetalhes(aba.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                    abaDetalhes === aba.id
                      ? 'bg-orange-500 text-white shadow'
                      : 'text-gray-400 hover:text-white'
                  }`}
                >
                  {aba.icon(abaDetalhes === aba.id)}
                  {aba.label}
                </button>
              ))}
            </div>
          )}

          {/* Aba Performance — somente prestador */}
          {usuarioLogado?.tipo === 'prestador' && abaDetalhes === 'performance' && (
            <PerformanceTab obra={obraSelecionada} />
          )}

          {/* Aba Controle de Prestadores — somente prestador */}
          {usuarioLogado?.tipo === 'prestador' && abaDetalhes === 'prestadores' && (
            <ControlePrestadoresTab obras={obras} obraAtual={obraSelecionada} />
          )}

          {/* Aba Compras de Materiais — prestador vê tudo, cliente vê resumo contratual */}
          {abaDetalhes === 'compras' && (
            <ComprasMateriaisTab obra={obraSelecionada} isPrestador={usuarioLogado?.tipo === 'prestador'} />
          )}

          {/* Aba Change Orders — prestador + cliente */}
          {abaDetalhes === 'changeOrders' && (
            <ChangeOrdersTab obra={obraSelecionada} isPrestador={usuarioLogado?.tipo === 'prestador'} />
          )}

          {/* Aba Linha do Tempo — prestador + cliente */}
          {abaDetalhes === 'timeline' && (
            <LinhaDoTempoTab />
          )}

          {/* Aba Cronograma */}
          {abaDetalhes === 'cronograma' && (
          <>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Coluna principal — Cronograma */}
            <div className="lg:col-span-2 min-w-0 space-y-4">
              <div className="bg-gray-900/80 rounded-2xl border border-gray-800 p-6">
                <div className="flex justify-between items-center mb-5">
                  <h2 className="text-base font-medium text-white flex items-center gap-2">
                    <span className="w-1 h-5 bg-orange-500 rounded-full inline-block"></span>
                    Cronograma de Serviços
                  </h2>
                  {usuarioLogado?.tipo === 'prestador' && (
                    <button
                      onClick={() => setMostrarForm(!mostrarForm)}
                      className="px-3 py-1.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all flex items-center gap-1.5"
                    >
                      <Plus className="w-4 h-4" />
                      Adicionar Serviço
                    </button>
                  )}
                </div>

                {mostrarForm && usuarioLogado?.tipo === 'prestador' && (
                  <div className="mb-5 p-5 bg-gray-900 rounded-xl border border-orange-500/20">
                    <h3 className="text-sm font-semibold text-orange-400 mb-4 flex items-center gap-2">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4"/></svg>
                      Novo Serviço
                    </h3>

                    {/* Linha 1 — Identificação */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3">
                      <div>
                        <label className="block text-xs text-gray-400 mb-1">Nome do serviço <span className="text-orange-500">*</span></label>
                        <input type="text" placeholder="Ex: Fundação"
                          value={novoServico.nome}
                          onChange={(e) => setNovoServico({...novoServico, nome: e.target.value})}
                          className="w-full px-3 py-2 text-sm bg-gray-800 border border-gray-600 rounded-xl text-white placeholder-gray-500 focus:border-orange-500 focus:outline-none" />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-400 mb-1">Duração (dias) <span className="text-orange-500">*</span></label>
                        <input type="number" placeholder="Ex: 15"
                          value={novoServico.duracao}
                          onChange={(e) => setNovoServico({...novoServico, duracao: e.target.value})}
                          className="w-full px-3 py-2 text-sm bg-gray-800 border border-gray-600 rounded-xl text-white placeholder-gray-500 focus:border-orange-500 focus:outline-none" />
                      </div>
                    </div>

                    {/* Linha 2 — Valores financeiros */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                      <div>
                        <label className="block text-xs mb-1">
                          <span className="text-blue-400">●</span> <span className="text-gray-400">Valor vendido ao cliente (R$)</span>
                        </label>
                        <input type="number" placeholder="Ex: 35000"
                          value={novoServico.valorVenda}
                          onChange={(e) => setNovoServico({...novoServico, valorVenda: e.target.value})}
                          className="w-full px-3 py-2 text-sm bg-gray-800 border border-gray-600 rounded-xl text-white placeholder-gray-500 focus:border-blue-500 focus:outline-none" />
                      </div>
                      <div>
                        <label className="block text-xs mb-1">
                          <span className="text-amber-400">●</span> <span className="text-gray-400">Valor contratado c/ prestador (R$)</span>
                        </label>
                        <input type="number" placeholder="Ex: 28000"
                          value={novoServico.valorCustoContratado}
                          onChange={(e) => setNovoServico({...novoServico, valorCustoContratado: e.target.value})}
                          className="w-full px-3 py-2 text-sm bg-gray-800 border border-gray-600 rounded-xl text-white placeholder-gray-500 focus:border-amber-500 focus:outline-none" />
                      </div>
                    </div>

                    {/* Linha 3 — Prestador e Datas */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
                      <div className="sm:col-span-1">
                        <label className="block text-xs mb-1">
                          <span className="text-orange-400">●</span> <span className="text-gray-400">Prestador responsável</span>
                        </label>
                        <input type="text" placeholder="Ex: João Pedreiro"
                          value={novoServico.nomePrestador}
                          onChange={(e) => setNovoServico({...novoServico, nomePrestador: e.target.value})}
                          className="w-full px-3 py-2 text-sm bg-gray-800 border border-gray-600 rounded-xl text-white placeholder-gray-500 focus:border-orange-500 focus:outline-none" />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-400 mb-1">Data início acordada</label>
                        <input type="date"
                          value={novoServico.dataInicioAcordada}
                          onChange={(e) => setNovoServico({...novoServico, dataInicioAcordada: e.target.value})}
                          className="w-full px-3 py-2 text-sm bg-gray-800 border border-gray-600 rounded-xl text-white placeholder-gray-500 focus:border-orange-500 focus:outline-none" />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-400 mb-1">Data entrega acordada</label>
                        <input type="date"
                          value={novoServico.dataEntregaAcordada}
                          onChange={(e) => setNovoServico({...novoServico, dataEntregaAcordada: e.target.value})}
                          className="w-full px-3 py-2 text-sm bg-gray-800 border border-gray-600 rounded-xl text-white placeholder-gray-500 focus:border-orange-500 focus:outline-none" />
                      </div>
                    </div>

                    {/* Preview margem em tempo real */}
                    {novoServico.valorVenda && novoServico.valorCustoContratado && (() => {
                      const v = parseFloat(novoServico.valorVenda) || 0;
                      const c = parseFloat(novoServico.valorCustoContratado) || 0;
                      const m = v > 0 ? ((v - c) / v * 100) : null;
                      const cor = m === null ? '#64748b' : m >= 20 ? '#22c55e' : m >= 15 ? '#86efac' : m >= 0 ? '#eab308' : '#ef4444';
                      return (
                        <div className="mb-3 px-3 py-2 rounded-xl border flex items-center justify-between text-xs" style={{ borderColor: cor + '40', background: cor + '12' }}>
                          <span className="text-gray-400">Margem prevista desta etapa</span>
                          <span className="font-bold" style={{ color: cor }}>
                            {m !== null ? m.toFixed(2) + '%' : '—'}
                          </span>
                        </div>
                      );
                    })()}

                    <div className="flex gap-2">
                      <button onClick={adicionarServico}
                        className="px-4 py-2 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-medium rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all flex items-center gap-2">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"/></svg>
                        Salvar Serviço
                      </button>
                      <button onClick={() => { setMostrarForm(false); setNovoServico({ nome: '', duracao: '', custo: '', valorVenda: '', valorCustoContratado: '' }); }}
                        className="px-4 py-2 bg-gray-800 border border-gray-700 text-gray-400 text-sm rounded-xl hover:border-gray-600 hover:text-white transition-all">
                        Cancelar
                      </button>
                    </div>
                  </div>
                )}

                <div className="space-y-3 overflow-x-hidden">
                  {(!obraSelecionada.servicos || obraSelecionada.servicos.length === 0) ? (
                    <div className="text-center py-8 text-gray-400">
                      <p className="text-sm">Nenhum serviço cadastrado ainda.</p>
                    </div>
                  ) : obraSelecionada.servicos.map((servico) => {
                    const etapasConcluidas = servico.etapas?.filter(e => e.concluida).length || 0;
                    const totalEtapas = servico.etapas?.length || 0;
                    const progressoEtapas = totalEtapas > 0 ? Math.round((etapasConcluidas / totalEtapas) * 100) : 0;
                    const expandido = servicoExpandido === servico.id;

                    return (
                      <div key={servico.id} className={`rounded-xl border transition-all ${
                        servico.status === 'concluido'
                          ? 'bg-green-900/20 border-green-500/30'
                          : servico.status === 'em_andamento'
                          ? 'bg-orange-900/20 border-orange-500/30'
                          : 'bg-gray-900/40 border-gray-800'
                      }`}>
                        <div className="p-4">
                          <div className="flex justify-between items-start">
                            <div className="flex-1">
                              <div className="flex items-center gap-3 mb-1.5">
                                {servico.status === 'concluido' && <CheckCircle className="w-4 h-4 text-green-400 flex-shrink-0" />}
                                {servico.status === 'em_andamento' && <Clock className="w-4 h-4 text-orange-400 flex-shrink-0" />}
                                {servico.status === 'pendente' && <AlertCircle className="w-4 h-4 text-gray-500 flex-shrink-0" />}
                                <h3 className="font-medium text-white text-sm">{servico.nome}</h3>
                                <button
                                  onClick={() => setServicoExpandido(expandido ? null : servico.id)}
                                  className="ml-auto p-1 hover:bg-gray-700/50 rounded-lg transition-colors"
                                >
                                  <svg className={`w-4 h-4 text-gray-400 transition-transform ${expandido ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                  </svg>
                                </button>
                              </div>
                              <div className="flex gap-4 text-xs text-gray-500 ml-7">
                                <span className="flex items-center gap-1"><Calendar className="w-3 h-3" />{servico.duracao} dias</span>
                                <span className="flex items-center gap-1"><DollarSign className="w-3 h-3" />R$ {servico.custo.toLocaleString('pt-BR')}</span>
                                {totalEtapas > 0 && (
                                  <span className="text-orange-400 font-medium">{etapasConcluidas}/{totalEtapas} etapas • {progressoEtapas}%</span>
                                )}
                              </div>
                            </div>
                            {usuarioLogado?.tipo === 'prestador' && (
                              <div className="flex items-center gap-1.5 ml-2 flex-shrink-0 flex-wrap justify-end">
                                {servico.status !== 'concluido' && (
                                  <button
                                    onClick={() => atualizarStatusServico(servico.id, servico.status === 'pendente' ? 'em_andamento' : 'concluido')}
                                    className={`px-3 py-1 rounded-lg text-xs font-medium transition-colors ${
                                      servico.status === 'pendente'
                                        ? 'bg-orange-500/20 text-orange-400 border border-orange-500/30 hover:bg-orange-500/30'
                                        : 'bg-green-500/20 text-green-400 border border-green-500/30 hover:bg-green-500/30'
                                    }`}
                                  >
                                    {servico.status === 'pendente' ? 'Iniciar' : 'Concluir'}
                                  </button>
                                )}
                                <button
                                  onClick={() => { setEditandoServico(servico.id); setServicoEmEdicao({ nome: servico.nome, duracao: String(servico.duracao), custo: String(servico.custo), valorVenda: String(servico.valorVenda || ''), valorCustoContratado: String(servico.valorCustoContratado || ''), valorPago: String(servico.valorPago || ''), nomePrestador: servico.nomePrestador || '', dataInicioAcordada: servico.dataInicioAcordada || '', dataEntregaAcordada: servico.dataEntregaAcordada || '' }); }}
                                  className="p-1.5 rounded-lg bg-gray-700/50 hover:bg-blue-500/20 hover:text-blue-400 text-gray-400 border border-gray-800 hover:border-blue-500/30 transition-all"
                                  title="Editar serviço"
                                >
                                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                  </svg>
                                </button>
                                <button
                                  onClick={() => setConfirmarExclusaoServico(servico.id)}
                                  className="p-1.5 rounded-lg bg-gray-700/50 hover:bg-red-500/20 hover:text-red-400 text-gray-400 border border-gray-800 hover:border-red-500/30 transition-all"
                                  title="Excluir serviço"
                                >
                                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                  </svg>
                                </button>
                              </div>
                            )}
                          </div>

                          {/* Área expandida */}
                          {expandido && (
                            <div className="mt-4 pt-4 border-t border-gray-800 space-y-5">

                              {/* Etapas */}
                              <div>
                                <div className="flex justify-between items-center mb-2.5">
                                  <h4 className="text-xs font-semibold text-gray-300 uppercase tracking-wider flex items-center gap-1.5">
                                    <svg className="w-3.5 h-3.5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                    </svg>
                                    Etapas
                                  </h4>
                                  {usuarioLogado?.tipo === 'prestador' && (
                                    <button onClick={() => setMostrarFormEtapa(mostrarFormEtapa === servico.id ? null : servico.id)}
                                      className="text-xs text-orange-400 hover:text-orange-300 flex items-center gap-1">
                                      <Plus className="w-3.5 h-3.5" /> Adicionar
                                    </button>
                                  )}
                                </div>
                                {mostrarFormEtapa === servico.id && usuarioLogado?.tipo === 'prestador' && (
                                  <div className="mb-2 flex gap-2">
                                    <input type="text" placeholder="Nome da etapa" value={novaEtapa.nome}
                                      onChange={(e) => setNovaEtapa({ ...novaEtapa, nome: e.target.value })}
                                      className="flex-1 px-3 py-1.5 text-xs bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:border-orange-500 focus:outline-none" />
                                    <button onClick={() => adicionarEtapa(servico.id)}
                                      className="px-3 py-1.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-xs rounded-lg">{t('save')}</button>
                                  </div>
                                )}
                                {servico.etapas && servico.etapas.length > 0 ? (
                                  <div className="space-y-1.5">
                                    {servico.etapas.map((etapa) => (
                                      <div key={etapa.id} className="flex items-center gap-2.5 p-2 rounded-lg bg-gray-800/60 border border-gray-800 hover:border-gray-600/60 transition-colors">
                                        <input type="checkbox" checked={etapa.concluida}
                                          onChange={() => usuarioLogado?.tipo === 'prestador' && toggleEtapa(servico.id, etapa.id)}
                                          disabled={usuarioLogado?.tipo !== 'prestador'}
                                          className="w-3.5 h-3.5 accent-orange-500 cursor-pointer disabled:cursor-default" />
                                        <span className={`text-xs flex-1 ${etapa.concluida ? 'line-through text-gray-600' : 'text-gray-300'}`}>{etapa.nome}</span>
                                        {etapa.concluida && <CheckCircle className="w-3.5 h-3.5 text-green-400" />}
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <p className="text-xs text-gray-600 italic">Nenhuma etapa definida ainda</p>
                                )}
                              </div>

                              {/* Materiais */}
                              <div>
                                <div className="flex justify-between items-center mb-2.5">
                                  <h4 className="text-xs font-semibold text-gray-300 uppercase tracking-wider flex items-center gap-1.5">
                                    <svg className="w-3.5 h-3.5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                    </svg>
                                    Materiais
                                  </h4>
                                  {usuarioLogado?.tipo === 'prestador' && (
                                    <button onClick={() => setMostrarFormMaterial(mostrarFormMaterial === servico.id ? null : servico.id)}
                                      className="text-xs text-orange-400 hover:text-orange-300 flex items-center gap-1">
                                      <Plus className="w-3.5 h-3.5" /> Adicionar
                                    </button>
                                  )}
                                </div>
                                {mostrarFormMaterial === servico.id && usuarioLogado?.tipo === 'prestador' && (
                                  <div className="mb-3 p-3 bg-gray-900 rounded-xl border border-orange-500/20">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-2">
                                      {['Nome do material','Quantidade','Unidade (ex: m³, kg)','Fornecedor'].map((ph, i) => {
                                        const keys = ['nome','quantidade','unidade','fornecedor'];
                                        return <input key={i} type="text" placeholder={ph} value={novoMaterial[keys[i]]}
                                          onChange={(e) => setNovoMaterial({ ...novoMaterial, [keys[i]]: e.target.value })}
                                          className="px-3 py-1.5 text-xs bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:border-orange-500 focus:outline-none" />;
                                      })}
                                    </div>
                                    <button onClick={() => adicionarMaterial(servico.id)}
                                      className="px-3 py-1.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-xs rounded-lg">Salvar Material</button>
                                  </div>
                                )}
                                {servico.materiais && servico.materiais.length > 0 ? (
                                  <div className="overflow-x-auto rounded-xl border border-gray-800">
                                    <table className="w-full text-xs">
                                      <thead className="bg-gray-900 border-b border-gray-800">
                                        <tr>
                                          <th className="text-left p-2.5 font-semibold text-gray-400">Material</th>
                                          <th className="text-left p-2.5 font-semibold text-gray-400">Qtd.</th>
                                          <th className="text-left p-2.5 font-semibold text-gray-400">Fornecedor</th>
                                          {usuarioLogado?.tipo === 'prestador' && <th className="p-2.5"></th>}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {servico.materiais.map((material) => (
                                          <tr key={material.id} className="border-b border-gray-700/30 hover:bg-gray-800/40 transition-colors">
                                            <td className="p-2.5 text-gray-300">{material.nome}</td>
                                            <td className="p-2.5 text-gray-300">{material.quantidade} {material.unidade}</td>
                                            <td className="p-2.5 text-gray-400">{material.fornecedor || '-'}</td>
                                            {usuarioLogado?.tipo === 'prestador' && (
                                              <td className="p-2.5">
                                                <button onClick={() => removerMaterial(servico.id, material.id)} className="text-red-500/70 hover:text-red-400 transition-colors">
                                                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                  </svg>
                                                </button>
                                              </td>
                                            )}
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                ) : (
                                  <p className="text-xs text-gray-600 italic">Nenhum material cadastrado ainda</p>
                                )}
                              </div>

                              {/* Observações */}
                              <div>
                                <h4 className="text-xs font-semibold text-gray-300 uppercase tracking-wider flex items-center gap-1.5 mb-2.5">
                                  <svg className="w-3.5 h-3.5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                  </svg>
                                  Observações
                                </h4>
                                {usuarioLogado?.tipo === 'prestador' ? (
                                  <textarea value={servico.observacoes || ''} rows="3"
                                    onChange={(e) => atualizarObservacoes(servico.id, e.target.value)}
                                    placeholder="Adicione observações sobre este serviço..."
                                    className="w-full px-3 py-2 text-xs bg-gray-800 border border-gray-600 rounded-xl text-white placeholder-gray-500 focus:border-orange-500 focus:outline-none resize-none" />
                                ) : (
                                  <p className="text-xs text-gray-400 p-3 bg-gray-800/60 rounded-xl border border-gray-800">
                                    {servico.observacoes || 'Nenhuma observação adicionada'}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  )}
                </div>
              </div>
            </div>

            {/* Coluna lateral */}
            <div className="space-y-5">
              {/* Gráfico de custos */}
              <div className="bg-gray-900/80 rounded-2xl border border-gray-800 p-5">
                <h2 className="text-base font-medium text-white mb-4 flex items-center gap-2">
                  <span className="w-1 h-5 bg-orange-500 rounded-full inline-block"></span>
                  {usuarioLogado?.tipo === 'prestador' ? 'Controle de Custos' : 'Controle de Investimento'}
                </h2>
                <ResponsiveContainer width="100%" height={180}>
                  <PieChart>
                    <Pie data={dadosCustos} cx="50%" cy="50%" innerRadius={55} outerRadius={72} paddingAngle={4} dataKey="value">
                      {dadosCustos.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                      ))}
                    </Pie>
                    <Tooltip
                      formatter={(value) => `R$ ${value.toLocaleString('pt-BR')}`}
                      contentStyle={{ background: '#1f2937', border: '1px solid #374151', borderRadius: '12px', color: '#f9fafb', fontSize: '12px' }}
                    />
                  </PieChart>
                </ResponsiveContainer>
                <div className="mt-3 space-y-2.5">
                  {[
                    { label: 'Orçamento Total', value: obraSelecionada.orcamentoTotal, color: 'text-blue-400' },
                    { label: labelGasto, value: gastoExibido, color: 'text-green-400' },
                    { label: 'Restante', value: Math.max(0, obraSelecionada.orcamentoTotal - gastoExibido), color: 'text-amber-400' },
                  ].map(({ label, value, color }) => (
                    <div key={label} className="flex justify-between items-center">
                      <span className="text-xs text-gray-400 font-light">{label}</span>
                      <span className={`text-xs font-semibold ${color}`}>R$ {value.toLocaleString('pt-BR')}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Detalhes da obra */}
              <div className="bg-gray-900/80 rounded-2xl border border-gray-800 p-5">
                <h2 className="text-base font-medium text-white mb-4 flex items-center gap-2">
                  <span className="w-1 h-5 bg-orange-500 rounded-full inline-block"></span>
                  Detalhes da Obra
                </h2>
                <div className="space-y-3">
                  {[
                    { label: t('projectName'), value: obraSelecionada.nome },
                    { label: 'Cliente', value: obraSelecionada.cliente },
                    { label: 'Endereço', value: obraSelecionada.endereco },
                    { label: t('startDate'), value: new Date(obraSelecionada.inicio).toLocaleDateString('pt-BR') },
                    { label: t('completionForecast'), value: calcularDataConclusao(obraSelecionada) },
                  ].map(({ label, value }) => (
                    <div key={label} className="flex flex-col gap-0.5">
                      <p className="text-xs text-gray-500 font-light">{label}</p>
                      <p className="text-sm font-medium text-gray-200">{value}</p>
                    </div>
                  ))}
                  <div className="pt-1">
                    <p className="text-xs text-gray-500 font-light mb-1">Status</p>
                    <span className="inline-block px-3 py-1 bg-orange-500/15 text-orange-400 border border-orange-500/30 rounded-full text-xs font-medium">
                      Em Andamento
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <GanttChart obra={obraSelecionada} />
          </>
          )}
        </main>

        {/* Modal Confirmar Exclusão */}
        {confirmarExclusaoServico && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/70 " onClick={() => setConfirmarExclusaoServico(null)} />
            <div className="relative z-10 w-full max-w-sm bg-gray-900 border border-red-500/30 rounded-2xl shadow-xl overflow-hidden">
              <div className="px-6 py-6 text-center">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-red-500/15 border border-red-500/30 mb-4">
                  <svg className="w-7 h-7 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </div>
                <h2 className="text-base font-semibold text-white mb-1">Excluir Serviço</h2>
                <p className="text-sm text-gray-400 font-light">
                  Tem certeza que deseja excluir o serviço <span className="text-white font-medium">"{obraSelecionada.servicos.find(s => s.id === confirmarExclusaoServico)?.nome}"</span>? Esta ação não pode ser desfeita.
                </p>
              </div>
              <div className="flex gap-3 px-6 pb-5">
                <button onClick={() => setConfirmarExclusaoServico(null)}
                  className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-xl hover:border-gray-600 hover:text-white transition-all">
                  Cancelar
                </button>
                <button onClick={() => { removerServico(confirmarExclusaoServico); setConfirmarExclusaoServico(null); }}
                  className="flex-1 px-4 py-2.5 bg-red-500/20 border border-red-500/40 text-red-400 text-sm font-medium rounded-xl hover:bg-red-500/30 transition-all flex items-center justify-center gap-2">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                  Excluir
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Editar Serviço — somente Prestador */}
        {editandoServico && usuarioLogado?.tipo === 'prestador' && (() => {
          const venda  = parseFloat(servicoEmEdicao.valorVenda)           || 0;
          const custo  = parseFloat(servicoEmEdicao.valorCustoContratado) || 0;
          const pago   = parseFloat(servicoEmEdicao.valorPago)            || 0;
          const saldo  = Math.max(0, custo - pago);
          const margem = venda > 0 ? ((venda - custo) / venda * 100) : null;
          const corM   = margem === null ? '#64748b' : margem >= 20 ? '#22c55e' : margem >= 15 ? '#86efac' : margem >= 0 ? '#eab308' : '#ef4444';
          return (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/70 " onClick={() => setEditandoServico(null)} />
            <div className="relative z-10 w-full max-w-lg bg-gray-900 border border-gray-800 rounded-2xl shadow-xl overflow-hidden">

              {/* Header */}
              <div className="flex items-center justify-between px-6 py-5 border-b border-gray-800">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                  </div>
                  <div>
                    <h2 className="text-base font-semibold text-white">Editar Serviço</h2>
                    <p className="text-xs text-gray-400 font-light">Atualize os dados e valores financeiros</p>
                  </div>
                </div>
                <button onClick={() => setEditandoServico(null)} className="p-2 hover:bg-gray-800 rounded-xl transition-colors text-gray-400 hover:text-white">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* Campos */}
              <div className="px-6 py-5 space-y-5 max-h-[70vh] overflow-y-auto">

                {/* Identificação */}
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">Identificação</p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div className="sm:col-span-2">
                      <label className="block text-xs font-medium text-gray-400 mb-1.5">Nome do Serviço <span className="text-orange-500">*</span></label>
                      <input type="text" placeholder="Ex: Fundação"
                        value={servicoEmEdicao.nome}
                        onChange={e => setServicoEmEdicao({ ...servicoEmEdicao, nome: e.target.value })}
                        className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-orange-500 focus:outline-none transition-colors" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-400 mb-1.5">Duração (dias) <span className="text-orange-500">*</span></label>
                      <input type="number" placeholder="Ex: 15"
                        value={servicoEmEdicao.duracao}
                        onChange={e => setServicoEmEdicao({ ...servicoEmEdicao, duracao: e.target.value })}
                        className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-orange-500 focus:outline-none transition-colors" />
                    </div>
                  </div>
                </div>

                {/* Divisor */}
                <div className="border-t border-gray-800"/>

                {/* Valores Financeiros */}
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">Valores Financeiros</p>
                  <div className="space-y-3">

                    {/* Valor Vendido */}
                    <div>
                      <label className="block text-xs font-medium mb-1.5">
                        <span className="text-blue-400">●</span>{' '}
                        <span className="text-gray-300">Valor vendido ao cliente (R$)</span>
                      </label>
                      <input type="number" placeholder="Ex: 35000"
                        value={servicoEmEdicao.valorVenda}
                        onChange={e => setServicoEmEdicao({ ...servicoEmEdicao, valorVenda: e.target.value })}
                        className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-blue-500 focus:outline-none transition-colors" />
                      <p className="text-xs text-gray-600 mt-1">Receita desta etapa junto ao cliente</p>
                    </div>

                    {/* Custo Contratado */}
                    <div>
                      <label className="block text-xs font-medium mb-1.5">
                        <span className="text-amber-400">●</span>{' '}
                        <span className="text-gray-300">Valor contratado com o prestador (R$)</span>
                      </label>
                      <input type="number" placeholder="Ex: 28000"
                        value={servicoEmEdicao.valorCustoContratado}
                        onChange={e => setServicoEmEdicao({ ...servicoEmEdicao, valorCustoContratado: e.target.value })}
                        className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-amber-500 focus:outline-none transition-colors" />
                      <p className="text-xs text-gray-600 mt-1">Custo acordado com o prestador terceirizado</p>
                    </div>

                    {/* Valor Pago */}
                    <div>
                      <label className="block text-xs font-medium mb-1.5">
                        <span className="text-red-400">●</span>{' '}
                        <span className="text-gray-300">Valor já pago ao prestador (R$)</span>
                      </label>
                      <input type="number" placeholder="Ex: 14000"
                        value={servicoEmEdicao.valorPago}
                        onChange={e => setServicoEmEdicao({ ...servicoEmEdicao, valorPago: e.target.value })}
                        className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-red-500 focus:outline-none transition-colors" />
                      <p className="text-xs text-gray-600 mt-1">Desembolso real já realizado</p>
                    </div>
                  </div>
                </div>

                {/* Divisor */}
                <div className="border-t border-gray-800"/>

                {/* Prestador e Datas */}
                <div>
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">Prestador & Prazo</p>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="sm:col-span-1">
                      <label className="block text-xs font-medium mb-1.5">
                        <span className="text-orange-400">●</span>{' '}
                        <span className="text-gray-300">Prestador responsável</span>
                      </label>
                      <input type="text" placeholder="Ex: João Pedreiro"
                        value={servicoEmEdicao.nomePrestador}
                        onChange={e => setServicoEmEdicao({ ...servicoEmEdicao, nomePrestador: e.target.value })}
                        className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-orange-500 focus:outline-none transition-colors" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-400 mb-1.5">Data início acordada</label>
                      <input type="date"
                        value={servicoEmEdicao.dataInicioAcordada}
                        onChange={e => setServicoEmEdicao({ ...servicoEmEdicao, dataInicioAcordada: e.target.value })}
                        className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm focus:border-orange-500 focus:outline-none transition-colors" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-400 mb-1.5">Data entrega acordada</label>
                      <input type="date"
                        value={servicoEmEdicao.dataEntregaAcordada}
                        onChange={e => setServicoEmEdicao({ ...servicoEmEdicao, dataEntregaAcordada: e.target.value })}
                        className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm focus:border-orange-500 focus:outline-none transition-colors" />
                    </div>
                  </div>
                </div>

                {/* Preview cálculos em tempo real */}
                {(venda > 0 || custo > 0) && (
                  <div className="rounded-xl border p-4 space-y-2.5" style={{ borderColor: corM + '35', background: corM + '0d' }}>
                    <p className="text-xs font-semibold text-gray-400 mb-1">Prévia dos cálculos</p>
                    <div className="grid grid-cols-3 gap-3 text-xs">
                      <div className="text-center">
                        <p className="text-gray-500 mb-1">Saldo a pagar</p>
                        <p className="font-bold text-amber-300">
                          {saldo > 0 ? `R$ ${saldo.toLocaleString('pt-BR')}` : <span className="text-green-400">Quitado</span>}
                        </p>
                      </div>
                      <div className="text-center">
                        <p className="text-gray-500 mb-1">Margem</p>
                        <p className="font-bold" style={{ color: corM }}>
                          {margem !== null ? margem.toFixed(2) + '%' : '—'}
                        </p>
                      </div>
                      <div className="text-center">
                        <p className="text-gray-500 mb-1">Status</p>
                        <p className="font-semibold text-xs" style={{ color: corM }}>
                          {margem === null ? '—' : margem >= 20 ? 'Saudável' : margem >= 15 ? 'Aceitável' : margem >= 0 ? 'Baixa' : 'Negativa'}
                        </p>
                      </div>
                    </div>
                    {margem !== null && (
                      <div className="w-full bg-gray-700/50 rounded-full h-1.5 mt-1">
                        <div className="h-1.5 rounded-full transition-all duration-300"
                          style={{ width: `${Math.min(Math.max(margem, 0), 100)}%`, background: corM }}/>
                      </div>
                    )}
                  </div>
                )}

              </div>

              {/* Footer */}
              <div className="flex gap-3 px-6 py-4 border-t border-gray-800">
                <button onClick={() => setEditandoServico(null)}
                  className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-xl hover:border-gray-600 hover:text-white transition-all">
                  Cancelar
                </button>
                <button onClick={salvarEdicaoServico}
                  disabled={!servicoEmEdicao.nome || !servicoEmEdicao.duracao}
                  className="flex-1 px-4 py-2.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-medium rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-2">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  Salvar Alterações
                </button>
              </div>
            </div>
          </div>
          );
        })()}


        {/* Modal — Nova Atualização */}
        {modalNovaAtualizacao && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/80 " onClick={() => { setModalNovaAtualizacao(false); setFotosNovaAtualizacao([]); }}/>
            <div className="relative z-10 w-full max-w-2xl bg-gray-900 border border-orange-500/25 rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">

              {/* Header */}
              <div className="flex items-center justify-between px-6 py-5 border-b border-gray-800 flex-shrink-0">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-br from-orange-500 to-amber-500 rounded-xl">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4"/>
                    </svg>
                  </div>
                  <div>
                    <h2 className="text-base font-semibold text-white">{t('newUpdate')}</h2>
                    <p className="text-xs text-gray-400 font-light">Publique o progresso desta etapa da obra</p>
                  </div>
                </div>
                <button
                  onClick={() => { setModalNovaAtualizacao(false); setFotosNovaAtualizacao([]); }}
                  className="p-2 hover:bg-gray-800 rounded-xl transition-colors text-gray-400 hover:text-white"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
                  </svg>
                </button>
              </div>

              {/* Body */}
              <div className="px-6 py-5 space-y-4 overflow-y-auto flex-1">
                {/* Título */}
                <div>
                  <label className="block text-xs font-medium text-gray-400 mb-1.5">
                    Título <span className="text-orange-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Ex: Concretagem dos pilares concluída"
                    value={novaAtualizacao.titulo}
                    onChange={e => setNovaAtualizacao(p => ({ ...p, titulo: e.target.value }))}
                    className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-orange-500 focus:outline-none transition-colors"
                  />
                </div>

                {/* Descrição */}
                <div>
                  <label className="block text-xs font-medium text-gray-400 mb-1.5">
                    {t('whatWasDone')}
                  </label>
                  <textarea
                    rows={4}
                    placeholder="Descreva o que foi realizado neste período..."
                    value={novaAtualizacao.descricao}
                    onChange={e => setNovaAtualizacao(p => ({ ...p, descricao: e.target.value }))}
                    className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-orange-500 focus:outline-none transition-colors resize-none"
                  />
                </div>

                {/* {t('nextSteps')} */}
                <div>
                  <label className="block text-xs font-medium text-gray-400 mb-1.5">
                    {t('nextSteps')}
                  </label>
                  <textarea
                    rows={3}
                    placeholder="O que será executado na próxima etapa..."
                    value={novaAtualizacao.proximos_passos}
                    onChange={e => setNovaAtualizacao(p => ({ ...p, proximos_passos: e.target.value }))}
                    className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-orange-500 focus:outline-none transition-colors resize-none"
                  />
                </div>

                {/* Upload de fotos */}
                <div>
                  <label className="block text-xs font-medium text-gray-400 mb-1.5">
                    Fotos do progresso
                  </label>
                  <label className="flex flex-col items-center justify-center w-full h-28 border-2 border-dashed border-gray-700 rounded-xl cursor-pointer hover:border-orange-500/50 hover:bg-orange-500/5 transition-all group">
                    <svg className="w-8 h-8 text-gray-600 group-hover:text-orange-400 transition-colors mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                    </svg>
                    <p className="text-xs text-gray-500 group-hover:text-gray-400">Clique para selecionar ou arraste as fotos</p>
                    <p className="text-xs text-gray-600 mt-0.5">PNG, JPG, WEBP — múltiplas fotos</p>
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      className="hidden"
                      onChange={e => {
                        const files = Array.from(e.target.files || []);
                        setFotosNovaAtualizacao(prev => [...prev, ...files]);
                      }}
                    />
                  </label>

                  {/* Preview das fotos selecionadas */}
                  {fotosNovaAtualizacao.length > 0 && (
                    <div className="mt-3 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
                      {fotosNovaAtualizacao.map((file, fi) => (
                        <div key={fi} className="relative group aspect-square rounded-lg overflow-hidden bg-gray-700/50">
                          <img
                            src={URL.createObjectURL(file)}
                            alt={file.name}
                            className="w-full h-full object-cover"
                          />
                          <button
                            onClick={() => setFotosNovaAtualizacao(prev => prev.filter((_, i) => i !== fi))}
                            className="absolute top-1 right-1 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity text-xs"
                          >
                            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12"/>
                            </svg>
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Footer */}
              <div className="flex gap-3 px-6 py-4 border-t border-gray-800 flex-shrink-0">
                <button
                  onClick={() => { setModalNovaAtualizacao(false); setFotosNovaAtualizacao([]); }}
                  className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-xl hover:border-gray-600 hover:text-white transition-all"
                >
                  Cancelar
                </button>
                <button
                  onClick={salvarAtualizacao}
                  disabled={!novaAtualizacao.titulo.trim() || salvandoAtualizacao}
                  className="flex-1 px-4 py-2.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-medium rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  {salvandoAtualizacao ? (
                    <><div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"/> Publicando...</>
                  ) : (
                    <><svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"/></svg> {t('publish')}</>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal — {t('confirmDelete')} de atualização */}
        {excluindoAtualizacao && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/70 " onClick={() => setExcluindoAtualizacao(null)}/>
            <div className="relative z-10 w-full max-w-sm bg-gray-900 border border-red-500/30 rounded-2xl shadow-2xl overflow-hidden">
              <div className="px-6 py-6 text-center">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-red-500/15 border border-red-500/30 mb-4">
                  <svg className="w-7 h-7 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">{t('deleteUpdate')}?</h3>
                <p className="text-sm text-gray-400">As fotos e informações desta atualização serão removidas permanentemente.</p>
              </div>
              <div className="flex gap-3 px-6 pb-6">
                <button onClick={() => setExcluindoAtualizacao(null)}
                  className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-xl hover:border-gray-600 transition-all">
                  Cancelar
                </button>
                <button onClick={() => excluirAtualizacao(excluindoAtualizacao)}
                  className="flex-1 px-4 py-2.5 bg-red-500 text-white text-sm font-medium rounded-xl hover:bg-red-600 transition-all">
                  Excluir
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal — Foto ampliada da timeline */}
        {fotoTimelineAmpliada && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90 "
            onClick={() => setFotoTimelineAmpliada(null)}>
            <div className="relative max-w-5xl w-full" onClick={e => e.stopPropagation()}>
              <button
                onClick={() => setFotoTimelineAmpliada(null)}
                className="absolute -top-12 right-0 p-2 text-gray-400 hover:text-white transition-colors"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
                </svg>
              </button>
              <img
                src={fotoTimelineAmpliada.url}
                alt={fotoTimelineAmpliada.titulo}
                className="w-full max-h-[80vh] object-contain rounded-xl shadow-2xl"
              />
              <div className="text-center mt-3">
                <p className="text-white text-sm font-medium">{fotoTimelineAmpliada.titulo}</p>
                <p className="text-gray-500 text-xs mt-0.5">Foto {fotoTimelineAmpliada.idx} de {fotoTimelineAmpliada.total}</p>
              </div>
            </div>
          </div>
        )}


        {/* Modal — Financeiro por Etapa — somente Prestador */}
        {editandoFinanceiroServico && usuarioLogado?.tipo === 'prestador' && (() => {
          const serv = obraSelecionada?.servicos?.find(s => s.id === editandoFinanceiroServico);
          const venda  = parseFloat(dadosFinanceiroServico.valorVenda)           || 0;
          const custo  = parseFloat(dadosFinanceiroServico.valorCustoContratado) || 0;
          const pago   = parseFloat(dadosFinanceiroServico.valorPago)            || 0;
          const saldo  = Math.max(0, custo - pago);
          const margem = venda > 0 ? ((venda - custo) / venda) * 100 : null;
          const corM   = margem === null ? '#64748b' : margem >= 20 ? '#22c55e' : margem >= 15 ? '#86efac' : margem >= 0 ? '#eab308' : '#ef4444';
          return (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
              <div className="absolute inset-0 bg-black/80 " onClick={() => setEditandoFinanceiroServico(null)}/>
              <div className="relative z-10 w-full max-w-lg bg-gray-900 border border-orange-500/25 rounded-2xl shadow-2xl overflow-hidden">

                <div className="flex items-center justify-between px-6 py-5 border-b border-gray-800">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-gradient-to-br from-orange-500 to-amber-500 rounded-xl">
                      <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                    </div>
                    <div>
                      <h2 className="text-base font-semibold text-white">Financeiro da Etapa</h2>
                      <p className="text-xs text-orange-400 font-medium truncate max-w-[240px]">{serv?.nome}</p>
                    </div>
                  </div>
                  <button onClick={() => setEditandoFinanceiroServico(null)} className="p-2 hover:bg-gray-800 rounded-xl text-gray-400 hover:text-white transition-colors">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/></svg>
                  </button>
                </div>

                <div className="px-6 py-5 space-y-4">
                  <div className="grid grid-cols-1 gap-3">
                    {/* Valor Venda */}
                    <div>
                      <label className="block text-xs font-medium mb-1.5">
                        <span className="text-blue-400">●</span> <span className="text-gray-300">Valor vendido ao cliente (R$)</span>
                      </label>
                      <input type="number" placeholder="Ex: 35000"
                        value={dadosFinanceiroServico.valorVenda}
                        onChange={e => setDadosFinanceiroServico(p => ({ ...p, valorVenda: e.target.value }))}
                        className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-blue-500 focus:outline-none transition-colors"
                      />
                    </div>
                    {/* Custo Contratado */}
                    <div>
                      <label className="block text-xs font-medium mb-1.5">
                        <span className="text-amber-400">●</span> <span className="text-gray-300">Valor contratado com prestador (R$)</span>
                      </label>
                      <input type="number" placeholder="Ex: 28000"
                        value={dadosFinanceiroServico.valorCustoContratado}
                        onChange={e => setDadosFinanceiroServico(p => ({ ...p, valorCustoContratado: e.target.value }))}
                        className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-amber-500 focus:outline-none transition-colors"
                      />
                    </div>
                    {/* Valor Pago */}
                    <div>
                      <label className="block text-xs font-medium mb-1.5">
                        <span className="text-red-400">●</span> <span className="text-gray-300">Valor já pago ao prestador (R$)</span>
                      </label>
                      <input type="number" placeholder="Ex: 14000"
                        value={dadosFinanceiroServico.valorPago}
                        onChange={e => setDadosFinanceiroServico(p => ({ ...p, valorPago: e.target.value }))}
                        className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-red-500 focus:outline-none transition-colors"
                      />
                    </div>
                  </div>

                  {/* Preview calculado */}
                  {(venda > 0 || custo > 0) && (
                    <div className="bg-gray-800/60 rounded-xl p-4 border border-gray-800 space-y-2">
                      <p className="text-xs text-gray-400 font-medium mb-2">Prévia dos cálculos</p>
                      <div className="grid grid-cols-2 gap-2 text-xs">
                        <div className="flex justify-between items-center">
                          <span className="text-gray-500">Saldo a pagar</span>
                          <span className="text-amber-300 font-semibold">R$ {saldo.toLocaleString('pt-BR', {minimumFractionDigits:2})}</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-gray-500">Margem etapa</span>
                          <span className="font-bold" style={{ color: corM }}>
                            {margem !== null ? margem.toFixed(2) + '%' : '—'}
                          </span>
                        </div>
                      </div>
                      {margem !== null && (
                        <div className="flex items-center gap-2 mt-2 pt-2 border-t border-gray-800">
                          <div className="w-full bg-gray-700/50 rounded-full h-2">
                            <div className="h-2 rounded-full transition-all" style={{ width: `${Math.min(Math.max(margem, 0), 100)}%`, background: corM }}/>
                          </div>
                          <span className="text-xs font-semibold whitespace-nowrap" style={{ color: corM }}>
                            {margem >= 20 ? 'Saudável' : margem >= 15 ? 'Aceitável' : margem >= 0 ? 'Baixa' : 'Negativa'}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="flex gap-3 px-6 py-4 border-t border-gray-800">
                  <button onClick={() => setEditandoFinanceiroServico(null)}
                    className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-xl hover:border-gray-600 transition-all">
                    Cancelar
                  </button>
                  <button onClick={salvarFinanceiroServico}
                    className="flex-1 px-4 py-2.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-medium rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all flex items-center justify-center gap-2">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"/></svg>
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          );
        })()}

        {/* Modal Editar Recebimentos */}
        {editandoRecebimento && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/70 " onClick={() => setEditandoRecebimento(false)} />
            <div className="relative z-10 w-full max-w-md bg-gray-900 border border-blue-500/30 rounded-2xl shadow-2xl overflow-hidden">
              <div className="flex items-center justify-between px-6 py-5 border-b border-gray-800">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h2 className="text-base font-semibold text-white">Editar Recebimentos</h2>
                    <p className="text-xs text-gray-400 font-light">Atualize o valor total já recebido do cliente</p>
                  </div>
                </div>
                <button onClick={() => setEditandoRecebimento(false)} className="p-2 hover:bg-gray-800 rounded-xl transition-colors text-gray-400 hover:text-white">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="px-6 py-5 space-y-4">
                {/* Referências rápidas */}
                <div className="grid grid-cols-2 gap-3 text-xs">
                  <div className="bg-gray-800/60 rounded-xl p-3 border border-gray-800">
                    <p className="text-gray-500 mb-1">{t('contractValue')}</p>
                    <p className="text-sm font-semibold text-white">R$ {(obraSelecionada?.valorContrato || 0).toLocaleString('pt-BR')}</p>
                  </div>
                  <div className="bg-gray-800/60 rounded-xl p-3 border border-gray-800">
                    <p className="text-gray-500 mb-1">Executado Físico</p>
                    <p className="text-sm font-semibold text-orange-400">{calcularProgresso(obraSelecionada)}%</p>
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-medium text-gray-400 mb-1.5">
                    Valor Total Recebido do Cliente (R$) <span className="text-blue-400">*</span>
                  </label>
                  <input
                    type="number"
                    placeholder="Ex: 150000"
                    value={valorRecebidoInput}
                    onChange={e => setValorRecebidoInput(e.target.value)}
                    className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-blue-500 focus:outline-none transition-colors"
                  />
                  <p className="text-xs text-gray-600 mt-1">Soma de todos os pagamentos já recebidos</p>
                </div>

                {/* Prévia do cálculo */}
                {valorRecebidoInput && obraSelecionada?.valorContrato > 0 && (() => {
                  const pctRec = (parseFloat(valorRecebidoInput) / obraSelecionada.valorContrato) * 100;
                  const pctExec = calcularProgresso(obraSelecionada);
                  const dif = pctRec - pctExec;
                  const cor = dif >= -5 ? '#22c55e' : dif >= -15 ? '#eab308' : '#ef4444';
                  const emoji = dif >= -5 ? '🟢' : dif >= -15 ? '🟡' : '🔴';
                  const label = dif >= -5 ? 'Equilibrado' : dif >= -15 ? 'Atenção' : 'Financiando Cliente';
                  return (
                    <div className="bg-gray-800/60 rounded-xl p-4 border border-gray-800">
                      <p className="text-xs text-gray-400 font-medium mb-3">Prévia do diagnóstico</p>
                      <div className="grid grid-cols-3 gap-2 text-center text-xs">
                        <div>
                          <p className="text-gray-500">Recebido</p>
                          <p className="text-blue-400 font-bold text-base">{pctRec.toFixed(1)}%</p>
                        </div>
                        <div>
                          <p className="text-gray-500">Executado</p>
                          <p className="text-orange-400 font-bold text-base">{pctExec.toFixed(0)}%</p>
                        </div>
                        <div>
                          <p className="text-gray-500">Diferença</p>
                          <p className="font-bold text-base" style={{ color: cor }}>{dif >= 0 ? '+' : ''}{dif.toFixed(1)}%</p>
                        </div>
                      </div>
                      <div className="mt-3 flex items-center justify-center gap-2 py-2 rounded-lg" style={{ background: cor + '18' }}>
                        <span>{emoji}</span>
                        <span className="text-sm font-semibold" style={{ color: cor }}>{label}</span>
                      </div>
                    </div>
                  );
                })()}
              </div>
              <div className="flex gap-3 px-6 py-4 border-t border-gray-800">
                <button onClick={() => setEditandoRecebimento(false)}
                  className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-xl hover:border-gray-600 hover:text-white transition-all">
                  Cancelar
                </button>
                <button onClick={salvarRecebimento}
                  className="flex-1 px-4 py-2.5 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-sm font-medium rounded-xl hover:shadow-lg hover:shadow-blue-500/30 transition-all flex items-center justify-center gap-2">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  Salvar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Editar Margem — somente Prestador */}
        {editandoMargem && usuarioLogado?.tipo === 'prestador' && (() => {
          const vc = parseFloat(dadosMargem.valorContrato)  || 0;
          const vr = parseFloat(dadosMargem.valorRecebido)  || 0;
          const pctRec = vc > 0 && vr > 0 ? Math.min((vr / vc) * 100, 100) : null;
          return (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/70 " onClick={() => setEditandoMargem(false)} />
            <div className="relative z-10 w-full max-w-md bg-gray-900 border border-orange-500/30 rounded-2xl shadow-2xl overflow-hidden">

              <div className="flex items-center justify-between px-6 py-5 border-b border-gray-800">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-br from-orange-500 to-amber-500 rounded-xl">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                  </div>
                  <div>
                    <h2 className="text-base font-semibold text-white">Dados Financeiros da Obra</h2>
                    <p className="text-xs text-gray-400 font-light">Configure os valores globais do contrato</p>
                  </div>
                </div>
                <button onClick={() => setEditandoMargem(false)} className="p-2 hover:bg-gray-800 rounded-xl transition-colors text-gray-400 hover:text-white">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                </button>
              </div>

              <div className="px-6 py-5 space-y-4">

                {/* {t('contractValue')} */}
                <div>
                  <label className="block text-xs font-medium mb-1.5">
                    <span className="text-blue-400">●</span>{' '}
                    <span className="text-gray-300">{t('contractValue')} com o Cliente (R$)</span>{' '}
                    <span className="text-orange-500">*</span>
                  </label>
                  <input type="number" placeholder="Ex: 500000"
                    value={dadosMargem.valorContrato}
                    onChange={e => setDadosMargem({ ...dadosMargem, valorContrato: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-blue-500 focus:outline-none transition-colors"
                  />
                  <p className="text-xs text-gray-600 mt-1">Valor total acordado com o cliente</p>
                </div>

                {/* Valor Recebido do Cliente */}
                <div>
                  <label className="block text-xs font-medium mb-1.5">
                    <span className="text-green-400">●</span>{' '}
                    <span className="text-gray-300">Valor Já Recebido do Cliente (R$)</span>
                  </label>
                  <input type="number" placeholder="Ex: 150000"
                    value={dadosMargem.valorRecebido}
                    onChange={e => setDadosMargem({ ...dadosMargem, valorRecebido: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-green-500 focus:outline-none transition-colors"
                  />
                  <p className="text-xs text-gray-600 mt-1">Total efetivamente recebido até o momento</p>
                </div>

                {/* Meta de Margem */}
                <div>
                  <label className="block text-xs font-medium mb-1.5">
                    <span className="text-purple-400">●</span>{' '}
                    <span className="text-gray-300">Meta de Margem da Obra (%)</span>
                  </label>
                  <input type="number" placeholder="Ex: 20" min="0" max="100"
                    value={dadosMargem.metaMargem}
                    onChange={e => setDadosMargem({ ...dadosMargem, metaMargem: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-800 border border-gray-700 rounded-xl text-white text-sm placeholder-gray-600 focus:border-purple-500 focus:outline-none transition-colors"
                  />
                  <p className="text-xs text-gray-600 mt-1">Percentual mínimo de margem esperado para esta obra</p>
                </div>

                {/* Preview recebimento */}
                {pctRec !== null && (
                  <div className="bg-gray-800/60 rounded-xl p-4 border border-gray-800 space-y-2">
                    <div className="flex justify-between items-center text-xs">
                      <span className="text-gray-400">Recebimento do contrato</span>
                      <span className="text-green-400 font-bold">{pctRec.toFixed(1)}%</span>
                    </div>
                    <div className="w-full bg-gray-700/60 rounded-full h-2 overflow-hidden">
                      <div className="h-2 rounded-full bg-gradient-to-r from-green-500 to-emerald-400 transition-all duration-500"
                        style={{ width: `${pctRec}%` }}/>
                    </div>
                    <div className="flex justify-between text-xs text-gray-500">
                      <span>Recebido: <span className="text-green-400">R$ {vr.toLocaleString('pt-BR')}</span></span>
                      <span>Falta: <span className="text-amber-400">R$ {Math.max(0, vc - vr).toLocaleString('pt-BR')}</span></span>
                    </div>
                  </div>
                )}

                {/* Info */}
                <div className="bg-orange-500/08 rounded-xl p-3.5 border border-orange-500/20">
                  <p className="text-xs text-orange-400 font-medium mb-1">ℹ Os custos dos prestadores</p>
                  <p className="text-xs text-gray-500 leading-relaxed">
                    São configurados individualmente em cada etapa (botão <span className="text-orange-400">✎</span> na tabela de Margem), com valor contratado e valor já pago.
                  </p>
                </div>
              </div>

              <div className="flex gap-3 px-6 py-4 border-t border-gray-800">
                <button onClick={() => setEditandoMargem(false)}
                  className="flex-1 px-4 py-2.5 bg-gray-800 border border-gray-700 text-gray-300 text-sm rounded-xl hover:border-gray-600 hover:text-white transition-all">
                  Cancelar
                </button>
                <button onClick={salvarMargem}
                  disabled={!dadosMargem.valorContrato}
                  className="flex-1 px-4 py-2.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-medium rounded-xl hover:from-orange-600 hover:to-amber-600 transition-all disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-2">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  Salvar
                </button>
              </div>
            </div>
          </div>
          );
        })()}
      </div>
    );
  }


  return null;
}